export const TRANSLATIONS = {
      en: {
        "Accessibility": "Accessibility",
        "Accessibility Options": "Accessibility Options",
        "Accessibility Menu": "Accessibility Menu",
        "Reset settings": "Reset settings",
        "Reset All Settings": "Reset All Settings",
        "Close": "Close",
        "Content Adjustments": "Content Adjustments",
        "Adjust Font Size": "Adjust Font Size",
        "Highlight Title": "Highlight Title",
        "Highlight Links": "Highlight Links",
        "Readable Font": "Readable Font",
        "Color Adjustments": "Color Adjustments",
        "Invert Colors": "Invert Colors",
        "Light Contrast": "Light Contrast",
        "Dark Contrast": "Dark Contrast",
        "High Contrast": "High Contrast",
        "High Saturation": "High Saturation",
        "Low Saturation": "Low Saturation",
        "Monochrome": "Monochrome",
        "Tools": "Tools",
        "Reading Guide": "Reading Guide",
        "Stop Animations": "Stop Animations",
        "Big Cursor": "Big Cursor",
        "Increase Font Size": "Increase Font Size",
        "Decrease Font Size": "Decrease Font Size",
        "Letter Spacing": "Letter Spacing",
        "Line Height": "Line Height",
        "Font Weight": "Font Weight",
        "Dyslexia Font": "Dyslexia Font",
        "Legible Font": "Legible Font",
        "Font Size": "Font Size",
        "Language": "Language",
        "All Languages": "All Languages",
        "Search language": "Search language",
        "Open Accessibility Menu": "Open Accessibility Menu",
        "Open accessibility menu": "Open accessibility menu",
        "Hide Images": "Hide Images",
        "Skip to accessibility menu": "Skip to accessibility menu",
        "Accessibility Report": "Accessibility Report",
        "Run Accessibility Check": "Run Accessibility Check",
        "Loading...": "Loading...",
        "Analyzing page...": "Analyzing page...",
        "Critical": "Critical",
        "Serious": "Serious",
        "Moderate": "Moderate",
        "Minor": "Minor",
        "Violations Found": "Violations Found",
        "No Issues Found": "No Issues Found",
        "Element": "Element",
        "Issue": "Issue",
        "How to Fix": "How to Fix",
        "Close Report": "Close Report",
        "Passed Tests": "Passed Tests",
        "Items Need Review": "Items Need Review",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Text to Speech On",
        "Text to Speech Off": "Text to Speech Off",
        "Simplify Layout": "Simplify Layout",
        "Speech": "Speech",
        "Text": "Text",
        "Color & Contrast": "Color & Contrast",
        "Reading Aids": "Reading Aids",
        "Interaction": "Interaction",
        "Contrast": "Contrast",
        "Saturation": "Saturation",
        "Light": "Light",
        "Dark": "Dark",
        "High": "High",
        "Low": "Low",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Loading voice...": "Loading voice...",
        "Reading...": "Reading...",
        "Profiles": "Profiles",
        "Seizure Safe": "Seizure Safe",
        "Vision Impaired": "Vision Impaired",
        "ADHD Friendly": "ADHD Friendly",
        "Dyslexia Friendly": "Dyslexia Friendly",
        "On": "On",
        "Off": "Off",
        "Mute Sounds": "Mute Sounds",
        "Page Structure": "Page Structure",
        "Text Magnifier": "Text Magnifier",
        "Headings": "Headings",
        "Landmarks": "Landmarks",
        "Links": "Links",
        "No items found": "No items found",
        "Settings reset": "Settings reset",
      },
      pt: {
        "Accessibility": "Acessibilidade",
        "Accessibility Options": "Opções de acessibilidade",
        "Accessibility Menu": "Menu de Acessibilidade",
        "Reset settings": "Redefinir configurações",
        "Reset All Settings": "Redefinir todas as configurações",
        "Close": "Fechar",
        "Content Adjustments": "Ajustes de Conteúdo",
        "Adjust Font Size": "Ajustar Tamanho da Fonte",
        "Highlight Title": "Destacar Títulos",
        "Highlight Links": "Destacar Links",
        "Readable Font": "Fonte Legível",
        "Color Adjustments": "Ajustes de Cor",
        "Invert Colors": "Inverter Cores",
        "Light Contrast": "Contraste Claro",
        "Dark Contrast": "Contraste Escuro",
        "High Contrast": "Alto Contraste",
        "High Saturation": "Alta Saturação",
        "Low Saturation": "Baixa Saturação",
        "Monochrome": "Monocromático",
        "Tools": "Ferramentas",
        "Reading Guide": "Guia de Leitura",
        "Stop Animations": "Parar Animações",
        "Big Cursor": "Cursor Grande",
        "Increase Font Size": "Aumentar Tamanho da Fonte",
        "Decrease Font Size": "Diminuir Tamanho da Fonte",
        "Letter Spacing": "Espaçamento entre Letras",
        "Line Height": "Altura da Linha",
        "Font Weight": "Peso da Fonte",
        "Dyslexia Font": "Fonte para Dislexia",
        "Legible Font": "Fonte Legível",
        "Font Size": "Tamanho da Fonte",
        "Language": "Idioma",
        "All Languages": "Todos os Idiomas",
        "Search language": "Buscar idioma",
        "Open Accessibility Menu": "Abrir Menu de Acessibilidade",
        "Open accessibility menu": "Abrir menu de acessibilidade",
        "Hide Images": "Ocultar Imagens",
        "Skip to accessibility menu": "Ir para o menu de acessibilidade",
        "Accessibility Report": "Relatório de Acessibilidade",
        "Run Accessibility Check": "Executar Verificação de Acessibilidade",
        "Loading...": "Carregando...",
        "Analyzing page...": "Analisando página...",
        "Critical": "Crítico",
        "Serious": "Sério",
        "Moderate": "Moderado",
        "Minor": "Leve",
        "Violations Found": "Violações Encontradas",
        "No Issues Found": "Nenhum Problema Encontrado",
        "Element": "Elemento",
        "Issue": "Problema",
        "How to Fix": "Como Corrigir",
        "Close Report": "Fechar Relatório",
        "Passed Tests": "Testes Aprovados",
        "Items Need Review": "Itens Precisam de Revisão",
        "Annotations": "Anotações",
        "Text to Speech": "Texto para Fala",
        "Text to Speech On": "Texto para Fala Ativado",
        "Text to Speech Off": "Texto para Fala Desativado",
        "Simplify Layout": "Simplificar Layout",
        "Speech": "Fala",
        "Text": "Texto",
        "Color & Contrast": "Cor e Contraste",
        "Reading Aids": "Ajudas de Leitura",
        "Interaction": "Interação",
        "Contrast": "Contraste",
        "Saturation": "Saturação",
        "Light": "Claro",
        "Dark": "Escuro",
        "High": "Alto",
        "Low": "Baixo",
        "Play": "Reproduzir",
        "Pause": "Pausar",
        "Stop": "Parar",
        "Loading voice...": "Carregando voz...",
        "Reading...": "Lendo...",
        "Profiles": "Perfis",
        "Seizure Safe": "Seguro para Epilepsia",
        "Vision Impaired": "Deficiência Visual",
        "ADHD Friendly": "Adaptado para TDAH",
        "Dyslexia Friendly": "Adaptado para Dislexia",
        "On": "Ativado",
        "Off": "Desativado",
        "Mute Sounds": "Silenciar Sons",
        "Page Structure": "Estrutura da Página",
        "Text Magnifier": "Lupa de Texto",
        "Headings": "Títulos",
        "Landmarks": "Pontos de Referência",
        "Links": "Links",
        "No items found": "Nenhum item encontrado",
        "Settings reset": "Configurações redefinidas",
      },
      it: {
        "Accessibility": "Accessibilità",
        "Accessibility Options": "Opzioni di accessibilità",
        "Accessibility Menu": "Menu Accessibilità",
        "Reset settings": "Ripristina impostazioni",
        "Reset All Settings": "Ripristina tutte le impostazioni",
        "Close": "Chiudi",
        "Content Adjustments": "Regolazioni Contenuto",
        "Adjust Font Size": "Regola Dimensione Font",
        "Highlight Title": "Evidenzia Titoli",
        "Highlight Links": "Evidenzia Link",
        "Readable Font": "Font Leggibile",
        "Color Adjustments": "Regolazioni Colore",
        "Invert Colors": "Inverti Colori",
        "Light Contrast": "Contrasto Chiaro",
        "Dark Contrast": "Contrasto Scuro",
        "High Contrast": "Alto Contrasto",
        "High Saturation": "Alta Saturazione",
        "Low Saturation": "Bassa Saturazione",
        "Monochrome": "Monocromatico",
        "Tools": "Strumenti",
        "Reading Guide": "Guida di Lettura",
        "Stop Animations": "Ferma Animazioni",
        "Big Cursor": "Cursore Grande",
        "Increase Font Size": "Aumenta Dimensione Font",
        "Decrease Font Size": "Diminuisci Dimensione Font",
        "Letter Spacing": "Spaziatura Lettere",
        "Line Height": "Altezza Riga",
        "Font Weight": "Grassetto",
        "Dyslexia Font": "Font Dislessia",
        "Legible Font": "Carattere Leggibile",
        "Font Size": "Dimensione Font",
        "Language": "Lingua",
        "All Languages": "Tutte le Lingue",
        "Search language": "Cerca lingua",
        "Open Accessibility Menu": "Apri Menu Accessibilità",
        "Open accessibility menu": "Apri menu accessibilità",
        "Hide Images": "Nascondi Immagini",
        "Skip to accessibility menu": "Vai al menu accessibilità",
        "Accessibility Report": "Report Accessibilità",
        "Run Accessibility Check": "Esegui Controllo Accessibilità",
        "Loading...": "Caricamento...",
        "Analyzing page...": "Analisi pagina...",
        "Critical": "Critico",
        "Serious": "Grave",
        "Moderate": "Moderato",
        "Minor": "Minore",
        "Violations Found": "Violazioni Trovate",
        "No Issues Found": "Nessun Problema Trovato",
        "Element": "Elemento",
        "Issue": "Problema",
        "How to Fix": "Come Risolvere",
        "Close Report": "Chiudi Report",
        "Passed Tests": "Test Superati",
        "Items Need Review": "Elementi da Rivedere",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Sintesi Vocale Attiva",
        "Text to Speech Off": "Sintesi Vocale Disattiva",
        "Simplify Layout": "Simplify Layout",
        "Speech": "Voce",
        "Text": "Testo",
        "Color & Contrast": "Colore e Contrasto",
        "Reading Aids": "Aiuti alla Lettura",
        "Interaction": "Interazione",
        "Contrast": "Contrasto",
        "Saturation": "Saturazione",
        "Light": "Chiaro",
        "Dark": "Scuro",
        "High": "Alta",
        "Low": "Bassa",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Loading voice...": "Caricamento voce...",
        "Reading...": "Reading...",
        "Profiles": "Profili",
        "Seizure Safe": "Sicuro per Epilessia",
        "Vision Impaired": "Ipovisione",
        "ADHD Friendly": "Adatto per ADHD",
        "Dyslexia Friendly": "Adatto per Dislessia",
        "On": "Attivato",
        "Off": "Disattivato",
        "Mute Sounds": "Disattiva Suoni",
        "Page Structure": "Struttura della Pagina",
        "Text Magnifier": "Lente d'Ingrandimento Testo",
        "Headings": "Intestazioni",
        "Landmarks": "Punti di Riferimento",
        "Links": "Link",
        "No items found": "Nessun elemento trovato",
        "Settings reset": "Impostazioni ripristinate",
      },
      fr: {
        "Accessibility": "Accessibilité",
        "Accessibility Options": "Options d'accessibilité",
        "Accessibility Menu": "Menu Accessibilité",
        "Reset settings": "Réinitialiser les paramètres",
        "Reset All Settings": "Réinitialiser tous les paramètres",
        "Close": "Fermer",
        "Content Adjustments": "Ajustements du Contenu",
        "Adjust Font Size": "Ajuster la Taille de Police",
        "Highlight Title": "Surligner les Titres",
        "Highlight Links": "Surligner les Liens",
        "Readable Font": "Police Lisible",
        "Color Adjustments": "Ajustements des Couleurs",
        "Invert Colors": "Inverser les Couleurs",
        "Light Contrast": "Contraste Clair",
        "Dark Contrast": "Contraste Sombre",
        "High Contrast": "Contraste Élevé",
        "High Saturation": "Saturation Élevée",
        "Low Saturation": "Saturation Faible",
        "Monochrome": "Monochrome",
        "Tools": "Outils",
        "Reading Guide": "Guide de Lecture",
        "Stop Animations": "Arrêter les Animations",
        "Big Cursor": "Grand Curseur",
        "Increase Font Size": "Augmenter la Taille de Police",
        "Decrease Font Size": "Diminuer la Taille de Police",
        "Letter Spacing": "Espacement des Lettres",
        "Line Height": "Hauteur de Ligne",
        "Font Weight": "Graisse de Police",
        "Dyslexia Font": "Police Dyslexie",
        "Legible Font": "Police Lisible",
        "Font Size": "Taille de Police",
        "Language": "Langue",
        "All Languages": "Toutes les Langues",
        "Search language": "Rechercher une langue",
        "Open Accessibility Menu": "Ouvrir le Menu Accessibilité",
        "Open accessibility menu": "Ouvrir le menu accessibilité",
        "Hide Images": "Masquer les Images",
        "Skip to accessibility menu": "Aller au menu accessibilité",
        "Accessibility Report": "Rapport d'Accessibilité",
        "Run Accessibility Check": "Lancer le Contrôle d'Accessibilité",
        "Loading...": "Chargement...",
        "Analyzing page...": "Analyse de la page...",
        "Critical": "Critique",
        "Serious": "Grave",
        "Moderate": "Modéré",
        "Minor": "Mineur",
        "Violations Found": "Violations Trouvées",
        "No Issues Found": "Aucun Problème Trouvé",
        "Element": "Élément",
        "Issue": "Problème",
        "How to Fix": "Comment Corriger",
        "Close Report": "Fermer le Rapport",
        "Passed Tests": "Tests Réussis",
        "Items Need Review": "Éléments à Vérifier",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Synthèse Vocale Activée",
        "Text to Speech Off": "Synthèse Vocale Désactivée",
        "Simplify Layout": "Simplify Layout",
        "Speech": "Voix",
        "Text": "Texte",
        "Color & Contrast": "Couleur et Contraste",
        "Reading Aids": "Aides à la Lecture",
        "Interaction": "Interaction",
        "Contrast": "Contraste",
        "Saturation": "Saturation",
        "Light": "Clair",
        "Dark": "Sombre",
        "High": "Élevée",
        "Low": "Faible",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Loading voice...": "Chargement de la voix...",
        "Reading...": "Reading...",
        "Profiles": "Profils",
        "Seizure Safe": "Protection Épilepsie",
        "Vision Impaired": "Déficience Visuelle",
        "ADHD Friendly": "Adapté TDAH",
        "Dyslexia Friendly": "Adapté Dyslexie",
        "On": "Activé",
        "Off": "Désactivé",
        "Mute Sounds": "Couper les Sons",
        "Page Structure": "Structure de la Page",
        "Text Magnifier": "Loupe de Texte",
        "Headings": "Titres",
        "Landmarks": "Points de Repère",
        "Links": "Liens",
        "No items found": "Aucun élément trouvé",
        "Settings reset": "Paramètres réinitialisés",
      },
      de: {
        "Accessibility": "Barrierefreiheit",
        "Accessibility Options": "Optionen für Barrierefreiheit",
        "Accessibility Menu": "Barrierefreiheit-Menü",
        "Reset settings": "Einstellungen zurücksetzen",
        "Reset All Settings": "Alle Einstellungen zurücksetzen",
        "Close": "Schließen",
        "Content Adjustments": "Inhaltsanpassungen",
        "Adjust Font Size": "Schriftgröße anpassen",
        "Highlight Title": "Titel hervorheben",
        "Highlight Links": "Links hervorheben",
        "Readable Font": "Lesbare Schrift",
        "Color Adjustments": "Farbanpassungen",
        "Invert Colors": "Farben invertieren",
        "Light Contrast": "Heller Kontrast",
        "Dark Contrast": "Dunkler Kontrast",
        "High Contrast": "Hoher Kontrast",
        "High Saturation": "Hohe Sättigung",
        "Low Saturation": "Niedrige Sättigung",
        "Monochrome": "Monochrom",
        "Tools": "Werkzeuge",
        "Reading Guide": "Lesehilfe",
        "Stop Animations": "Animationen stoppen",
        "Big Cursor": "Großer Cursor",
        "Increase Font Size": "Schriftgröße erhöhen",
        "Decrease Font Size": "Schriftgröße verringern",
        "Letter Spacing": "Zeichenabstand",
        "Line Height": "Zeilenhöhe",
        "Font Weight": "Schriftstärke",
        "Dyslexia Font": "Legasthenie-Schrift",
        "Legible Font": "Gut lesbare Schrift",
        "Font Size": "Schriftgröße",
        "Language": "Sprache",
        "All Languages": "Alle Sprachen",
        "Search language": "Sprache suchen",
        "Open Accessibility Menu": "Barrierefreiheit-Menü öffnen",
        "Open accessibility menu": "Barrierefreiheit-Menü öffnen",
        "Hide Images": "Bilder ausblenden",
        "Skip to accessibility menu": "Zum Barrierefreiheit-Menü springen",
        "Accessibility Report": "Barrierefreiheit-Bericht",
        "Run Accessibility Check": "Barrierefreiheitsprüfung starten",
        "Loading...": "Laden...",
        "Analyzing page...": "Seite wird analysiert...",
        "Critical": "Kritisch",
        "Serious": "Schwerwiegend",
        "Moderate": "Mäßig",
        "Minor": "Gering",
        "Violations Found": "Verstöße gefunden",
        "No Issues Found": "Keine Probleme gefunden",
        "Element": "Element",
        "Issue": "Problem",
        "How to Fix": "Lösung",
        "Close Report": "Bericht schließen",
        "Passed Tests": "Bestandene Tests",
        "Items Need Review": "Elemente zur Überprüfung",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Sprachausgabe Ein",
        "Text to Speech Off": "Sprachausgabe Aus",
        "Simplify Layout": "Simplify Layout",
        "Speech": "Sprachausgabe",
        "Text": "Text",
        "Color & Contrast": "Farbe & Kontrast",
        "Reading Aids": "Lesehilfen",
        "Interaction": "Interaktion",
        "Contrast": "Kontrast",
        "Saturation": "Sättigung",
        "Light": "Hell",
        "Dark": "Dunkel",
        "High": "Hoch",
        "Low": "Niedrig",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Loading voice...": "Stimme wird geladen...",
        "Reading...": "Reading...",
        "Profiles": "Profile",
        "Seizure Safe": "Anfallssicher",
        "Vision Impaired": "Sehbeeinträchtigung",
        "ADHD Friendly": "ADHS-freundlich",
        "Dyslexia Friendly": "Legasthenie-freundlich",
        "On": "Ein",
        "Off": "Aus",
        "Mute Sounds": "Töne stummschalten",
        "Page Structure": "Seitenstruktur",
        "Text Magnifier": "Textlupe",
        "Headings": "Überschriften",
        "Landmarks": "Orientierungspunkte",
        "Links": "Links",
        "No items found": "Keine Einträge gefunden",
        "Settings reset": "Einstellungen zurückgesetzt",
      },
      es: {
        "Accessibility": "Accesibilidad",
        "Accessibility Options": "Opciones de accesibilidad",
        "Accessibility Menu": "Menú de Accesibilidad",
        "Reset settings": "Restablecer configuración",
        "Reset All Settings": "Restablecer toda la configuración",
        "Close": "Cerrar",
        "Content Adjustments": "Ajustes de Contenido",
        "Adjust Font Size": "Ajustar Tamaño de Fuente",
        "Highlight Title": "Resaltar Títulos",
        "Highlight Links": "Resaltar Enlaces",
        "Readable Font": "Fuente Legible",
        "Color Adjustments": "Ajustes de Color",
        "Invert Colors": "Invertir Colores",
        "Light Contrast": "Contraste Claro",
        "Dark Contrast": "Contraste Oscuro",
        "High Contrast": "Alto Contraste",
        "High Saturation": "Alta Saturación",
        "Low Saturation": "Baja Saturación",
        "Monochrome": "Monocromo",
        "Tools": "Herramientas",
        "Reading Guide": "Guía de Lectura",
        "Stop Animations": "Detener Animaciones",
        "Big Cursor": "Cursor Grande",
        "Increase Font Size": "Aumentar Tamaño de Fuente",
        "Decrease Font Size": "Disminuir Tamaño de Fuente",
        "Letter Spacing": "Espaciado de Letras",
        "Line Height": "Altura de Línea",
        "Font Weight": "Grosor de Fuente",
        "Dyslexia Font": "Fuente para Dislexia",
        "Legible Font": "Fuente Legible",
        "Font Size": "Tamaño de Fuente",
        "Language": "Idioma",
        "All Languages": "Todos los Idiomas",
        "Search language": "Buscar idioma",
        "Open Accessibility Menu": "Abrir Menú de Accesibilidad",
        "Open accessibility menu": "Abrir menú de accesibilidad",
        "Hide Images": "Ocultar Imágenes",
        "Skip to accessibility menu": "Ir al menú de accesibilidad",
        "Accessibility Report": "Informe de Accesibilidad",
        "Run Accessibility Check": "Ejecutar Comprobación de Accesibilidad",
        "Loading...": "Cargando...",
        "Analyzing page...": "Analizando página...",
        "Critical": "Crítico",
        "Serious": "Grave",
        "Moderate": "Moderado",
        "Minor": "Menor",
        "Violations Found": "Violaciones Encontradas",
        "No Issues Found": "Sin Problemas Encontrados",
        "Element": "Elemento",
        "Issue": "Problema",
        "How to Fix": "Cómo Solucionarlo",
        "Close Report": "Cerrar Informe",
        "Passed Tests": "Pruebas Superadas",
        "Items Need Review": "Elementos a Revisar",
        "Annotations": "Anotaciones",
        "Text to Speech": "Texto a voz",
        "Text to Speech On": "Texto a Voz Activado",
        "Text to Speech Off": "Texto a Voz Desactivado",
        "Simplify Layout": "Simplificar diseño",
        "Speech": "Voz",
        "Text": "Texto",
        "Color & Contrast": "Color y Contraste",
        "Reading Aids": "Ayudas de Lectura",
        "Interaction": "Interacción",
        "Contrast": "Contraste",
        "Saturation": "Saturación",
        "Light": "Claro",
        "Dark": "Oscuro",
        "High": "Alta",
        "Low": "Baja",
        "Play": "Reproducir",
        "Pause": "Pausar",
        "Stop": "Detener",
        "Loading voice...": "Cargando voz...",
        "Reading...": "Leyendo...",
        "Profiles": "Perfiles",
        "Seizure Safe": "Seguro para Epilepsia",
        "Vision Impaired": "Discapacidad Visual",
        "ADHD Friendly": "Adaptado para TDAH",
        "Dyslexia Friendly": "Adaptado para Dislexia",
        "On": "Activado",
        "Off": "Desactivado",
        "Mute Sounds": "Silenciar Sonidos",
        "Page Structure": "Estructura de la Página",
        "Text Magnifier": "Lupa de Texto",
        "Headings": "Encabezados",
        "Landmarks": "Puntos de Referencia",
        "Links": "Enlaces",
        "No items found": "No se encontraron elementos",
        "Settings reset": "Configuración restablecida",
      },
      ru: {
        "Accessibility": "Доступность",
        "Accessibility Options": "Настройки доступности",
        "Accessibility Menu": "Меню доступности",
        "Reset settings": "Сбросить настройки",
        "Reset All Settings": "Сбросить все настройки",
        "Close": "Закрыть",
        "Content Adjustments": "Настройки контента",
        "Adjust Font Size": "Изменить размер шрифта",
        "Highlight Title": "Выделить заголовки",
        "Highlight Links": "Выделить ссылки",
        "Readable Font": "Читаемый шрифт",
        "Color Adjustments": "Настройки цвета",
        "Invert Colors": "Инвертировать цвета",
        "Light Contrast": "Светлый контраст",
        "Dark Contrast": "Тёмный контраст",
        "High Contrast": "Высокий контраст",
        "High Saturation": "Высокая насыщенность",
        "Low Saturation": "Низкая насыщенность",
        "Monochrome": "Монохромный",
        "Tools": "Инструменты",
        "Reading Guide": "Линейка для чтения",
        "Stop Animations": "Остановить анимации",
        "Big Cursor": "Большой курсор",
        "Increase Font Size": "Увеличить размер шрифта",
        "Decrease Font Size": "Уменьшить размер шрифта",
        "Letter Spacing": "Межбуквенный интервал",
        "Line Height": "Высота строки",
        "Font Weight": "Жирный шрифт",
        "Dyslexia Font": "Шрифт для дислексии",
        "Legible Font": "Разборчивый шрифт",
        "Font Size": "Размер шрифта",
        "Language": "Язык",
        "All Languages": "Все языки",
        "Search language": "Поиск языка",
        "Open Accessibility Menu": "Открыть меню доступности",
        "Open accessibility menu": "Открыть меню доступности",
        "Hide Images": "Скрыть изображения",
        "Skip to accessibility menu": "Перейти к меню доступности",
        "Accessibility Report": "Отчёт о доступности",
        "Run Accessibility Check": "Запустить проверку доступности",
        "Loading...": "Загрузка...",
        "Analyzing page...": "Анализ страницы...",
        "Critical": "Критический",
        "Serious": "Серьёзный",
        "Moderate": "Умеренный",
        "Minor": "Незначительный",
        "Violations Found": "Найдены нарушения",
        "No Issues Found": "Проблем не найдено",
        "Element": "Элемент",
        "Issue": "Проблема",
        "How to Fix": "Как исправить",
        "Close Report": "Закрыть отчёт",
        "Passed Tests": "Пройденные тесты",
        "Items Need Review": "Требуют проверки",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Озвучивание Включено",
        "Text to Speech Off": "Озвучивание Выключено",
        "Simplify Layout": "Simplify Layout",
        "Speech": "Речь",
        "Text": "Текст",
        "Color & Contrast": "Цвет и контраст",
        "Reading Aids": "Помощь при чтении",
        "Interaction": "Взаимодействие",
        "Contrast": "Контраст",
        "Saturation": "Насыщенность",
        "Light": "Светлый",
        "Dark": "Тёмный",
        "High": "Высокая",
        "Low": "Низкая",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Loading voice...": "Загрузка голоса...",
        "Reading...": "Reading...",
        "Profiles": "Профили",
        "Seizure Safe": "Защита от эпилепсии",
        "Vision Impaired": "Для слабовидящих",
        "ADHD Friendly": "Для людей с СДВГ",
        "Dyslexia Friendly": "Для людей с дислексией",
        "On": "Включено",
        "Off": "Выключено",
        "Mute Sounds": "Отключить звук",
        "Page Structure": "Структура страницы",
        "Text Magnifier": "Текстовая лупа",
        "Headings": "Заголовки",
        "Landmarks": "Ориентиры",
        "Links": "Ссылки",
        "No items found": "Ничего не найдено",
        "Settings reset": "Настройки сброшены",
      },
      pl: {
        "Accessibility": "Dostępność",
        "Accessibility Options": "Opcje dostępności",
        "Accessibility Menu": "Menu Dostępności",
        "Reset settings": "Zresetuj ustawienia",
        "Reset All Settings": "Zresetuj wszystkie ustawienia",
        "Close": "Zamknij",
        "Content Adjustments": "Dostosowanie Treści",
        "Adjust Font Size": "Dostosuj Rozmiar Czcionki",
        "Highlight Title": "Podświetl Tytuły",
        "Highlight Links": "Podświetl Linki",
        "Readable Font": "Czytelna Czcionka",
        "Color Adjustments": "Dostosowanie Kolorów",
        "Invert Colors": "Odwróć Kolory",
        "Light Contrast": "Jasny Kontrast",
        "Dark Contrast": "Ciemny Kontrast",
        "High Contrast": "Wysoki Kontrast",
        "High Saturation": "Wysoka Saturacja",
        "Low Saturation": "Niska Saturacja",
        "Monochrome": "Monochromatyczny",
        "Tools": "Narzędzia",
        "Reading Guide": "Linia do Czytania",
        "Stop Animations": "Zatrzymaj Animacje",
        "Big Cursor": "Duży Kursor",
        "Increase Font Size": "Zwiększ Rozmiar Czcionki",
        "Decrease Font Size": "Zmniejsz Rozmiar Czcionki",
        "Letter Spacing": "Odstępy Między Literami",
        "Line Height": "Wysokość Linii",
        "Font Weight": "Grubość Czcionki",
        "Dyslexia Font": "Czcionka dla Dysleksji",
        "Legible Font": "Czytelna Czcionka",
        "Font Size": "Rozmiar Czcionki",
        "Language": "Język",
        "All Languages": "Wszystkie Języki",
        "Search language": "Szukaj języka",
        "Open Accessibility Menu": "Otwórz Menu Dostępności",
        "Open accessibility menu": "Otwórz menu dostępności",
        "Hide Images": "Ukryj Obrazy",
        "Skip to accessibility menu": "Przejdź do menu dostępności",
        "Accessibility Report": "Raport Dostępności",
        "Run Accessibility Check": "Uruchom Sprawdzanie Dostępności",
        "Loading...": "Ładowanie...",
        "Analyzing page...": "Analizowanie strony...",
        "Critical": "Krytyczny",
        "Serious": "Poważny",
        "Moderate": "Umiarkowany",
        "Minor": "Drobny",
        "Violations Found": "Znalezione Naruszenia",
        "No Issues Found": "Brak Problemów",
        "Element": "Element",
        "Issue": "Problem",
        "How to Fix": "Jak Naprawić",
        "Close Report": "Zamknij Raport",
        "Passed Tests": "Zaliczone Testy",
        "Items Need Review": "Elementy do Sprawdzenia",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Czytanie Tekstu Włączone",
        "Text to Speech Off": "Czytanie Tekstu Wyłączone",
        "Simplify Layout": "Simplify Layout",
        "Speech": "Mowa",
        "Text": "Tekst",
        "Color & Contrast": "Kolor i Kontrast",
        "Reading Aids": "Pomoce do Czytania",
        "Interaction": "Interakcja",
        "Contrast": "Kontrast",
        "Saturation": "Saturacja",
        "Light": "Jasny",
        "Dark": "Ciemny",
        "High": "Wysoka",
        "Low": "Niska",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Loading voice...": "Ładowanie głosu...",
        "Reading...": "Reading...",
        "Profiles": "Profile",
        "Seizure Safe": "Bezpieczny dla Epileptyków",
        "Vision Impaired": "Dla Słabowidzących",
        "ADHD Friendly": "Przyjazny dla ADHD",
        "Dyslexia Friendly": "Przyjazny dla Dysleksji",
        "On": "Włączone",
        "Off": "Wyłączone",
        "Mute Sounds": "Wycisz Dźwięki",
        "Page Structure": "Struktura Strony",
        "Text Magnifier": "Lupa Tekstu",
        "Headings": "Nagłówki",
        "Landmarks": "Punkty Orientacyjne",
        "Links": "Linki",
        "No items found": "Nie znaleziono elementów",
        "Settings reset": "Ustawienia zresetowane",
      },
      ro: {
        "Accessibility": "Accesibilitate",
        "Accessibility Options": "Opțiuni de accesibilitate",
        "Accessibility Menu": "Meniu Accesibilitate",
        "Reset settings": "Resetare setări",
        "Reset All Settings": "Resetare toate setările",
        "Close": "Închide",
        "Content Adjustments": "Ajustări Conținut",
        "Adjust Font Size": "Ajustare Dimensiune Font",
        "Highlight Title": "Evidențiere Titluri",
        "Highlight Links": "Evidențiere Linkuri",
        "Readable Font": "Font Lizibil",
        "Color Adjustments": "Ajustări Culoare",
        "Invert Colors": "Inversare Culori",
        "Light Contrast": "Contrast Luminos",
        "Dark Contrast": "Contrast Întunecat",
        "High Contrast": "Contrast Ridicat",
        "High Saturation": "Saturație Ridicată",
        "Low Saturation": "Saturație Scăzută",
        "Monochrome": "Monocrom",
        "Tools": "Instrumente",
        "Reading Guide": "Ghid de Citire",
        "Stop Animations": "Oprire Animații",
        "Big Cursor": "Cursor Mare",
        "Increase Font Size": "Mărire Dimensiune Font",
        "Decrease Font Size": "Micșorare Dimensiune Font",
        "Letter Spacing": "Spațiere Litere",
        "Line Height": "Înălțime Linie",
        "Font Weight": "Grosime Font",
        "Dyslexia Font": "Font pentru Dislexie",
        "Legible Font": "Font Lizibil",
        "Font Size": "Dimensiune Font",
        "Language": "Limbă",
        "All Languages": "Toate Limbile",
        "Search language": "Căutare limbă",
        "Open Accessibility Menu": "Deschide Meniul Accesibilitate",
        "Open accessibility menu": "Deschide meniul de accesibilitate",
        "Hide Images": "Ascunde Imagini",
        "Skip to accessibility menu": "Salt la meniul de accesibilitate",
        "Accessibility Report": "Raport Accesibilitate",
        "Run Accessibility Check": "Rulează Verificare Accesibilitate",
        "Loading...": "Se încarcă...",
        "Analyzing page...": "Se analizează pagina...",
        "Critical": "Critic",
        "Serious": "Grav",
        "Moderate": "Moderat",
        "Minor": "Minor",
        "Violations Found": "Încălcări Găsite",
        "No Issues Found": "Nicio Problemă Găsită",
        "Element": "Element",
        "Issue": "Problemă",
        "How to Fix": "Cum se Remediază",
        "Close Report": "Închide Raportul",
        "Passed Tests": "Teste Trecute",
        "Items Need Review": "Elemente de Verificat",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Text to Speech Pornit",
        "Text to Speech Off": "Text to Speech Oprit",
        "Simplify Layout": "Simplify Layout",
        "Speech": "Voce",
        "Text": "Text",
        "Color & Contrast": "Culoare și Contrast",
        "Reading Aids": "Ajutoare de Citire",
        "Interaction": "Interacțiune",
        "Contrast": "Contrast",
        "Saturation": "Saturație",
        "Light": "Luminos",
        "Dark": "Întunecat",
        "High": "Ridicată",
        "Low": "Scăzută",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Loading voice...": "Se încarcă vocea...",
        "Reading...": "Reading...",
        "Profiles": "Profiluri",
        "Seizure Safe": "Protecție Epilepsie",
        "Vision Impaired": "Deficiențe de Vedere",
        "ADHD Friendly": "Adaptat pentru ADHD",
        "Dyslexia Friendly": "Adaptat pentru Dislexie",
        "On": "Activat",
        "Off": "Dezactivat",
        "Mute Sounds": "Dezactivare Sunete",
        "Page Structure": "Structura Paginii",
        "Text Magnifier": "Lupă pentru Text",
        "Headings": "Titluri",
        "Landmarks": "Repere",
        "Links": "Linkuri",
        "No items found": "Niciun element găsit",
        "Settings reset": "Setări resetate",
      },
      nl: {
        "Accessibility": "Toegankelijkheid",
        "Accessibility Options": "Toegankelijkheidsopties",
        "Accessibility Menu": "Toegankelijkheidsmenu",
        "Reset settings": "Instellingen resetten",
        "Reset All Settings": "Alle instellingen resetten",
        "Close": "Sluiten",
        "Content Adjustments": "Inhoudsaanpassingen",
        "Adjust Font Size": "Lettergrootte aanpassen",
        "Highlight Title": "Titels markeren",
        "Highlight Links": "Links markeren",
        "Readable Font": "Leesbaar Lettertype",
        "Color Adjustments": "Kleuraanpassingen",
        "Invert Colors": "Kleuren omkeren",
        "Light Contrast": "Licht Contrast",
        "Dark Contrast": "Donker Contrast",
        "High Contrast": "Hoog Contrast",
        "High Saturation": "Hoge Verzadiging",
        "Low Saturation": "Lage Verzadiging",
        "Monochrome": "Monochroom",
        "Tools": "Hulpmiddelen",
        "Reading Guide": "Leeshulp",
        "Stop Animations": "Animaties stoppen",
        "Big Cursor": "Grote Cursor",
        "Increase Font Size": "Lettergrootte vergroten",
        "Decrease Font Size": "Lettergrootte verkleinen",
        "Letter Spacing": "Letterafstand",
        "Line Height": "Regelhoogte",
        "Font Weight": "Letterdikte",
        "Dyslexia Font": "Dyslexie Lettertype",
        "Legible Font": "Leesbaar Lettertype",
        "Font Size": "Lettergrootte",
        "Language": "Taal",
        "All Languages": "Alle Talen",
        "Search language": "Taal zoeken",
        "Open Accessibility Menu": "Toegankelijkheidsmenu openen",
        "Open accessibility menu": "Toegankelijkheidsmenu openen",
        "Hide Images": "Afbeeldingen verbergen",
        "Skip to accessibility menu": "Ga naar toegankelijkheidsmenu",
        "Accessibility Report": "Toegankelijkheidsrapport",
        "Run Accessibility Check": "Toegankelijkheidscontrole uitvoeren",
        "Loading...": "Laden...",
        "Analyzing page...": "Pagina analyseren...",
        "Critical": "Kritiek",
        "Serious": "Ernstig",
        "Moderate": "Matig",
        "Minor": "Gering",
        "Violations Found": "Overtredingen Gevonden",
        "No Issues Found": "Geen Problemen Gevonden",
        "Element": "Element",
        "Issue": "Probleem",
        "How to Fix": "Hoe op te lossen",
        "Close Report": "Rapport Sluiten",
        "Passed Tests": "Geslaagde Tests",
        "Items Need Review": "Items te Controleren",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Tekst naar Spraak Aan",
        "Text to Speech Off": "Tekst naar Spraak Uit",
        "Simplify Layout": "Simplify Layout",
        "Speech": "Spraak",
        "Text": "Tekst",
        "Color & Contrast": "Kleur & Contrast",
        "Reading Aids": "Leeshulpmiddelen",
        "Interaction": "Interactie",
        "Contrast": "Contrast",
        "Saturation": "Verzadiging",
        "Light": "Licht",
        "Dark": "Donker",
        "High": "Hoog",
        "Low": "Laag",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Loading voice...": "Stem laden...",
        "Reading...": "Reading...",
        "Profiles": "Profielen",
        "Seizure Safe": "Epilepsieveilig",
        "Vision Impaired": "Slechtziend",
        "ADHD Friendly": "ADHD-vriendelijk",
        "Dyslexia Friendly": "Dyslexievriendelijk",
        "On": "Aan",
        "Off": "Uit",
        "Mute Sounds": "Geluiden dempen",
        "Page Structure": "Paginastructuur",
        "Text Magnifier": "Tekstvergrootglas",
        "Headings": "Koppen",
        "Landmarks": "Oriëntatiepunten",
        "Links": "Links",
        "No items found": "Geen items gevonden",
        "Settings reset": "Instellingen gereset",
      },
      uk: {
        "Accessibility": "Доступність",
        "Accessibility Options": "Параметри доступності",
        "Accessibility Menu": "Меню доступності",
        "Reset settings": "Скинути налаштування",
        "Reset All Settings": "Скинути всі налаштування",
        "Close": "Закрити",
        "Content Adjustments": "Налаштування контенту",
        "Adjust Font Size": "Змінити розмір шрифту",
        "Highlight Title": "Виділити заголовки",
        "Highlight Links": "Виділити посилання",
        "Readable Font": "Читабельний шрифт",
        "Color Adjustments": "Налаштування кольору",
        "Invert Colors": "Інвертувати кольори",
        "Light Contrast": "Світлий контраст",
        "Dark Contrast": "Темний контраст",
        "High Contrast": "Високий контраст",
        "High Saturation": "Висока насиченість",
        "Low Saturation": "Низька насиченість",
        "Monochrome": "Монохромний",
        "Tools": "Інструменти",
        "Reading Guide": "Лінійка для читання",
        "Stop Animations": "Зупинити анімації",
        "Big Cursor": "Великий курсор",
        "Increase Font Size": "Збільшити розмір шрифту",
        "Decrease Font Size": "Зменшити розмір шрифту",
        "Letter Spacing": "Міжлітерний інтервал",
        "Line Height": "Висота рядка",
        "Font Weight": "Жирний шрифт",
        "Dyslexia Font": "Шрифт для дислексії",
        "Legible Font": "Розбірливий шрифт",
        "Font Size": "Розмір шрифту",
        "Language": "Мова",
        "All Languages": "Усі мови",
        "Search language": "Пошук мови",
        "Open Accessibility Menu": "Відкрити меню доступності",
        "Open accessibility menu": "Відкрити меню доступності",
        "Hide Images": "Приховати зображення",
        "Skip to accessibility menu": "Перейти до меню доступності",
        "Accessibility Report": "Звіт про доступність",
        "Run Accessibility Check": "Запустити перевірку доступності",
        "Loading...": "Завантаження...",
        "Analyzing page...": "Аналіз сторінки...",
        "Critical": "Критичний",
        "Serious": "Серйозний",
        "Moderate": "Помірний",
        "Minor": "Незначний",
        "Violations Found": "Знайдені порушення",
        "No Issues Found": "Проблем не знайдено",
        "Element": "Елемент",
        "Issue": "Проблема",
        "How to Fix": "Як виправити",
        "Close Report": "Закрити звіт",
        "Passed Tests": "Пройдені тести",
        "Items Need Review": "Потребують перевірки",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Озвучування Увімкнено",
        "Text to Speech Off": "Озвучування Вимкнено",
        "Simplify Layout": "Simplify Layout",
        "Speech": "Мовлення",
        "Text": "Текст",
        "Color & Contrast": "Колір і контраст",
        "Reading Aids": "Допомога при читанні",
        "Interaction": "Взаємодія",
        "Contrast": "Контраст",
        "Saturation": "Насиченість",
        "Light": "Світлий",
        "Dark": "Темний",
        "High": "Висока",
        "Low": "Низька",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Loading voice...": "Завантаження голосу...",
        "Reading...": "Reading...",
        "Profiles": "Профілі",
        "Seizure Safe": "Захист від епілепсії",
        "Vision Impaired": "Для людей з вадами зору",
        "ADHD Friendly": "Для людей з РДУГ",
        "Dyslexia Friendly": "Для людей з дислексією",
        "On": "Увімкнено",
        "Off": "Вимкнено",
        "Mute Sounds": "Вимкнути звук",
        "Page Structure": "Структура сторінки",
        "Text Magnifier": "Текстова лупа",
        "Headings": "Заголовки",
        "Landmarks": "Орієнтири",
        "Links": "Посилання",
        "No items found": "Нічого не знайдено",
        "Settings reset": "Налаштування скинуто",
      },
      ar: {
        "Accessibility": "إمكانية الوصول",
        "Accessibility Options": "خيارات إمكانية الوصول",
        "Accessibility Menu": "قائمة إمكانية الوصول",
        "Reset settings": "إعادة تعيين الإعدادات",
        "Reset All Settings": "إعادة تعيين جميع الإعدادات",
        "Close": "إغلاق",
        "Content Adjustments": "تعديلات المحتوى",
        "Adjust Font Size": "تعديل حجم الخط",
        "Highlight Title": "تمييز العناوين",
        "Highlight Links": "تمييز الروابط",
        "Readable Font": "خط سهل القراءة",
        "Color Adjustments": "تعديلات الألوان",
        "Invert Colors": "عكس الألوان",
        "Light Contrast": "تباين فاتح",
        "Dark Contrast": "تباين داكن",
        "High Contrast": "تباين عالٍ",
        "High Saturation": "تشبع عالٍ",
        "Low Saturation": "تشبع منخفض",
        "Monochrome": "أحادي اللون",
        "Tools": "أدوات",
        "Reading Guide": "دليل القراءة",
        "Stop Animations": "إيقاف الرسوم المتحركة",
        "Big Cursor": "مؤشر كبير",
        "Increase Font Size": "تكبير حجم الخط",
        "Decrease Font Size": "تصغير حجم الخط",
        "Letter Spacing": "تباعد الأحرف",
        "Line Height": "ارتفاع السطر",
        "Font Weight": "سُمك الخط",
        "Dyslexia Font": "خط لعُسر القراءة",
        "Legible Font": "خط واضح",
        "Font Size": "حجم الخط",
        "Language": "اللغة",
        "All Languages": "جميع اللغات",
        "Search language": "البحث عن لغة",
        "Open Accessibility Menu": "فتح قائمة إمكانية الوصول",
        "Open accessibility menu": "فتح قائمة إمكانية الوصول",
        "Hide Images": "إخفاء الصور",
        "Skip to accessibility menu": "الانتقال إلى قائمة إمكانية الوصول",
        "Accessibility Report": "تقرير إمكانية الوصول",
        "Run Accessibility Check": "تشغيل فحص إمكانية الوصول",
        "Loading...": "جارٍ التحميل...",
        "Analyzing page...": "جارٍ تحليل الصفحة...",
        "Critical": "حرج",
        "Serious": "خطير",
        "Moderate": "متوسط",
        "Minor": "طفيف",
        "Violations Found": "المخالفات المكتشفة",
        "No Issues Found": "لم يتم العثور على مشاكل",
        "Element": "العنصر",
        "Issue": "المشكلة",
        "How to Fix": "كيفية الإصلاح",
        "Close Report": "إغلاق التقرير",
        "Passed Tests": "الاختبارات الناجحة",
        "Items Need Review": "عناصر تحتاج إلى مراجعة",
        "Annotations": "التعليقات التوضيحية",
        "Text to Speech": "تحويل النص إلى كلام",
        "Text to Speech On": "تحويل النص إلى كلام مفعّل",
        "Text to Speech Off": "تحويل النص إلى كلام معطّل",
        "Simplify Layout": "تبسيط التخطيط",
        "Speech": "الكلام",
        "Text": "النص",
        "Color & Contrast": "اللون والتباين",
        "Reading Aids": "مساعدات القراءة",
        "Interaction": "التفاعل",
        "Contrast": "التباين",
        "Saturation": "التشبع",
        "Light": "فاتح",
        "Dark": "داكن",
        "High": "عالٍ",
        "Low": "منخفض",
        "Play": "تشغيل",
        "Pause": "إيقاف مؤقت",
        "Stop": "إيقاف",
        "Loading voice...": "جارٍ تحميل الصوت...",
        "Reading...": "جارٍ القراءة...",
        "Profiles": "الملفات الشخصية",
        "Seizure Safe": "آمن لمرضى الصرع",
        "Vision Impaired": "لضعاف البصر",
        "ADHD Friendly": "مناسب لفرط الحركة وتشتت الانتباه",
        "Dyslexia Friendly": "مناسب لعُسر القراءة",
        "On": "مفعّل",
        "Off": "معطّل",
        "Mute Sounds": "كتم الأصوات",
        "Page Structure": "بنية الصفحة",
        "Text Magnifier": "مكبّر النص",
        "Headings": "العناوين",
        "Landmarks": "المعالم",
        "Links": "الروابط",
        "No items found": "لم يتم العثور على عناصر",
        "Settings reset": "تمت إعادة تعيين الإعدادات",
      },
      he: {
        "Accessibility": "נגישות",
        "Accessibility Options": "אפשרויות נגישות",
        "Accessibility Menu": "תפריט נגישות",
        "Reset settings": "איפוס הגדרות",
        "Reset All Settings": "איפוס כל ההגדרות",
        "Close": "סגירה",
        "Content Adjustments": "התאמות תוכן",
        "Adjust Font Size": "התאמת גודל גופן",
        "Highlight Title": "הדגשת כותרות",
        "Highlight Links": "הדגשת קישורים",
        "Readable Font": "גופן קריא",
        "Color Adjustments": "התאמות צבע",
        "Invert Colors": "היפוך צבעים",
        "Light Contrast": "ניגודיות בהירה",
        "Dark Contrast": "ניגודיות כהה",
        "High Contrast": "ניגודיות גבוהה",
        "High Saturation": "רוויה גבוהה",
        "Low Saturation": "רוויה נמוכה",
        "Monochrome": "מונוכרום",
        "Tools": "כלים",
        "Reading Guide": "סרגל קריאה",
        "Stop Animations": "עצירת אנימציות",
        "Big Cursor": "סמן גדול",
        "Increase Font Size": "הגדלת גודל גופן",
        "Decrease Font Size": "הקטנת גודל גופן",
        "Letter Spacing": "ריווח אותיות",
        "Line Height": "גובה שורה",
        "Font Weight": "עובי גופן",
        "Dyslexia Font": "גופן מותאם לדיסלקציה",
        "Legible Font": "גופן קריא",
        "Font Size": "גודל גופן",
        "Language": "שפה",
        "All Languages": "כל השפות",
        "Search language": "חיפוש שפה",
        "Open Accessibility Menu": "פתיחת תפריט נגישות",
        "Open accessibility menu": "פתיחת תפריט נגישות",
        "Hide Images": "הסתרת תמונות",
        "Skip to accessibility menu": "דילוג לתפריט הנגישות",
        "Accessibility Report": "דוח נגישות",
        "Run Accessibility Check": "הפעלת בדיקת נגישות",
        "Loading...": "טוען...",
        "Analyzing page...": "מנתח את הדף...",
        "Critical": "קריטי",
        "Serious": "חמור",
        "Moderate": "בינוני",
        "Minor": "קל",
        "Violations Found": "הפרות שנמצאו",
        "No Issues Found": "לא נמצאו בעיות",
        "Element": "רכיב",
        "Issue": "בעיה",
        "How to Fix": "כיצד לתקן",
        "Close Report": "סגירת הדוח",
        "Passed Tests": "בדיקות שעברו",
        "Items Need Review": "פריטים הדורשים בדיקה",
        "Annotations": "הערות",
        "Text to Speech": "הקראת טקסט",
        "Text to Speech On": "הקראת טקסט פועלת",
        "Text to Speech Off": "הקראת טקסט כבויה",
        "Simplify Layout": "פישוט הפריסה",
        "Speech": "דיבור",
        "Text": "טקסט",
        "Color & Contrast": "צבע וניגודיות",
        "Reading Aids": "עזרי קריאה",
        "Interaction": "אינטראקציה",
        "Contrast": "ניגודיות",
        "Saturation": "רוויה",
        "Light": "בהיר",
        "Dark": "כהה",
        "High": "גבוהה",
        "Low": "נמוכה",
        "Play": "נגן",
        "Pause": "השהה",
        "Stop": "עצור",
        "Loading voice...": "טוען קול...",
        "Reading...": "מקריא...",
        "Profiles": "פרופילים",
        "Seizure Safe": "מותאם לאפילפסיה",
        "Vision Impaired": "מותאם ללקויי ראייה",
        "ADHD Friendly": "מותאם להפרעות קשב",
        "Dyslexia Friendly": "מותאם לדיסלקציה",
        "On": "מופעל",
        "Off": "כבוי",
        "Mute Sounds": "השתקת צלילים",
        "Page Structure": "מבנה הדף",
        "Text Magnifier": "זכוכית מגדלת לטקסט",
        "Headings": "כותרות",
        "Landmarks": "ציוני דרך",
        "Links": "קישורים",
        "No items found": "לא נמצאו פריטים",
        "Settings reset": "ההגדרות אופסו",
      },
      sv: {
        "Accessibility": "Tillgänglighet",
        "Accessibility Options": "Tillgänglighetsalternativ",
        "Accessibility Menu": "Tillgänglighetsmeny",
        "Reset settings": "Återställ inställningar",
        "Reset All Settings": "Återställ alla inställningar",
        "Close": "Stäng",
        "Content Adjustments": "Innehållsjusteringar",
        "Adjust Font Size": "Justera textstorlek",
        "Highlight Title": "Markera rubriker",
        "Highlight Links": "Markera länkar",
        "Readable Font": "Läsbart typsnitt",
        "Color Adjustments": "Färgjusteringar",
        "Invert Colors": "Invertera färger",
        "Light Contrast": "Ljus kontrast",
        "Dark Contrast": "Mörk kontrast",
        "High Contrast": "Hög kontrast",
        "High Saturation": "Hög mättnad",
        "Low Saturation": "Låg mättnad",
        "Monochrome": "Monokrom",
        "Tools": "Verktyg",
        "Reading Guide": "Läslinjal",
        "Stop Animations": "Stoppa animationer",
        "Big Cursor": "Stor muspekare",
        "Increase Font Size": "Öka textstorlek",
        "Decrease Font Size": "Minska textstorlek",
        "Letter Spacing": "Teckenavstånd",
        "Line Height": "Radavstånd",
        "Font Weight": "Teckentjocklek",
        "Dyslexia Font": "Dyslexitypsnitt",
        "Legible Font": "Tydligt typsnitt",
        "Font Size": "Textstorlek",
        "Language": "Språk",
        "All Languages": "Alla språk",
        "Search language": "Sök språk",
        "Open Accessibility Menu": "Öppna tillgänglighetsmenyn",
        "Open accessibility menu": "Öppna tillgänglighetsmenyn",
        "Hide Images": "Dölj bilder",
        "Skip to accessibility menu": "Hoppa till tillgänglighetsmenyn",
        "Accessibility Report": "Tillgänglighetsrapport",
        "Run Accessibility Check": "Kör tillgänglighetskontroll",
        "Loading...": "Läser in...",
        "Analyzing page...": "Analyserar sidan...",
        "Critical": "Kritisk",
        "Serious": "Allvarlig",
        "Moderate": "Måttlig",
        "Minor": "Mindre",
        "Violations Found": "Problem hittade",
        "No Issues Found": "Inga problem hittade",
        "Element": "Element",
        "Issue": "Problem",
        "How to Fix": "Så åtgärdar du",
        "Close Report": "Stäng rapport",
        "Passed Tests": "Godkända tester",
        "Items Need Review": "Objekt som behöver granskas",
        "Annotations": "Markeringar",
        "Text to Speech": "Text till tal",
        "Text to Speech On": "Text till tal på",
        "Text to Speech Off": "Text till tal av",
        "Simplify Layout": "Förenkla layout",
        "Speech": "Tal",
        "Text": "Text",
        "Color & Contrast": "Färg och kontrast",
        "Reading Aids": "Läshjälpmedel",
        "Interaction": "Interaktion",
        "Contrast": "Kontrast",
        "Saturation": "Mättnad",
        "Light": "Ljus",
        "Dark": "Mörk",
        "High": "Hög",
        "Low": "Låg",
        "Play": "Spela upp",
        "Pause": "Pausa",
        "Stop": "Stoppa",
        "Loading voice...": "Läser in röst...",
        "Reading...": "Läser...",
        "Profiles": "Profiler",
        "Seizure Safe": "Anfallssäker",
        "Vision Impaired": "Nedsatt syn",
        "ADHD Friendly": "ADHD-vänlig",
        "Dyslexia Friendly": "Dyslexivänlig",
        "On": "På",
        "Off": "Av",
        "Mute Sounds": "Stäng av ljud",
        "Page Structure": "Sidstruktur",
        "Text Magnifier": "Textförstorare",
        "Headings": "Rubriker",
        "Landmarks": "Landmärken",
        "Links": "Länkar",
        "No items found": "Inga objekt hittades",
        "Settings reset": "Inställningarna har återställts",
      },
      da: {
        "Accessibility": "Tilgængelighed",
        "Accessibility Options": "Tilgængelighedsindstillinger",
        "Accessibility Menu": "Tilgængelighedsmenu",
        "Reset settings": "Nulstil indstillinger",
        "Reset All Settings": "Nulstil alle indstillinger",
        "Close": "Luk",
        "Content Adjustments": "Indholdsjusteringer",
        "Adjust Font Size": "Juster skriftstørrelse",
        "Highlight Title": "Fremhæv overskrifter",
        "Highlight Links": "Fremhæv links",
        "Readable Font": "Letlæselig skrifttype",
        "Color Adjustments": "Farvejusteringer",
        "Invert Colors": "Invertér farver",
        "Light Contrast": "Lys kontrast",
        "Dark Contrast": "Mørk kontrast",
        "High Contrast": "Høj kontrast",
        "High Saturation": "Høj mætning",
        "Low Saturation": "Lav mætning",
        "Monochrome": "Monokrom",
        "Tools": "Værktøjer",
        "Reading Guide": "Læselinjal",
        "Stop Animations": "Stop animationer",
        "Big Cursor": "Stor markør",
        "Increase Font Size": "Større skrift",
        "Decrease Font Size": "Mindre skrift",
        "Letter Spacing": "Bogstavafstand",
        "Line Height": "Linjeafstand",
        "Font Weight": "Skriftvægt",
        "Dyslexia Font": "Ordblindevenlig skrifttype",
        "Legible Font": "Tydelig skrifttype",
        "Font Size": "Skriftstørrelse",
        "Language": "Sprog",
        "All Languages": "Alle sprog",
        "Search language": "Søg sprog",
        "Open Accessibility Menu": "Åbn tilgængelighedsmenu",
        "Open accessibility menu": "Åbn tilgængelighedsmenu",
        "Hide Images": "Skjul billeder",
        "Skip to accessibility menu": "Spring til tilgængelighedsmenu",
        "Accessibility Report": "Tilgængelighedsrapport",
        "Run Accessibility Check": "Kør tilgængelighedstjek",
        "Loading...": "Indlæser...",
        "Analyzing page...": "Analyserer siden...",
        "Critical": "Kritisk",
        "Serious": "Alvorlig",
        "Moderate": "Moderat",
        "Minor": "Mindre",
        "Violations Found": "Problemer fundet",
        "No Issues Found": "Ingen problemer fundet",
        "Element": "Element",
        "Issue": "Problem",
        "How to Fix": "Sådan rettes det",
        "Close Report": "Luk rapport",
        "Passed Tests": "Beståede test",
        "Items Need Review": "Elementer kræver gennemgang",
        "Annotations": "Markeringer",
        "Text to Speech": "Tekst til tale",
        "Text to Speech On": "Tekst til tale slået til",
        "Text to Speech Off": "Tekst til tale slået fra",
        "Simplify Layout": "Forenkl layout",
        "Speech": "Tale",
        "Text": "Tekst",
        "Color & Contrast": "Farve og kontrast",
        "Reading Aids": "Læsehjælpemidler",
        "Interaction": "Interaktion",
        "Contrast": "Kontrast",
        "Saturation": "Mætning",
        "Light": "Lys",
        "Dark": "Mørk",
        "High": "Høj",
        "Low": "Lav",
        "Play": "Afspil",
        "Pause": "Pause",
        "Stop": "Stop",
        "Loading voice...": "Indlæser stemme...",
        "Reading...": "Læser...",
        "Profiles": "Profiler",
        "Seizure Safe": "Epilepsisikker",
        "Vision Impaired": "Nedsat syn",
        "ADHD Friendly": "ADHD-venlig",
        "Dyslexia Friendly": "Ordblindevenlig",
        "On": "Til",
        "Off": "Fra",
        "Mute Sounds": "Slå lyd fra",
        "Page Structure": "Sidestruktur",
        "Text Magnifier": "Tekstforstørrer",
        "Headings": "Overskrifter",
        "Landmarks": "Landemærker",
        "Links": "Links",
        "No items found": "Ingen elementer fundet",
        "Settings reset": "Indstillinger nulstillet",
      },
      ca: {
        "Accessibility": "Accessibilitat",
        "Accessibility Options": "Opcions d'accessibilitat",
        "Accessibility Menu": "Menú d'accessibilitat",
        "Reset settings": "Restableix la configuració",
        "Reset All Settings": "Restableix tota la configuració",
        "Close": "Tanca",
        "Content Adjustments": "Ajustos de contingut",
        "Adjust Font Size": "Ajusta la mida del text",
        "Highlight Title": "Ressalta els títols",
        "Highlight Links": "Ressalta els enllaços",
        "Readable Font": "Tipografia llegible",
        "Color Adjustments": "Ajustos de color",
        "Invert Colors": "Inverteix els colors",
        "Light Contrast": "Contrast clar",
        "Dark Contrast": "Contrast fosc",
        "High Contrast": "Contrast alt",
        "High Saturation": "Saturació alta",
        "Low Saturation": "Saturació baixa",
        "Monochrome": "Monocrom",
        "Tools": "Eines",
        "Reading Guide": "Guia de lectura",
        "Stop Animations": "Atura les animacions",
        "Big Cursor": "Cursor gran",
        "Increase Font Size": "Augmenta la mida del text",
        "Decrease Font Size": "Redueix la mida del text",
        "Letter Spacing": "Espaiat entre lletres",
        "Line Height": "Interlineat",
        "Font Weight": "Gruix de la lletra",
        "Dyslexia Font": "Tipografia per a dislèxia",
        "Legible Font": "Tipografia clara",
        "Font Size": "Mida del text",
        "Language": "Idioma",
        "All Languages": "Tots els idiomes",
        "Search language": "Cerca un idioma",
        "Open Accessibility Menu": "Obre el menú d'accessibilitat",
        "Open accessibility menu": "Obre el menú d'accessibilitat",
        "Hide Images": "Amaga les imatges",
        "Skip to accessibility menu": "Ves al menú d'accessibilitat",
        "Accessibility Report": "Informe d'accessibilitat",
        "Run Accessibility Check": "Executa la comprovació d'accessibilitat",
        "Loading...": "S'està carregant...",
        "Analyzing page...": "S'està analitzant la pàgina...",
        "Critical": "Crític",
        "Serious": "Greu",
        "Moderate": "Moderat",
        "Minor": "Menor",
        "Violations Found": "Problemes trobats",
        "No Issues Found": "No s'han trobat problemes",
        "Element": "Element",
        "Issue": "Problema",
        "How to Fix": "Com solucionar-ho",
        "Close Report": "Tanca l'informe",
        "Passed Tests": "Proves superades",
        "Items Need Review": "Elements per revisar",
        "Annotations": "Anotacions",
        "Text to Speech": "Text a veu",
        "Text to Speech On": "Text a veu activat",
        "Text to Speech Off": "Text a veu desactivat",
        "Simplify Layout": "Simplifica el disseny",
        "Speech": "Veu",
        "Text": "Text",
        "Color & Contrast": "Color i contrast",
        "Reading Aids": "Ajudes de lectura",
        "Interaction": "Interacció",
        "Contrast": "Contrast",
        "Saturation": "Saturació",
        "Light": "Clar",
        "Dark": "Fosc",
        "High": "Alt",
        "Low": "Baix",
        "Play": "Reprodueix",
        "Pause": "Pausa",
        "Stop": "Atura",
        "Loading voice...": "S'està carregant la veu...",
        "Reading...": "S'està llegint...",
        "Profiles": "Perfils",
        "Seizure Safe": "Segur per a epilèpsia",
        "Vision Impaired": "Visió reduïda",
        "ADHD Friendly": "Adaptat per a TDAH",
        "Dyslexia Friendly": "Adaptat per a dislèxia",
        "On": "Activat",
        "Off": "Desactivat",
        "Mute Sounds": "Silencia els sons",
        "Page Structure": "Estructura de la pàgina",
        "Text Magnifier": "Lupa de text",
        "Headings": "Encapçalaments",
        "Landmarks": "Punts de referència",
        "Links": "Enllaços",
        "No items found": "No s'han trobat elements",
        "Settings reset": "S'ha restablert la configuració",
      },
      sl: {
        "Accessibility": "Dostopnost",
        "Accessibility Options": "Možnosti dostopnosti",
        "Accessibility Menu": "Meni dostopnosti",
        "Reset settings": "Ponastavi nastavitve",
        "Reset All Settings": "Ponastavi vse nastavitve",
        "Close": "Zapri",
        "Content Adjustments": "Prilagoditve vsebine",
        "Adjust Font Size": "Prilagodi velikost pisave",
        "Highlight Title": "Označi naslove",
        "Highlight Links": "Označi povezave",
        "Readable Font": "Berljiva pisava",
        "Color Adjustments": "Prilagoditve barv",
        "Invert Colors": "Obrni barve",
        "Light Contrast": "Svetli kontrast",
        "Dark Contrast": "Temni kontrast",
        "High Contrast": "Visok kontrast",
        "High Saturation": "Visoka nasičenost",
        "Low Saturation": "Nizka nasičenost",
        "Monochrome": "Enobarvno",
        "Tools": "Orodja",
        "Reading Guide": "Bralno ravnilo",
        "Stop Animations": "Ustavi animacije",
        "Big Cursor": "Velik kazalec",
        "Increase Font Size": "Povečaj pisavo",
        "Decrease Font Size": "Zmanjšaj pisavo",
        "Letter Spacing": "Razmik med črkami",
        "Line Height": "Razmik med vrsticami",
        "Font Weight": "Debelina pisave",
        "Dyslexia Font": "Pisava za disleksijo",
        "Legible Font": "Čitljiva pisava",
        "Font Size": "Velikost pisave",
        "Language": "Jezik",
        "All Languages": "Vsi jeziki",
        "Search language": "Išči jezik",
        "Open Accessibility Menu": "Odpri meni dostopnosti",
        "Open accessibility menu": "Odpri meni dostopnosti",
        "Hide Images": "Skrij slike",
        "Skip to accessibility menu": "Skoči na meni dostopnosti",
        "Accessibility Report": "Poročilo o dostopnosti",
        "Run Accessibility Check": "Zaženi preverjanje dostopnosti",
        "Loading...": "Nalaganje ...",
        "Analyzing page...": "Analiziranje strani ...",
        "Critical": "Kritično",
        "Serious": "Resno",
        "Moderate": "Zmerno",
        "Minor": "Manjše",
        "Violations Found": "Najdene težave",
        "No Issues Found": "Ni najdenih težav",
        "Element": "Element",
        "Issue": "Težava",
        "How to Fix": "Kako odpraviti",
        "Close Report": "Zapri poročilo",
        "Passed Tests": "Uspešni preizkusi",
        "Items Need Review": "Elementi za pregled",
        "Annotations": "Oznake",
        "Text to Speech": "Besedilo v govor",
        "Text to Speech On": "Besedilo v govor vklopljeno",
        "Text to Speech Off": "Besedilo v govor izklopljeno",
        "Simplify Layout": "Poenostavi postavitev",
        "Speech": "Govor",
        "Text": "Besedilo",
        "Color & Contrast": "Barva in kontrast",
        "Reading Aids": "Bralni pripomočki",
        "Interaction": "Interakcija",
        "Contrast": "Kontrast",
        "Saturation": "Nasičenost",
        "Light": "Svetlo",
        "Dark": "Temno",
        "High": "Visoko",
        "Low": "Nizko",
        "Play": "Predvajaj",
        "Pause": "Premor",
        "Stop": "Ustavi",
        "Loading voice...": "Nalaganje glasu ...",
        "Reading...": "Branje ...",
        "Profiles": "Profili",
        "Seizure Safe": "Varno pri epilepsiji",
        "Vision Impaired": "Okvara vida",
        "ADHD Friendly": "Prijazno za ADHD",
        "Dyslexia Friendly": "Prijazno za disleksijo",
        "On": "Vklopljeno",
        "Off": "Izklopljeno",
        "Mute Sounds": "Izklopi zvok",
        "Page Structure": "Struktura strani",
        "Text Magnifier": "Povečevalnik besedila",
        "Headings": "Naslovi",
        "Landmarks": "Mejniki",
        "Links": "Povezave",
        "No items found": "Ni najdenih elementov",
        "Settings reset": "Nastavitve so ponastavljene",
      },
      lv: {
        "Accessibility": "Piekļūstamība",
        "Accessibility Options": "Piekļūstamības opcijas",
        "Accessibility Menu": "Piekļūstamības izvēlne",
        "Reset settings": "Atiestatīt iestatījumus",
        "Reset All Settings": "Atiestatīt visus iestatījumus",
        "Close": "Aizvērt",
        "Content Adjustments": "Satura pielāgojumi",
        "Adjust Font Size": "Pielāgot fonta lielumu",
        "Highlight Title": "Izcelt virsrakstus",
        "Highlight Links": "Izcelt saites",
        "Readable Font": "Lasāms fonts",
        "Color Adjustments": "Krāsu pielāgojumi",
        "Invert Colors": "Invertēt krāsas",
        "Light Contrast": "Gaišs kontrasts",
        "Dark Contrast": "Tumšs kontrasts",
        "High Contrast": "Augsts kontrasts",
        "High Saturation": "Augsts piesātinājums",
        "Low Saturation": "Zems piesātinājums",
        "Monochrome": "Vienkrāsains",
        "Tools": "Rīki",
        "Reading Guide": "Lasīšanas līnija",
        "Stop Animations": "Apturēt animācijas",
        "Big Cursor": "Liels kursors",
        "Increase Font Size": "Palielināt fontu",
        "Decrease Font Size": "Samazināt fontu",
        "Letter Spacing": "Burtu atstarpe",
        "Line Height": "Rindstarpa",
        "Font Weight": "Fonta biezums",
        "Dyslexia Font": "Disleksijas fonts",
        "Legible Font": "Salasāms fonts",
        "Font Size": "Fonta lielums",
        "Language": "Valoda",
        "All Languages": "Visas valodas",
        "Search language": "Meklēt valodu",
        "Open Accessibility Menu": "Atvērt piekļūstamības izvēlni",
        "Open accessibility menu": "Atvērt piekļūstamības izvēlni",
        "Hide Images": "Paslēpt attēlus",
        "Skip to accessibility menu": "Pāriet uz piekļūstamības izvēlni",
        "Accessibility Report": "Piekļūstamības pārskats",
        "Run Accessibility Check": "Palaist piekļūstamības pārbaudi",
        "Loading...": "Notiek ielāde...",
        "Analyzing page...": "Analizē lapu...",
        "Critical": "Kritisks",
        "Serious": "Nopietns",
        "Moderate": "Mērens",
        "Minor": "Neliels",
        "Violations Found": "Atrastas problēmas",
        "No Issues Found": "Problēmas nav atrastas",
        "Element": "Elements",
        "Issue": "Problēma",
        "How to Fix": "Kā novērst",
        "Close Report": "Aizvērt pārskatu",
        "Passed Tests": "Izturētie testi",
        "Items Need Review": "Vienumi jāpārskata",
        "Annotations": "Anotācijas",
        "Text to Speech": "Teksta nolasīšana",
        "Text to Speech On": "Teksta nolasīšana ieslēgta",
        "Text to Speech Off": "Teksta nolasīšana izslēgta",
        "Simplify Layout": "Vienkāršot izkārtojumu",
        "Speech": "Runa",
        "Text": "Teksts",
        "Color & Contrast": "Krāsa un kontrasts",
        "Reading Aids": "Lasīšanas palīgi",
        "Interaction": "Mijiedarbība",
        "Contrast": "Kontrasts",
        "Saturation": "Piesātinājums",
        "Light": "Gaišs",
        "Dark": "Tumšs",
        "High": "Augsts",
        "Low": "Zems",
        "Play": "Atskaņot",
        "Pause": "Pauzēt",
        "Stop": "Apturēt",
        "Loading voice...": "Ielādē balsi...",
        "Reading...": "Lasa...",
        "Profiles": "Profili",
        "Seizure Safe": "Drošs epilepsijai",
        "Vision Impaired": "Redzes traucējumi",
        "ADHD Friendly": "ADHD draudzīgs",
        "Dyslexia Friendly": "Disleksijai draudzīgs",
        "On": "Ieslēgts",
        "Off": "Izslēgts",
        "Mute Sounds": "Izslēgt skaņu",
        "Page Structure": "Lapas struktūra",
        "Text Magnifier": "Teksta lupa",
        "Headings": "Virsraksti",
        "Landmarks": "Orientieri",
        "Links": "Saites",
        "No items found": "Nekas nav atrasts",
        "Settings reset": "Iestatījumi atiestatīti",
      },
      el: {
        "Accessibility": "Προσβασιμότητα",
        "Accessibility Options": "Επιλογές προσβασιμότητας",
        "Accessibility Menu": "Μενού προσβασιμότητας",
        "Reset settings": "Επαναφορά ρυθμίσεων",
        "Reset All Settings": "Επαναφορά όλων των ρυθμίσεων",
        "Close": "Κλείσιμο",
        "Content Adjustments": "Προσαρμογές περιεχομένου",
        "Adjust Font Size": "Προσαρμογή μεγέθους γραμματοσειράς",
        "Highlight Title": "Επισήμανση τίτλων",
        "Highlight Links": "Επισήμανση συνδέσμων",
        "Readable Font": "Ευανάγνωστη γραμματοσειρά",
        "Color Adjustments": "Προσαρμογές χρωμάτων",
        "Invert Colors": "Αντιστροφή χρωμάτων",
        "Light Contrast": "Φωτεινή αντίθεση",
        "Dark Contrast": "Σκοτεινή αντίθεση",
        "High Contrast": "Υψηλή αντίθεση",
        "High Saturation": "Υψηλός κορεσμός",
        "Low Saturation": "Χαμηλός κορεσμός",
        "Monochrome": "Μονόχρωμο",
        "Tools": "Εργαλεία",
        "Reading Guide": "Οδηγός ανάγνωσης",
        "Stop Animations": "Διακοπή κινούμενων στοιχείων",
        "Big Cursor": "Μεγάλος δείκτης",
        "Increase Font Size": "Αύξηση μεγέθους γραμματοσειράς",
        "Decrease Font Size": "Μείωση μεγέθους γραμματοσειράς",
        "Letter Spacing": "Απόσταση γραμμάτων",
        "Line Height": "Διάστιχο",
        "Font Weight": "Πάχος γραμματοσειράς",
        "Dyslexia Font": "Γραμματοσειρά για δυσλεξία",
        "Legible Font": "Καθαρή γραμματοσειρά",
        "Font Size": "Μέγεθος γραμματοσειράς",
        "Language": "Γλώσσα",
        "All Languages": "Όλες οι γλώσσες",
        "Search language": "Αναζήτηση γλώσσας",
        "Open Accessibility Menu": "Άνοιγμα μενού προσβασιμότητας",
        "Open accessibility menu": "Άνοιγμα μενού προσβασιμότητας",
        "Hide Images": "Απόκρυψη εικόνων",
        "Skip to accessibility menu": "Μετάβαση στο μενού προσβασιμότητας",
        "Accessibility Report": "Αναφορά προσβασιμότητας",
        "Run Accessibility Check": "Εκτέλεση ελέγχου προσβασιμότητας",
        "Loading...": "Φόρτωση...",
        "Analyzing page...": "Ανάλυση σελίδας...",
        "Critical": "Κρίσιμο",
        "Serious": "Σοβαρό",
        "Moderate": "Μέτριο",
        "Minor": "Μικρό",
        "Violations Found": "Βρέθηκαν προβλήματα",
        "No Issues Found": "Δεν βρέθηκαν προβλήματα",
        "Element": "Στοιχείο",
        "Issue": "Πρόβλημα",
        "How to Fix": "Τρόπος διόρθωσης",
        "Close Report": "Κλείσιμο αναφοράς",
        "Passed Tests": "Επιτυχημένοι έλεγχοι",
        "Items Need Review": "Στοιχεία προς έλεγχο",
        "Annotations": "Επισημάνσεις",
        "Text to Speech": "Κείμενο σε ομιλία",
        "Text to Speech On": "Κείμενο σε ομιλία ενεργό",
        "Text to Speech Off": "Κείμενο σε ομιλία ανενεργό",
        "Simplify Layout": "Απλοποίηση διάταξης",
        "Speech": "Ομιλία",
        "Text": "Κείμενο",
        "Color & Contrast": "Χρώμα και αντίθεση",
        "Reading Aids": "Βοηθήματα ανάγνωσης",
        "Interaction": "Αλληλεπίδραση",
        "Contrast": "Αντίθεση",
        "Saturation": "Κορεσμός",
        "Light": "Φωτεινό",
        "Dark": "Σκοτεινό",
        "High": "Υψηλό",
        "Low": "Χαμηλό",
        "Play": "Αναπαραγωγή",
        "Pause": "Παύση",
        "Stop": "Διακοπή",
        "Loading voice...": "Φόρτωση φωνής...",
        "Reading...": "Ανάγνωση...",
        "Profiles": "Προφίλ",
        "Seizure Safe": "Ασφαλές για επιληψία",
        "Vision Impaired": "Προβλήματα όρασης",
        "ADHD Friendly": "Φιλικό για ΔΕΠΥ",
        "Dyslexia Friendly": "Φιλικό για δυσλεξία",
        "On": "Ενεργό",
        "Off": "Ανενεργό",
        "Mute Sounds": "Σίγαση ήχων",
        "Page Structure": "Δομή σελίδας",
        "Text Magnifier": "Μεγεθυντής κειμένου",
        "Headings": "Επικεφαλίδες",
        "Landmarks": "Ορόσημα",
        "Links": "Σύνδεσμοι",
        "No items found": "Δεν βρέθηκαν στοιχεία",
        "Settings reset": "Οι ρυθμίσεις επαναφέρθηκαν",
      },
      ka: {
        "Accessibility": "ხელმისაწვდომობა",
        "Accessibility Options": "ხელმისაწვდომობის პარამეტრები",
        "Accessibility Menu": "ხელმისაწვდომობის მენიუ",
        "Reset settings": "პარამეტრების აღდგენა",
        "Reset All Settings": "ყველა პარამეტრის აღდგენა",
        "Close": "დახურვა",
        "Content Adjustments": "შინაარსის მორგება",
        "Adjust Font Size": "შრიფტის ზომის მორგება",
        "Highlight Title": "სათაურების გამოკვეთა",
        "Highlight Links": "ბმულების გამოკვეთა",
        "Readable Font": "ადვილად წასაკითხი შრიფტი",
        "Color Adjustments": "ფერების მორგება",
        "Invert Colors": "ფერების ინვერსია",
        "Light Contrast": "ღია კონტრასტი",
        "Dark Contrast": "მუქი კონტრასტი",
        "High Contrast": "მაღალი კონტრასტი",
        "High Saturation": "მაღალი გაჯერებულობა",
        "Low Saturation": "დაბალი გაჯერებულობა",
        "Monochrome": "მონოქრომული",
        "Tools": "ინსტრუმენტები",
        "Reading Guide": "კითხვის ხაზი",
        "Stop Animations": "ანიმაციების შეჩერება",
        "Big Cursor": "დიდი კურსორი",
        "Increase Font Size": "შრიფტის გაზრდა",
        "Decrease Font Size": "შრიფტის შემცირება",
        "Letter Spacing": "ასოებს შორის მანძილი",
        "Line Height": "სტრიქონებს შორის მანძილი",
        "Font Weight": "შრიფტის სისქე",
        "Dyslexia Font": "დისლექსიის შრიფტი",
        "Legible Font": "მკაფიო შრიფტი",
        "Font Size": "შრიფტის ზომა",
        "Language": "ენა",
        "All Languages": "ყველა ენა",
        "Search language": "ენის ძიება",
        "Open Accessibility Menu": "ხელმისაწვდომობის მენიუს გახსნა",
        "Open accessibility menu": "ხელმისაწვდომობის მენიუს გახსნა",
        "Hide Images": "სურათების დამალვა",
        "Skip to accessibility menu": "ხელმისაწვდომობის მენიუზე გადასვლა",
        "Accessibility Report": "ხელმისაწვდომობის ანგარიში",
        "Run Accessibility Check": "ხელმისაწვდომობის შემოწმების გაშვება",
        "Loading...": "იტვირთება...",
        "Analyzing page...": "გვერდის ანალიზი...",
        "Critical": "კრიტიკული",
        "Serious": "სერიოზული",
        "Moderate": "ზომიერი",
        "Minor": "მცირე",
        "Violations Found": "ნაპოვნია პრობლემები",
        "No Issues Found": "პრობლემები არ მოიძებნა",
        "Element": "ელემენტი",
        "Issue": "პრობლემა",
        "How to Fix": "როგორ გამოვასწოროთ",
        "Close Report": "ანგარიშის დახურვა",
        "Passed Tests": "წარმატებული ტესტები",
        "Items Need Review": "გადასამოწმებელი ელემენტები",
        "Annotations": "ანოტაციები",
        "Text to Speech": "ტექსტის გახმოვანება",
        "Text to Speech On": "ტექსტის გახმოვანება ჩართულია",
        "Text to Speech Off": "ტექსტის გახმოვანება გამორთულია",
        "Simplify Layout": "განლაგების გამარტივება",
        "Speech": "მეტყველება",
        "Text": "ტექსტი",
        "Color & Contrast": "ფერი და კონტრასტი",
        "Reading Aids": "კითხვის დამხმარეები",
        "Interaction": "ინტერაქცია",
        "Contrast": "კონტრასტი",
        "Saturation": "გაჯერებულობა",
        "Light": "ღია",
        "Dark": "მუქი",
        "High": "მაღალი",
        "Low": "დაბალი",
        "Play": "დაკვრა",
        "Pause": "პაუზა",
        "Stop": "შეჩერება",
        "Loading voice...": "ხმა იტვირთება...",
        "Reading...": "იკითხება...",
        "Profiles": "პროფილები",
        "Seizure Safe": "უსაფრთხო ეპილეფსიისთვის",
        "Vision Impaired": "მხედველობის დარღვევა",
        "ADHD Friendly": "მოსახერხებელი ADHD-სთვის",
        "Dyslexia Friendly": "მოსახერხებელი დისლექსიისთვის",
        "On": "ჩართულია",
        "Off": "გამორთულია",
        "Mute Sounds": "ხმის გამორთვა",
        "Page Structure": "გვერდის სტრუქტურა",
        "Text Magnifier": "ტექსტის გამადიდებელი",
        "Headings": "სათაურები",
        "Landmarks": "ორიენტირები",
        "Links": "ბმულები",
        "No items found": "ელემენტები არ მოიძებნა",
        "Settings reset": "პარამეტრები აღდგენილია",
      },
      am: {
        "Accessibility": "ተደራሽነት",
        "Accessibility Options": "የተደራሽነት አማራጮች",
        "Accessibility Menu": "የተደራሽነት ምናሌ",
        "Reset settings": "ቅንብሮችን ዳግም አስጀምር",
        "Reset All Settings": "ሁሉንም ቅንብሮች ዳግም አስጀምር",
        "Close": "ዝጋ",
        "Content Adjustments": "የይዘት ማስተካከያዎች",
        "Adjust Font Size": "የቅርጸ-ቁምፊ መጠን አስተካክል",
        "Highlight Title": "ርዕስን አድምቅ",
        "Highlight Links": "አገናኞችን አድምቅ",
        "Readable Font": "ተነባቢ ቅርጸ-ቁምፊ",
        "Color Adjustments": "የቀለም ማስተካከያዎች",
        "Invert Colors": "ቀለማትን ገልብጥ",
        "Light Contrast": "ብሩህ ንፅፅር",
        "Dark Contrast": "ጨለማ ንፅፅር",
        "High Contrast": "ከፍተኛ ንፅፅር",
        "High Saturation": "ከፍተኛ ሙሌት",
        "Low Saturation": "ዝቅተኛ ሙሌት",
        "Monochrome": "ነጠላ ቀለም",
        "Tools": "መሣሪያዎች",
        "Reading Guide": "የንባብ መሪ",
        "Stop Animations": "እነማዎችን አቁም",
        "Big Cursor": "ትልቅ ጠቋሚ",
        "Increase Font Size": "የቅርጸ-ቁምፊ መጠን ጨምር",
        "Decrease Font Size": "የቅርጸ-ቁምፊ መጠን ቀንስ",
        "Letter Spacing": "የፊደል ክፍተት",
        "Line Height": "የመስመር ቁመት",
        "Font Weight": "የቅርጸ-ቁምፊ ውፍረት",
        "Dyslexia Font": "የዲስሌክሲያ ቅርጸ-ቁምፊ",
        "Legible Font": "ግልጽ ቅርጸ-ቁምፊ",
        "Font Size": "የቅርጸ-ቁምፊ መጠን",
        "Language": "ቋንቋ",
        "All Languages": "ሁሉም ቋንቋዎች",
        "Search language": "ቋንቋ ፈልግ",
        "Open Accessibility Menu": "የተደራሽነት ምናሌ ክፈት",
        "Open accessibility menu": "የተደራሽነት ምናሌ ክፈት",
        "Hide Images": "ምስሎችን ደብቅ",
        "Skip to accessibility menu": "ወደ ተደራሽነት ምናሌ ዝለል",
        "Accessibility Report": "የተደራሽነት ሪፖርት",
        "Run Accessibility Check": "የተደራሽነት ፍተሻ አካሂድ",
        "Loading...": "በመጫን ላይ...",
        "Analyzing page...": "ገጹን በመተንተን ላይ...",
        "Critical": "ወሳኝ",
        "Serious": "ከባድ",
        "Moderate": "መካከለኛ",
        "Minor": "አነስተኛ",
        "Violations Found": "የተገኙ ጥሰቶች",
        "No Issues Found": "ምንም ችግር አልተገኘም",
        "Element": "አካል",
        "Issue": "ችግር",
        "How to Fix": "እንዴት እንደሚስተካከል",
        "Close Report": "ሪፖርቱን ዝጋ",
        "Passed Tests": "ያለፉ ፍተሻዎች",
        "Items Need Review": "ግምገማ የሚያስፈልጋቸው ንጥሎች",
        "Annotations": "ማብራሪያዎች",
        "Text to Speech": "ጽሑፍ ወደ ንግግር",
        "Text to Speech On": "ጽሑፍ ወደ ንግግር በርቷል",
        "Text to Speech Off": "ጽሑፍ ወደ ንግግር ጠፍቷል",
        "Simplify Layout": "አቀማመጥን አቃልል",
        "Speech": "ንግግር",
        "Text": "ጽሑፍ",
        "Color & Contrast": "ቀለም እና ንፅፅር",
        "Reading Aids": "የንባብ አጋዦች",
        "Interaction": "መስተጋብር",
        "Contrast": "ንፅፅር",
        "Saturation": "ሙሌት",
        "Light": "ብሩህ",
        "Dark": "ጨለማ",
        "High": "ከፍተኛ",
        "Low": "ዝቅተኛ",
        "Play": "አጫውት",
        "Pause": "ለአፍታ አቁም",
        "Stop": "አቁም",
        "Loading voice...": "ድምፅ በመጫን ላይ...",
        "Reading...": "በማንበብ ላይ...",
        "Profiles": "መገለጫዎች",
        "Seizure Safe": "ለሚጥል በሽታ አስተማማኝ",
        "Vision Impaired": "የእይታ እክል",
        "ADHD Friendly": "ለኤዲኤችዲ ምቹ",
        "Dyslexia Friendly": "ለዲስሌክሲያ ምቹ",
        "On": "በርቷል",
        "Off": "ጠፍቷል",
        "Mute Sounds": "ድምፆችን አጥፋ",
        "Page Structure": "የገጽ መዋቅር",
        "Text Magnifier": "የጽሑፍ ማጉያ",
        "Headings": "ርዕሶች",
        "Landmarks": "ምልክቶች",
        "Links": "አገናኞች",
        "No items found": "ምንም ንጥል አልተገኘም",
        "Settings reset": "ቅንብሮች ዳግም ተጀምረዋል",
      },
      bg: {
        "Accessibility": "Достъпност",
        "Accessibility Options": "Опции за достъпност",
        "Accessibility Menu": "Меню за достъпност",
        "Reset settings": "Нулиране на настройките",
        "Reset All Settings": "Нулиране на всички настройки",
        "Close": "Затвори",
        "Content Adjustments": "Настройки на съдържанието",
        "Adjust Font Size": "Промяна на размера на шрифта",
        "Highlight Title": "Открояване на заглавия",
        "Highlight Links": "Открояване на връзки",
        "Readable Font": "Четлив шрифт",
        "Color Adjustments": "Настройки на цветовете",
        "Invert Colors": "Инвертиране на цветовете",
        "Light Contrast": "Светъл контраст",
        "Dark Contrast": "Тъмен контраст",
        "High Contrast": "Висок контраст",
        "High Saturation": "Висока наситеност",
        "Low Saturation": "Ниска наситеност",
        "Monochrome": "Монохром",
        "Tools": "Инструменти",
        "Reading Guide": "Линия за четене",
        "Stop Animations": "Спиране на анимациите",
        "Big Cursor": "Голям курсор",
        "Increase Font Size": "Увеличаване на шрифта",
        "Decrease Font Size": "Намаляване на шрифта",
        "Letter Spacing": "Разстояние между буквите",
        "Line Height": "Междуредие",
        "Font Weight": "Дебелина на шрифта",
        "Dyslexia Font": "Шрифт за дислексия",
        "Legible Font": "Ясен шрифт",
        "Font Size": "Размер на шрифта",
        "Language": "Език",
        "All Languages": "Всички езици",
        "Search language": "Търсене на език",
        "Open Accessibility Menu": "Отваряне на менюто за достъпност",
        "Open accessibility menu": "Отваряне на менюто за достъпност",
        "Hide Images": "Скриване на изображенията",
        "Skip to accessibility menu": "Към менюто за достъпност",
        "Accessibility Report": "Доклад за достъпност",
        "Run Accessibility Check": "Стартиране на проверка за достъпност",
        "Loading...": "Зареждане...",
        "Analyzing page...": "Анализиране на страницата...",
        "Critical": "Критично",
        "Serious": "Сериозно",
        "Moderate": "Умерено",
        "Minor": "Незначително",
        "Violations Found": "Открити нарушения",
        "No Issues Found": "Не са открити проблеми",
        "Element": "Елемент",
        "Issue": "Проблем",
        "How to Fix": "Как да се поправи",
        "Close Report": "Затваряне на доклада",
        "Passed Tests": "Преминати тестове",
        "Items Need Review": "Елементи за преглед",
        "Annotations": "Анотации",
        "Text to Speech": "Четене на глас",
        "Text to Speech On": "Четене на глас: включено",
        "Text to Speech Off": "Четене на глас: изключено",
        "Simplify Layout": "Опростяване на изгледа",
        "Speech": "Говор",
        "Text": "Текст",
        "Color & Contrast": "Цвят и контраст",
        "Reading Aids": "Помощ при четене",
        "Interaction": "Взаимодействие",
        "Contrast": "Контраст",
        "Saturation": "Наситеност",
        "Light": "Светло",
        "Dark": "Тъмно",
        "High": "Високо",
        "Low": "Ниско",
        "Play": "Възпроизвеждане",
        "Pause": "Пауза",
        "Stop": "Стоп",
        "Loading voice...": "Зареждане на глас...",
        "Reading...": "Четене...",
        "Profiles": "Профили",
        "Seizure Safe": "Безопасен при епилепсия",
        "Vision Impaired": "За увредено зрение",
        "ADHD Friendly": "Подходящ при СДВХ",
        "Dyslexia Friendly": "Подходящ при дислексия",
        "On": "Вкл.",
        "Off": "Изкл.",
        "Mute Sounds": "Заглушаване на звука",
        "Page Structure": "Структура на страницата",
        "Text Magnifier": "Лупа за текст",
        "Headings": "Заглавия",
        "Landmarks": "Ориентири",
        "Links": "Връзки",
        "No items found": "Няма намерени елементи",
        "Settings reset": "Настройките са нулирани",
      },
      bn: {
        "Accessibility": "অ্যাক্সেসিবিলিটি",
        "Accessibility Options": "অ্যাক্সেসিবিলিটি অপশন",
        "Accessibility Menu": "অ্যাক্সেসিবিলিটি মেনু",
        "Reset settings": "সেটিংস রিসেট করুন",
        "Reset All Settings": "সব সেটিংস রিসেট করুন",
        "Close": "বন্ধ করুন",
        "Content Adjustments": "কনটেন্ট সমন্বয়",
        "Adjust Font Size": "ফন্টের আকার সমন্বয় করুন",
        "Highlight Title": "শিরোনাম হাইলাইট করুন",
        "Highlight Links": "লিঙ্ক হাইলাইট করুন",
        "Readable Font": "পাঠযোগ্য ফন্ট",
        "Color Adjustments": "রঙের সমন্বয়",
        "Invert Colors": "রং উল্টান",
        "Light Contrast": "হালকা কনট্রাস্ট",
        "Dark Contrast": "গাঢ় কনট্রাস্ট",
        "High Contrast": "উচ্চ কনট্রাস্ট",
        "High Saturation": "উচ্চ স্যাচুরেশন",
        "Low Saturation": "কম স্যাচুরেশন",
        "Monochrome": "একরঙা",
        "Tools": "টুলস",
        "Reading Guide": "পড়ার গাইড",
        "Stop Animations": "অ্যানিমেশন বন্ধ করুন",
        "Big Cursor": "বড় কার্সার",
        "Increase Font Size": "ফন্টের আকার বাড়ান",
        "Decrease Font Size": "ফন্টের আকার কমান",
        "Letter Spacing": "অক্ষরের ব্যবধান",
        "Line Height": "লাইনের উচ্চতা",
        "Font Weight": "ফন্টের পুরুত্ব",
        "Dyslexia Font": "ডিসলেক্সিয়া ফন্ট",
        "Legible Font": "সুস্পষ্ট ফন্ট",
        "Font Size": "ফন্টের আকার",
        "Language": "ভাষা",
        "All Languages": "সব ভাষা",
        "Search language": "ভাষা খুঁজুন",
        "Open Accessibility Menu": "অ্যাক্সেসিবিলিটি মেনু খুলুন",
        "Open accessibility menu": "অ্যাক্সেসিবিলিটি মেনু খুলুন",
        "Hide Images": "ছবি লুকান",
        "Skip to accessibility menu": "অ্যাক্সেসিবিলিটি মেনুতে যান",
        "Accessibility Report": "অ্যাক্সেসিবিলিটি রিপোর্ট",
        "Run Accessibility Check": "অ্যাক্সেসিবিলিটি পরীক্ষা চালান",
        "Loading...": "লোড হচ্ছে...",
        "Analyzing page...": "পৃষ্ঠা বিশ্লেষণ করা হচ্ছে...",
        "Critical": "অতি গুরুতর",
        "Serious": "গুরুতর",
        "Moderate": "মাঝারি",
        "Minor": "সামান্য",
        "Violations Found": "লঙ্ঘন পাওয়া গেছে",
        "No Issues Found": "কোনো সমস্যা পাওয়া যায়নি",
        "Element": "এলিমেন্ট",
        "Issue": "সমস্যা",
        "How to Fix": "কীভাবে ঠিক করবেন",
        "Close Report": "রিপোর্ট বন্ধ করুন",
        "Passed Tests": "উত্তীর্ণ পরীক্ষা",
        "Items Need Review": "পর্যালোচনা প্রয়োজন এমন আইটেম",
        "Annotations": "টীকা",
        "Text to Speech": "টেক্সট টু স্পিচ",
        "Text to Speech On": "টেক্সট টু স্পিচ চালু",
        "Text to Speech Off": "টেক্সট টু স্পিচ বন্ধ",
        "Simplify Layout": "লেআউট সরল করুন",
        "Speech": "স্পিচ",
        "Text": "টেক্সট",
        "Color & Contrast": "রং ও কনট্রাস্ট",
        "Reading Aids": "পড়ার সহায়তা",
        "Interaction": "ইন্টারঅ্যাকশন",
        "Contrast": "কনট্রাস্ট",
        "Saturation": "স্যাচুরেশন",
        "Light": "হালকা",
        "Dark": "গাঢ়",
        "High": "উচ্চ",
        "Low": "কম",
        "Play": "চালান",
        "Pause": "বিরতি দিন",
        "Stop": "থামান",
        "Loading voice...": "ভয়েস লোড হচ্ছে...",
        "Reading...": "পড়া হচ্ছে...",
        "Profiles": "প্রোফাইল",
        "Seizure Safe": "খিঁচুনি-নিরাপদ",
        "Vision Impaired": "দৃষ্টিপ্রতিবন্ধী",
        "ADHD Friendly": "এডিএইচডি-বান্ধব",
        "Dyslexia Friendly": "ডিসলেক্সিয়া-বান্ধব",
        "On": "চালু",
        "Off": "বন্ধ",
        "Mute Sounds": "শব্দ বন্ধ করুন",
        "Page Structure": "পৃষ্ঠার কাঠামো",
        "Text Magnifier": "টেক্সট ম্যাগনিফায়ার",
        "Headings": "শিরোনাম",
        "Landmarks": "ল্যান্ডমার্ক",
        "Links": "লিঙ্ক",
        "No items found": "কোনো আইটেম পাওয়া যায়নি",
        "Settings reset": "সেটিংস রিসেট হয়েছে",
      },
      cs: {
        "Accessibility": "Přístupnost",
        "Accessibility Options": "Možnosti přístupnosti",
        "Accessibility Menu": "Nabídka přístupnosti",
        "Reset settings": "Obnovit nastavení",
        "Reset All Settings": "Obnovit všechna nastavení",
        "Close": "Zavřít",
        "Content Adjustments": "Úpravy obsahu",
        "Adjust Font Size": "Upravit velikost písma",
        "Highlight Title": "Zvýraznit nadpisy",
        "Highlight Links": "Zvýraznit odkazy",
        "Readable Font": "Čitelné písmo",
        "Color Adjustments": "Úpravy barev",
        "Invert Colors": "Invertovat barvy",
        "Light Contrast": "Světlý kontrast",
        "Dark Contrast": "Tmavý kontrast",
        "High Contrast": "Vysoký kontrast",
        "High Saturation": "Vysoká sytost",
        "Low Saturation": "Nízká sytost",
        "Monochrome": "Monochromatický režim",
        "Tools": "Nástroje",
        "Reading Guide": "Vodítko pro čtení",
        "Stop Animations": "Zastavit animace",
        "Big Cursor": "Velký kurzor",
        "Increase Font Size": "Zvětšit písmo",
        "Decrease Font Size": "Zmenšit písmo",
        "Letter Spacing": "Mezery mezi písmeny",
        "Line Height": "Výška řádku",
        "Font Weight": "Tloušťka písma",
        "Dyslexia Font": "Písmo pro dyslektiky",
        "Legible Font": "Zřetelné písmo",
        "Font Size": "Velikost písma",
        "Language": "Jazyk",
        "All Languages": "Všechny jazyky",
        "Search language": "Hledat jazyk",
        "Open Accessibility Menu": "Otevřít nabídku přístupnosti",
        "Open accessibility menu": "Otevřít nabídku přístupnosti",
        "Hide Images": "Skrýt obrázky",
        "Skip to accessibility menu": "Přeskočit na nabídku přístupnosti",
        "Accessibility Report": "Zpráva o přístupnosti",
        "Run Accessibility Check": "Spustit kontrolu přístupnosti",
        "Loading...": "Načítání...",
        "Analyzing page...": "Probíhá analýza stránky...",
        "Critical": "Kritické",
        "Serious": "Závažné",
        "Moderate": "Střední",
        "Minor": "Drobné",
        "Violations Found": "Nalezená porušení",
        "No Issues Found": "Nebyly nalezeny žádné problémy",
        "Element": "Prvek",
        "Issue": "Problém",
        "How to Fix": "Jak opravit",
        "Close Report": "Zavřít zprávu",
        "Passed Tests": "Úspěšné testy",
        "Items Need Review": "Položky ke kontrole",
        "Annotations": "Anotace",
        "Text to Speech": "Předčítání textu",
        "Text to Speech On": "Předčítání textu zapnuto",
        "Text to Speech Off": "Předčítání textu vypnuto",
        "Simplify Layout": "Zjednodušit rozložení",
        "Speech": "Řeč",
        "Text": "Text",
        "Color & Contrast": "Barvy a kontrast",
        "Reading Aids": "Pomůcky pro čtení",
        "Interaction": "Interakce",
        "Contrast": "Kontrast",
        "Saturation": "Sytost",
        "Light": "Světlý",
        "Dark": "Tmavý",
        "High": "Vysoká",
        "Low": "Nízká",
        "Play": "Přehrát",
        "Pause": "Pozastavit",
        "Stop": "Zastavit",
        "Loading voice...": "Načítání hlasu...",
        "Reading...": "Předčítání...",
        "Profiles": "Profily",
        "Seizure Safe": "Bezpečné při epilepsii",
        "Vision Impaired": "Pro slabozraké",
        "ADHD Friendly": "Vhodné pro ADHD",
        "Dyslexia Friendly": "Vhodné pro dyslektiky",
        "On": "Zapnuto",
        "Off": "Vypnuto",
        "Mute Sounds": "Ztlumit zvuky",
        "Page Structure": "Struktura stránky",
        "Text Magnifier": "Textová lupa",
        "Headings": "Nadpisy",
        "Landmarks": "Orientační body",
        "Links": "Odkazy",
        "No items found": "Nebyly nalezeny žádné položky",
        "Settings reset": "Nastavení obnoveno",
      },
      fa: {
        "Accessibility": "دسترس‌پذیری",
        "Accessibility Options": "گزینه‌های دسترس‌پذیری",
        "Accessibility Menu": "منوی دسترس‌پذیری",
        "Reset settings": "بازنشانی تنظیمات",
        "Reset All Settings": "بازنشانی همهٔ تنظیمات",
        "Close": "بستن",
        "Content Adjustments": "تنظیمات محتوا",
        "Adjust Font Size": "تنظیم اندازهٔ قلم",
        "Highlight Title": "برجسته‌سازی عنوان‌ها",
        "Highlight Links": "برجسته‌سازی پیوندها",
        "Readable Font": "قلم خوانا",
        "Color Adjustments": "تنظیمات رنگ",
        "Invert Colors": "معکوس کردن رنگ‌ها",
        "Light Contrast": "کنتراست روشن",
        "Dark Contrast": "کنتراست تیره",
        "High Contrast": "کنتراست بالا",
        "High Saturation": "اشباع بالا",
        "Low Saturation": "اشباع پایین",
        "Monochrome": "تک‌رنگ",
        "Tools": "ابزارها",
        "Reading Guide": "راهنمای خواندن",
        "Stop Animations": "توقف انیمیشن‌ها",
        "Big Cursor": "اشاره‌گر بزرگ",
        "Increase Font Size": "افزایش اندازهٔ قلم",
        "Decrease Font Size": "کاهش اندازهٔ قلم",
        "Letter Spacing": "فاصلهٔ حروف",
        "Line Height": "فاصلهٔ خطوط",
        "Font Weight": "ضخامت قلم",
        "Dyslexia Font": "قلم مخصوص نارساخوانی",
        "Legible Font": "قلم واضح",
        "Font Size": "اندازهٔ قلم",
        "Language": "زبان",
        "All Languages": "همهٔ زبان‌ها",
        "Search language": "جستجوی زبان",
        "Open Accessibility Menu": "باز کردن منوی دسترس‌پذیری",
        "Open accessibility menu": "باز کردن منوی دسترس‌پذیری",
        "Hide Images": "پنهان کردن تصاویر",
        "Skip to accessibility menu": "پرش به منوی دسترس‌پذیری",
        "Accessibility Report": "گزارش دسترس‌پذیری",
        "Run Accessibility Check": "اجرای بررسی دسترس‌پذیری",
        "Loading...": "در حال بارگذاری...",
        "Analyzing page...": "در حال تحلیل صفحه...",
        "Critical": "بحرانی",
        "Serious": "جدی",
        "Moderate": "متوسط",
        "Minor": "جزئی",
        "Violations Found": "موارد نقض یافت‌شده",
        "No Issues Found": "مشکلی یافت نشد",
        "Element": "عنصر",
        "Issue": "مشکل",
        "How to Fix": "نحوهٔ رفع",
        "Close Report": "بستن گزارش",
        "Passed Tests": "آزمون‌های موفق",
        "Items Need Review": "موارد نیازمند بررسی",
        "Annotations": "حاشیه‌نویسی‌ها",
        "Text to Speech": "متن به گفتار",
        "Text to Speech On": "متن به گفتار روشن",
        "Text to Speech Off": "متن به گفتار خاموش",
        "Simplify Layout": "ساده‌سازی چیدمان",
        "Speech": "گفتار",
        "Text": "متن",
        "Color & Contrast": "رنگ و کنتراست",
        "Reading Aids": "کمک‌های خواندن",
        "Interaction": "تعامل",
        "Contrast": "کنتراست",
        "Saturation": "اشباع",
        "Light": "روشن",
        "Dark": "تیره",
        "High": "بالا",
        "Low": "پایین",
        "Play": "پخش",
        "Pause": "مکث",
        "Stop": "توقف",
        "Loading voice...": "در حال بارگذاری صدا...",
        "Reading...": "در حال خواندن...",
        "Profiles": "پروفایل‌ها",
        "Seizure Safe": "ایمن برای صرع",
        "Vision Impaired": "کم‌بینایی",
        "ADHD Friendly": "سازگار با بیش‌فعالی",
        "Dyslexia Friendly": "سازگار با نارساخوانی",
        "On": "روشن",
        "Off": "خاموش",
        "Mute Sounds": "قطع صدا",
        "Page Structure": "ساختار صفحه",
        "Text Magnifier": "ذره‌بین متن",
        "Headings": "سرفصل‌ها",
        "Landmarks": "مرزنماها",
        "Links": "پیوندها",
        "No items found": "موردی یافت نشد",
        "Settings reset": "تنظیمات بازنشانی شد",
      },
      fi: {
        "Accessibility": "Saavutettavuus",
        "Accessibility Options": "Saavutettavuusasetukset",
        "Accessibility Menu": "Saavutettavuusvalikko",
        "Reset settings": "Palauta asetukset",
        "Reset All Settings": "Palauta kaikki asetukset",
        "Close": "Sulje",
        "Content Adjustments": "Sisällön säädöt",
        "Adjust Font Size": "Säädä fonttikokoa",
        "Highlight Title": "Korosta otsikot",
        "Highlight Links": "Korosta linkit",
        "Readable Font": "Luettava fontti",
        "Color Adjustments": "Värisäädöt",
        "Invert Colors": "Käänteiset värit",
        "Light Contrast": "Vaalea kontrasti",
        "Dark Contrast": "Tumma kontrasti",
        "High Contrast": "Korkea kontrasti",
        "High Saturation": "Korkea värikylläisyys",
        "Low Saturation": "Matala värikylläisyys",
        "Monochrome": "Yksivärinen",
        "Tools": "Työkalut",
        "Reading Guide": "Lukuviivain",
        "Stop Animations": "Pysäytä animaatiot",
        "Big Cursor": "Suuri osoitin",
        "Increase Font Size": "Suurenna fonttikokoa",
        "Decrease Font Size": "Pienennä fonttikokoa",
        "Letter Spacing": "Kirjainväli",
        "Line Height": "Riviväli",
        "Font Weight": "Fontin paksuus",
        "Dyslexia Font": "Dysleksiafontti",
        "Legible Font": "Selkeä fontti",
        "Font Size": "Fonttikoko",
        "Language": "Kieli",
        "All Languages": "Kaikki kielet",
        "Search language": "Hae kieltä",
        "Open Accessibility Menu": "Avaa saavutettavuusvalikko",
        "Open accessibility menu": "Avaa saavutettavuusvalikko",
        "Hide Images": "Piilota kuvat",
        "Skip to accessibility menu": "Siirry saavutettavuusvalikkoon",
        "Accessibility Report": "Saavutettavuusraportti",
        "Run Accessibility Check": "Suorita saavutettavuustarkistus",
        "Loading...": "Ladataan...",
        "Analyzing page...": "Analysoidaan sivua...",
        "Critical": "Kriittinen",
        "Serious": "Vakava",
        "Moderate": "Kohtalainen",
        "Minor": "Vähäinen",
        "Violations Found": "Löydetyt rikkomukset",
        "No Issues Found": "Ongelmia ei löytynyt",
        "Element": "Elementti",
        "Issue": "Ongelma",
        "How to Fix": "Korjausohje",
        "Close Report": "Sulje raportti",
        "Passed Tests": "Läpäistyt testit",
        "Items Need Review": "Tarkistettavat kohteet",
        "Annotations": "Merkinnät",
        "Text to Speech": "Tekstistä puheeksi",
        "Text to Speech On": "Tekstistä puheeksi käytössä",
        "Text to Speech Off": "Tekstistä puheeksi pois käytöstä",
        "Simplify Layout": "Yksinkertaista asettelu",
        "Speech": "Puhe",
        "Text": "Teksti",
        "Color & Contrast": "Värit ja kontrasti",
        "Reading Aids": "Lukemisen apuvälineet",
        "Interaction": "Vuorovaikutus",
        "Contrast": "Kontrasti",
        "Saturation": "Värikylläisyys",
        "Light": "Vaalea",
        "Dark": "Tumma",
        "High": "Korkea",
        "Low": "Matala",
        "Play": "Toista",
        "Pause": "Keskeytä",
        "Stop": "Pysäytä",
        "Loading voice...": "Ladataan ääntä...",
        "Reading...": "Luetaan...",
        "Profiles": "Profiilit",
        "Seizure Safe": "Epilepsiaturvallinen",
        "Vision Impaired": "Näkövammaiset",
        "ADHD Friendly": "ADHD-ystävällinen",
        "Dyslexia Friendly": "Dysleksiaystävällinen",
        "On": "Päällä",
        "Off": "Pois",
        "Mute Sounds": "Mykistä äänet",
        "Page Structure": "Sivun rakenne",
        "Text Magnifier": "Tekstin suurennuslasi",
        "Headings": "Otsikot",
        "Landmarks": "Maamerkit",
        "Links": "Linkit",
        "No items found": "Kohteita ei löytynyt",
        "Settings reset": "Asetukset palautettu",
      },
      fil: {
        "Accessibility": "Accessibility",
        "Accessibility Options": "Mga Opsyon sa Accessibility",
        "Accessibility Menu": "Menu ng Accessibility",
        "Reset settings": "I-reset ang mga setting",
        "Reset All Settings": "I-reset ang Lahat ng Setting",
        "Close": "Isara",
        "Content Adjustments": "Mga Pagsasaayos sa Nilalaman",
        "Adjust Font Size": "Isaayos ang Laki ng Font",
        "Highlight Title": "I-highlight ang Pamagat",
        "Highlight Links": "I-highlight ang Mga Link",
        "Readable Font": "Nababasang Font",
        "Color Adjustments": "Mga Pagsasaayos sa Kulay",
        "Invert Colors": "I-invert ang Mga Kulay",
        "Light Contrast": "Maliwanag na Contrast",
        "Dark Contrast": "Madilim na Contrast",
        "High Contrast": "Mataas na Contrast",
        "High Saturation": "Mataas na Saturation",
        "Low Saturation": "Mababang Saturation",
        "Monochrome": "Monochrome",
        "Tools": "Mga Tool",
        "Reading Guide": "Gabay sa Pagbabasa",
        "Stop Animations": "Ihinto ang Mga Animation",
        "Big Cursor": "Malaking Cursor",
        "Increase Font Size": "Palakihin ang Font",
        "Decrease Font Size": "Paliitin ang Font",
        "Letter Spacing": "Pagitan ng Mga Titik",
        "Line Height": "Taas ng Linya",
        "Font Weight": "Kapal ng Font",
        "Dyslexia Font": "Font para sa Dyslexia",
        "Legible Font": "Malinaw na Font",
        "Font Size": "Laki ng Font",
        "Language": "Wika",
        "All Languages": "Lahat ng Wika",
        "Search language": "Maghanap ng wika",
        "Open Accessibility Menu": "Buksan ang Menu ng Accessibility",
        "Open accessibility menu": "Buksan ang menu ng accessibility",
        "Hide Images": "Itago ang Mga Larawan",
        "Skip to accessibility menu": "Lumaktaw sa menu ng accessibility",
        "Accessibility Report": "Ulat sa Accessibility",
        "Run Accessibility Check": "Patakbuhin ang Pagsusuri sa Accessibility",
        "Loading...": "Naglo-load...",
        "Analyzing page...": "Sinusuri ang pahina...",
        "Critical": "Kritikal",
        "Serious": "Malubha",
        "Moderate": "Katamtaman",
        "Minor": "Maliit",
        "Violations Found": "Mga Nakitang Paglabag",
        "No Issues Found": "Walang Nakitang Isyu",
        "Element": "Elemento",
        "Issue": "Isyu",
        "How to Fix": "Paano Aayusin",
        "Close Report": "Isara ang Ulat",
        "Passed Tests": "Mga Pumasang Pagsusuri",
        "Items Need Review": "Mga Item na Kailangang Suriin",
        "Annotations": "Mga Anotasyon",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Naka-on ang Text to Speech",
        "Text to Speech Off": "Naka-off ang Text to Speech",
        "Simplify Layout": "Pasimplehin ang Layout",
        "Speech": "Pagsasalita",
        "Text": "Teksto",
        "Color & Contrast": "Kulay at Contrast",
        "Reading Aids": "Mga Tulong sa Pagbabasa",
        "Interaction": "Interaksyon",
        "Contrast": "Contrast",
        "Saturation": "Saturation",
        "Light": "Maliwanag",
        "Dark": "Madilim",
        "High": "Mataas",
        "Low": "Mababa",
        "Play": "I-play",
        "Pause": "I-pause",
        "Stop": "Ihinto",
        "Loading voice...": "Naglo-load ng boses...",
        "Reading...": "Binabasa...",
        "Profiles": "Mga Profile",
        "Seizure Safe": "Ligtas sa Seizure",
        "Vision Impaired": "May Kapansanan sa Paningin",
        "ADHD Friendly": "Angkop sa ADHD",
        "Dyslexia Friendly": "Angkop sa Dyslexia",
        "On": "Naka-on",
        "Off": "Naka-off",
        "Mute Sounds": "I-mute ang Mga Tunog",
        "Page Structure": "Istruktura ng Pahina",
        "Text Magnifier": "Pampalaki ng Teksto",
        "Headings": "Mga Heading",
        "Landmarks": "Mga Landmark",
        "Links": "Mga Link",
        "No items found": "Walang nakitang item",
        "Settings reset": "Na-reset ang mga setting",
      },
      hi: {
        "Accessibility": "सुलभता",
        "Accessibility Options": "सुलभता विकल्प",
        "Accessibility Menu": "सुलभता मेनू",
        "Reset settings": "सेटिंग्स रीसेट करें",
        "Reset All Settings": "सभी सेटिंग्स रीसेट करें",
        "Close": "बंद करें",
        "Content Adjustments": "सामग्री समायोजन",
        "Adjust Font Size": "फ़ॉन्ट आकार समायोजित करें",
        "Highlight Title": "शीर्षक हाइलाइट करें",
        "Highlight Links": "लिंक हाइलाइट करें",
        "Readable Font": "पठनीय फ़ॉन्ट",
        "Color Adjustments": "रंग समायोजन",
        "Invert Colors": "रंग उलटें",
        "Light Contrast": "हल्का कंट्रास्ट",
        "Dark Contrast": "गहरा कंट्रास्ट",
        "High Contrast": "उच्च कंट्रास्ट",
        "High Saturation": "उच्च सैचुरेशन",
        "Low Saturation": "कम सैचुरेशन",
        "Monochrome": "मोनोक्रोम",
        "Tools": "टूल्स",
        "Reading Guide": "पठन गाइड",
        "Stop Animations": "एनिमेशन रोकें",
        "Big Cursor": "बड़ा कर्सर",
        "Increase Font Size": "फ़ॉन्ट आकार बढ़ाएँ",
        "Decrease Font Size": "फ़ॉन्ट आकार घटाएँ",
        "Letter Spacing": "अक्षर अंतराल",
        "Line Height": "पंक्ति ऊँचाई",
        "Font Weight": "फ़ॉन्ट मोटाई",
        "Dyslexia Font": "डिस्लेक्सिया फ़ॉन्ट",
        "Legible Font": "सुपाठ्य फ़ॉन्ट",
        "Font Size": "फ़ॉन्ट आकार",
        "Language": "भाषा",
        "All Languages": "सभी भाषाएँ",
        "Search language": "भाषा खोजें",
        "Open Accessibility Menu": "सुलभता मेनू खोलें",
        "Open accessibility menu": "सुलभता मेनू खोलें",
        "Hide Images": "छवियाँ छिपाएँ",
        "Skip to accessibility menu": "सुलभता मेनू पर जाएँ",
        "Accessibility Report": "सुलभता रिपोर्ट",
        "Run Accessibility Check": "सुलभता जाँच चलाएँ",
        "Loading...": "लोड हो रहा है...",
        "Analyzing page...": "पृष्ठ का विश्लेषण हो रहा है...",
        "Critical": "अति गंभीर",
        "Serious": "गंभीर",
        "Moderate": "मध्यम",
        "Minor": "मामूली",
        "Violations Found": "उल्लंघन पाए गए",
        "No Issues Found": "कोई समस्या नहीं मिली",
        "Element": "एलिमेंट",
        "Issue": "समस्या",
        "How to Fix": "ठीक करने का तरीका",
        "Close Report": "रिपोर्ट बंद करें",
        "Passed Tests": "पास हुए परीक्षण",
        "Items Need Review": "समीक्षा के लिए आइटम",
        "Annotations": "एनोटेशन",
        "Text to Speech": "टेक्स्ट-टू-स्पीच",
        "Text to Speech On": "टेक्स्ट-टू-स्पीच चालू",
        "Text to Speech Off": "टेक्स्ट-टू-स्पीच बंद",
        "Simplify Layout": "लेआउट सरल करें",
        "Speech": "स्पीच",
        "Text": "टेक्स्ट",
        "Color & Contrast": "रंग और कंट्रास्ट",
        "Reading Aids": "पठन सहायता",
        "Interaction": "इंटरैक्शन",
        "Contrast": "कंट्रास्ट",
        "Saturation": "सैचुरेशन",
        "Light": "हल्का",
        "Dark": "गहरा",
        "High": "उच्च",
        "Low": "कम",
        "Play": "चलाएँ",
        "Pause": "पॉज़ करें",
        "Stop": "रोकें",
        "Loading voice...": "आवाज़ लोड हो रही है...",
        "Reading...": "पढ़ा जा रहा है...",
        "Profiles": "प्रोफ़ाइल",
        "Seizure Safe": "मिर्गी सुरक्षित",
        "Vision Impaired": "दृष्टिबाधित",
        "ADHD Friendly": "एडीएचडी अनुकूल",
        "Dyslexia Friendly": "डिस्लेक्सिया अनुकूल",
        "On": "चालू",
        "Off": "बंद",
        "Mute Sounds": "ध्वनि म्यूट करें",
        "Page Structure": "पृष्ठ संरचना",
        "Text Magnifier": "टेक्स्ट आवर्धक",
        "Headings": "हेडिंग",
        "Landmarks": "लैंडमार्क",
        "Links": "लिंक",
        "No items found": "कोई आइटम नहीं मिला",
        "Settings reset": "सेटिंग्स रीसेट हो गईं",
      },
      hr: {
        "Accessibility": "Pristupačnost",
        "Accessibility Options": "Opcije pristupačnosti",
        "Accessibility Menu": "Izbornik pristupačnosti",
        "Reset settings": "Vrati postavke na zadano",
        "Reset All Settings": "Vrati sve postavke na zadano",
        "Close": "Zatvori",
        "Content Adjustments": "Prilagodbe sadržaja",
        "Adjust Font Size": "Prilagodi veličinu fonta",
        "Highlight Title": "Istakni naslove",
        "Highlight Links": "Istakni poveznice",
        "Readable Font": "Čitljiv font",
        "Color Adjustments": "Prilagodbe boja",
        "Invert Colors": "Invertiraj boje",
        "Light Contrast": "Svijetli kontrast",
        "Dark Contrast": "Tamni kontrast",
        "High Contrast": "Visoki kontrast",
        "High Saturation": "Visoka zasićenost",
        "Low Saturation": "Niska zasićenost",
        "Monochrome": "Monokromatski",
        "Tools": "Alati",
        "Reading Guide": "Vodilica za čitanje",
        "Stop Animations": "Zaustavi animacije",
        "Big Cursor": "Veliki pokazivač",
        "Increase Font Size": "Povećaj veličinu fonta",
        "Decrease Font Size": "Smanji veličinu fonta",
        "Letter Spacing": "Razmak između slova",
        "Line Height": "Prored",
        "Font Weight": "Debljina fonta",
        "Dyslexia Font": "Font za disleksiju",
        "Legible Font": "Čitak font",
        "Font Size": "Veličina fonta",
        "Language": "Jezik",
        "All Languages": "Svi jezici",
        "Search language": "Pretraži jezike",
        "Open Accessibility Menu": "Otvori izbornik pristupačnosti",
        "Open accessibility menu": "Otvori izbornik pristupačnosti",
        "Hide Images": "Sakrij slike",
        "Skip to accessibility menu": "Preskoči na izbornik pristupačnosti",
        "Accessibility Report": "Izvješće o pristupačnosti",
        "Run Accessibility Check": "Pokreni provjeru pristupačnosti",
        "Loading...": "Učitavanje...",
        "Analyzing page...": "Analiza stranice...",
        "Critical": "Kritično",
        "Serious": "Ozbiljno",
        "Moderate": "Umjereno",
        "Minor": "Blago",
        "Violations Found": "Pronađena kršenja",
        "No Issues Found": "Nema pronađenih problema",
        "Element": "Element",
        "Issue": "Problem",
        "How to Fix": "Kako ispraviti",
        "Close Report": "Zatvori izvješće",
        "Passed Tests": "Uspješni testovi",
        "Items Need Review": "Stavke za provjeru",
        "Annotations": "Oznake",
        "Text to Speech": "Tekst u govor",
        "Text to Speech On": "Tekst u govor uključen",
        "Text to Speech Off": "Tekst u govor isključen",
        "Simplify Layout": "Pojednostavi prikaz",
        "Speech": "Govor",
        "Text": "Tekst",
        "Color & Contrast": "Boje i kontrast",
        "Reading Aids": "Pomagala za čitanje",
        "Interaction": "Interakcija",
        "Contrast": "Kontrast",
        "Saturation": "Zasićenost",
        "Light": "Svijetlo",
        "Dark": "Tamno",
        "High": "Visoko",
        "Low": "Nisko",
        "Play": "Reproduciraj",
        "Pause": "Pauziraj",
        "Stop": "Zaustavi",
        "Loading voice...": "Učitavanje glasa...",
        "Reading...": "Čitanje...",
        "Profiles": "Profili",
        "Seizure Safe": "Sigurno za epilepsiju",
        "Vision Impaired": "Oštećenje vida",
        "ADHD Friendly": "Prilagođeno za ADHD",
        "Dyslexia Friendly": "Prilagođeno za disleksiju",
        "On": "Uključeno",
        "Off": "Isključeno",
        "Mute Sounds": "Isključi zvukove",
        "Page Structure": "Struktura stranice",
        "Text Magnifier": "Povećalo teksta",
        "Headings": "Naslovi",
        "Landmarks": "Orijentiri",
        "Links": "Poveznice",
        "No items found": "Nema pronađenih stavki",
        "Settings reset": "Postavke su vraćene na zadano",
      },
      hu: {
        "Accessibility": "Akadálymentesítés",
        "Accessibility Options": "Akadálymentesítési beállítások",
        "Accessibility Menu": "Akadálymentesítési menü",
        "Reset settings": "Beállítások visszaállítása",
        "Reset All Settings": "Összes beállítás visszaállítása",
        "Close": "Bezárás",
        "Content Adjustments": "Tartalmi beállítások",
        "Adjust Font Size": "Betűméret módosítása",
        "Highlight Title": "Címek kiemelése",
        "Highlight Links": "Hivatkozások kiemelése",
        "Readable Font": "Olvasható betűtípus",
        "Color Adjustments": "Színbeállítások",
        "Invert Colors": "Színek invertálása",
        "Light Contrast": "Világos kontraszt",
        "Dark Contrast": "Sötét kontraszt",
        "High Contrast": "Magas kontraszt",
        "High Saturation": "Magas telítettség",
        "Low Saturation": "Alacsony telítettség",
        "Monochrome": "Monokróm",
        "Tools": "Eszközök",
        "Reading Guide": "Olvasási segédvonal",
        "Stop Animations": "Animációk leállítása",
        "Big Cursor": "Nagy kurzor",
        "Increase Font Size": "Betűméret növelése",
        "Decrease Font Size": "Betűméret csökkentése",
        "Letter Spacing": "Betűköz",
        "Line Height": "Sormagasság",
        "Font Weight": "Betűvastagság",
        "Dyslexia Font": "Diszlexiabarát betűtípus",
        "Legible Font": "Könnyen olvasható betűtípus",
        "Font Size": "Betűméret",
        "Language": "Nyelv",
        "All Languages": "Összes nyelv",
        "Search language": "Nyelv keresése",
        "Open Accessibility Menu": "Akadálymentesítési menü megnyitása",
        "Open accessibility menu": "Akadálymentesítési menü megnyitása",
        "Hide Images": "Képek elrejtése",
        "Skip to accessibility menu": "Ugrás az akadálymentesítési menüre",
        "Accessibility Report": "Akadálymentesítési jelentés",
        "Run Accessibility Check": "Akadálymentesítési ellenőrzés futtatása",
        "Loading...": "Betöltés...",
        "Analyzing page...": "Oldal elemzése...",
        "Critical": "Kritikus",
        "Serious": "Súlyos",
        "Moderate": "Közepes",
        "Minor": "Enyhe",
        "Violations Found": "Talált hibák",
        "No Issues Found": "Nem található probléma",
        "Element": "Elem",
        "Issue": "Probléma",
        "How to Fix": "Javítás módja",
        "Close Report": "Jelentés bezárása",
        "Passed Tests": "Sikeres tesztek",
        "Items Need Review": "Ellenőrzendő elemek",
        "Annotations": "Jelölések",
        "Text to Speech": "Szövegfelolvasás",
        "Text to Speech On": "Szövegfelolvasás bekapcsolva",
        "Text to Speech Off": "Szövegfelolvasás kikapcsolva",
        "Simplify Layout": "Elrendezés egyszerűsítése",
        "Speech": "Beszéd",
        "Text": "Szöveg",
        "Color & Contrast": "Szín és kontraszt",
        "Reading Aids": "Olvasási segédeszközök",
        "Interaction": "Interakció",
        "Contrast": "Kontraszt",
        "Saturation": "Telítettség",
        "Light": "Világos",
        "Dark": "Sötét",
        "High": "Magas",
        "Low": "Alacsony",
        "Play": "Lejátszás",
        "Pause": "Szünet",
        "Stop": "Leállítás",
        "Loading voice...": "Hang betöltése...",
        "Reading...": "Felolvasás...",
        "Profiles": "Profilok",
        "Seizure Safe": "Epilepsziabiztos",
        "Vision Impaired": "Látássérült",
        "ADHD Friendly": "ADHD-barát",
        "Dyslexia Friendly": "Diszlexiabarát",
        "On": "Be",
        "Off": "Ki",
        "Mute Sounds": "Hangok némítása",
        "Page Structure": "Oldalszerkezet",
        "Text Magnifier": "Szövegnagyító",
        "Headings": "Címsorok",
        "Landmarks": "Tájékozódási pontok",
        "Links": "Hivatkozások",
        "No items found": "Nincs találat",
        "Settings reset": "Beállítások visszaállítva",
      },
      id: {
        "Accessibility": "Aksesibilitas",
        "Accessibility Options": "Opsi Aksesibilitas",
        "Accessibility Menu": "Menu Aksesibilitas",
        "Reset settings": "Atur ulang pengaturan",
        "Reset All Settings": "Atur Ulang Semua Pengaturan",
        "Close": "Tutup",
        "Content Adjustments": "Penyesuaian Konten",
        "Adjust Font Size": "Sesuaikan Ukuran Font",
        "Highlight Title": "Sorot Judul",
        "Highlight Links": "Sorot Tautan",
        "Readable Font": "Font Mudah Dibaca",
        "Color Adjustments": "Penyesuaian Warna",
        "Invert Colors": "Balikkan Warna",
        "Light Contrast": "Kontras Terang",
        "Dark Contrast": "Kontras Gelap",
        "High Contrast": "Kontras Tinggi",
        "High Saturation": "Saturasi Tinggi",
        "Low Saturation": "Saturasi Rendah",
        "Monochrome": "Monokrom",
        "Tools": "Alat",
        "Reading Guide": "Panduan Membaca",
        "Stop Animations": "Hentikan Animasi",
        "Big Cursor": "Kursor Besar",
        "Increase Font Size": "Perbesar Ukuran Font",
        "Decrease Font Size": "Perkecil Ukuran Font",
        "Letter Spacing": "Jarak Huruf",
        "Line Height": "Jarak Baris",
        "Font Weight": "Ketebalan Font",
        "Dyslexia Font": "Font Disleksia",
        "Legible Font": "Font Jelas",
        "Font Size": "Ukuran Font",
        "Language": "Bahasa",
        "All Languages": "Semua Bahasa",
        "Search language": "Cari bahasa",
        "Open Accessibility Menu": "Buka Menu Aksesibilitas",
        "Open accessibility menu": "Buka menu aksesibilitas",
        "Hide Images": "Sembunyikan Gambar",
        "Skip to accessibility menu": "Langsung ke menu aksesibilitas",
        "Accessibility Report": "Laporan Aksesibilitas",
        "Run Accessibility Check": "Jalankan Pemeriksaan Aksesibilitas",
        "Loading...": "Memuat...",
        "Analyzing page...": "Menganalisis halaman...",
        "Critical": "Kritis",
        "Serious": "Serius",
        "Moderate": "Sedang",
        "Minor": "Ringan",
        "Violations Found": "Pelanggaran Ditemukan",
        "No Issues Found": "Tidak Ditemukan Masalah",
        "Element": "Elemen",
        "Issue": "Masalah",
        "How to Fix": "Cara Memperbaiki",
        "Close Report": "Tutup Laporan",
        "Passed Tests": "Tes yang Lolos",
        "Items Need Review": "Item Perlu Ditinjau",
        "Annotations": "Anotasi",
        "Text to Speech": "Teks ke Ucapan",
        "Text to Speech On": "Teks ke Ucapan Aktif",
        "Text to Speech Off": "Teks ke Ucapan Nonaktif",
        "Simplify Layout": "Sederhanakan Tata Letak",
        "Speech": "Ucapan",
        "Text": "Teks",
        "Color & Contrast": "Warna & Kontras",
        "Reading Aids": "Alat Bantu Baca",
        "Interaction": "Interaksi",
        "Contrast": "Kontras",
        "Saturation": "Saturasi",
        "Light": "Terang",
        "Dark": "Gelap",
        "High": "Tinggi",
        "Low": "Rendah",
        "Play": "Putar",
        "Pause": "Jeda",
        "Stop": "Berhenti",
        "Loading voice...": "Memuat suara...",
        "Reading...": "Membaca...",
        "Profiles": "Profil",
        "Seizure Safe": "Aman dari Kejang",
        "Vision Impaired": "Gangguan Penglihatan",
        "ADHD Friendly": "Ramah ADHD",
        "Dyslexia Friendly": "Ramah Disleksia",
        "On": "Aktif",
        "Off": "Nonaktif",
        "Mute Sounds": "Bisukan Suara",
        "Page Structure": "Struktur Halaman",
        "Text Magnifier": "Pembesar Teks",
        "Headings": "Judul",
        "Landmarks": "Landmark",
        "Links": "Tautan",
        "No items found": "Tidak ada item yang ditemukan",
        "Settings reset": "Pengaturan diatur ulang",
      },
      ja: {
        "Accessibility": "アクセシビリティ",
        "Accessibility Options": "アクセシビリティオプション",
        "Accessibility Menu": "アクセシビリティメニュー",
        "Reset settings": "設定をリセット",
        "Reset All Settings": "すべての設定をリセット",
        "Close": "閉じる",
        "Content Adjustments": "コンテンツの調整",
        "Adjust Font Size": "文字サイズの調整",
        "Highlight Title": "タイトルを強調表示",
        "Highlight Links": "リンクを強調表示",
        "Readable Font": "読みやすいフォント",
        "Color Adjustments": "色の調整",
        "Invert Colors": "色を反転",
        "Light Contrast": "ライトコントラスト",
        "Dark Contrast": "ダークコントラスト",
        "High Contrast": "ハイコントラスト",
        "High Saturation": "高彩度",
        "Low Saturation": "低彩度",
        "Monochrome": "モノクロ",
        "Tools": "ツール",
        "Reading Guide": "リーディングガイド",
        "Stop Animations": "アニメーションを停止",
        "Big Cursor": "大きなカーソル",
        "Increase Font Size": "文字サイズを拡大",
        "Decrease Font Size": "文字サイズを縮小",
        "Letter Spacing": "文字間隔",
        "Line Height": "行間",
        "Font Weight": "文字の太さ",
        "Dyslexia Font": "ディスレクシア対応フォント",
        "Legible Font": "視認性の高いフォント",
        "Font Size": "文字サイズ",
        "Language": "言語",
        "All Languages": "すべての言語",
        "Search language": "言語を検索",
        "Open Accessibility Menu": "アクセシビリティメニューを開く",
        "Open accessibility menu": "アクセシビリティメニューを開く",
        "Hide Images": "画像を非表示",
        "Skip to accessibility menu": "アクセシビリティメニューへスキップ",
        "Accessibility Report": "アクセシビリティレポート",
        "Run Accessibility Check": "アクセシビリティチェックを実行",
        "Loading...": "読み込み中…",
        "Analyzing page...": "ページを分析中…",
        "Critical": "重大",
        "Serious": "深刻",
        "Moderate": "中程度",
        "Minor": "軽微",
        "Violations Found": "検出された違反",
        "No Issues Found": "問題は見つかりませんでした",
        "Element": "要素",
        "Issue": "問題",
        "How to Fix": "修正方法",
        "Close Report": "レポートを閉じる",
        "Passed Tests": "合格したテスト",
        "Items Need Review": "要確認の項目",
        "Annotations": "注釈",
        "Text to Speech": "テキスト読み上げ",
        "Text to Speech On": "テキスト読み上げオン",
        "Text to Speech Off": "テキスト読み上げオフ",
        "Simplify Layout": "レイアウトを簡素化",
        "Speech": "音声",
        "Text": "テキスト",
        "Color & Contrast": "色とコントラスト",
        "Reading Aids": "読書補助",
        "Interaction": "操作",
        "Contrast": "コントラスト",
        "Saturation": "彩度",
        "Light": "ライト",
        "Dark": "ダーク",
        "High": "高",
        "Low": "低",
        "Play": "再生",
        "Pause": "一時停止",
        "Stop": "停止",
        "Loading voice...": "音声を読み込み中…",
        "Reading...": "読み上げ中…",
        "Profiles": "プロファイル",
        "Seizure Safe": "発作予防",
        "Vision Impaired": "視覚障害対応",
        "ADHD Friendly": "ADHD対応",
        "Dyslexia Friendly": "ディスレクシア対応",
        "On": "オン",
        "Off": "オフ",
        "Mute Sounds": "サウンドをミュート",
        "Page Structure": "ページ構造",
        "Text Magnifier": "テキスト拡大鏡",
        "Headings": "見出し",
        "Landmarks": "ランドマーク",
        "Links": "リンク",
        "No items found": "項目が見つかりません",
        "Settings reset": "設定をリセットしました",
      },
      kn: {
        "Accessibility": "ಪ್ರವೇಶಿಸುವಿಕೆ",
        "Accessibility Options": "ಪ್ರವೇಶಿಸುವಿಕೆ ಆಯ್ಕೆಗಳು",
        "Accessibility Menu": "ಪ್ರವೇಶಿಸುವಿಕೆ ಮೆನು",
        "Reset settings": "ಸೆಟ್ಟಿಂಗ್‌ಗಳನ್ನು ಮರುಹೊಂದಿಸಿ",
        "Reset All Settings": "ಎಲ್ಲಾ ಸೆಟ್ಟಿಂಗ್‌ಗಳನ್ನು ಮರುಹೊಂದಿಸಿ",
        "Close": "ಮುಚ್ಚಿ",
        "Content Adjustments": "ವಿಷಯ ಹೊಂದಾಣಿಕೆಗಳು",
        "Adjust Font Size": "ಫಾಂಟ್ ಗಾತ್ರ ಹೊಂದಿಸಿ",
        "Highlight Title": "ಶೀರ್ಷಿಕೆ ಹೈಲೈಟ್ ಮಾಡಿ",
        "Highlight Links": "ಲಿಂಕ್‌ಗಳನ್ನು ಹೈಲೈಟ್ ಮಾಡಿ",
        "Readable Font": "ಓದಬಹುದಾದ ಫಾಂಟ್",
        "Color Adjustments": "ಬಣ್ಣ ಹೊಂದಾಣಿಕೆಗಳು",
        "Invert Colors": "ಬಣ್ಣಗಳನ್ನು ವಿಲೋಮಗೊಳಿಸಿ",
        "Light Contrast": "ತಿಳಿ ಕಾಂಟ್ರಾಸ್ಟ್",
        "Dark Contrast": "ಗಾಢ ಕಾಂಟ್ರಾಸ್ಟ್",
        "High Contrast": "ಅಧಿಕ ಕಾಂಟ್ರಾಸ್ಟ್",
        "High Saturation": "ಅಧಿಕ ಸ್ಯಾಚುರೇಶನ್",
        "Low Saturation": "ಕಡಿಮೆ ಸ್ಯಾಚುರೇಶನ್",
        "Monochrome": "ಏಕವರ್ಣ",
        "Tools": "ಪರಿಕರಗಳು",
        "Reading Guide": "ಓದುವ ಮಾರ್ಗದರ್ಶಿ",
        "Stop Animations": "ಅನಿಮೇಶನ್‌ಗಳನ್ನು ನಿಲ್ಲಿಸಿ",
        "Big Cursor": "ದೊಡ್ಡ ಕರ್ಸರ್",
        "Increase Font Size": "ಫಾಂಟ್ ಗಾತ್ರ ಹೆಚ್ಚಿಸಿ",
        "Decrease Font Size": "ಫಾಂಟ್ ಗಾತ್ರ ಕಡಿಮೆ ಮಾಡಿ",
        "Letter Spacing": "ಅಕ್ಷರ ಅಂತರ",
        "Line Height": "ಸಾಲಿನ ಎತ್ತರ",
        "Font Weight": "ಫಾಂಟ್ ದಪ್ಪ",
        "Dyslexia Font": "ಡಿಸ್ಲೆಕ್ಸಿಯಾ ಫಾಂಟ್",
        "Legible Font": "ಸ್ಪಷ್ಟ ಫಾಂಟ್",
        "Font Size": "ಫಾಂಟ್ ಗಾತ್ರ",
        "Language": "ಭಾಷೆ",
        "All Languages": "ಎಲ್ಲಾ ಭಾಷೆಗಳು",
        "Search language": "ಭಾಷೆ ಹುಡುಕಿ",
        "Open Accessibility Menu": "ಪ್ರವೇಶಿಸುವಿಕೆ ಮೆನು ತೆರೆಯಿರಿ",
        "Open accessibility menu": "ಪ್ರವೇಶಿಸುವಿಕೆ ಮೆನು ತೆರೆಯಿರಿ",
        "Hide Images": "ಚಿತ್ರಗಳನ್ನು ಮರೆಮಾಡಿ",
        "Skip to accessibility menu": "ಪ್ರವೇಶಿಸುವಿಕೆ ಮೆನುಗೆ ತೆರಳಿ",
        "Accessibility Report": "ಪ್ರವೇಶಿಸುವಿಕೆ ವರದಿ",
        "Run Accessibility Check": "ಪ್ರವೇಶಿಸುವಿಕೆ ಪರಿಶೀಲನೆ ನಡೆಸಿ",
        "Loading...": "ಲೋಡ್ ಆಗುತ್ತಿದೆ...",
        "Analyzing page...": "ಪುಟವನ್ನು ವಿಶ್ಲೇಷಿಸಲಾಗುತ್ತಿದೆ...",
        "Critical": "ತೀವ್ರ",
        "Serious": "ಗಂಭೀರ",
        "Moderate": "ಮಧ್ಯಮ",
        "Minor": "ಸಣ್ಣ",
        "Violations Found": "ಉಲ್ಲಂಘನೆಗಳು ಕಂಡುಬಂದಿವೆ",
        "No Issues Found": "ಯಾವುದೇ ಸಮಸ್ಯೆಗಳು ಕಂಡುಬಂದಿಲ್ಲ",
        "Element": "ಘಟಕ",
        "Issue": "ಸಮಸ್ಯೆ",
        "How to Fix": "ಸರಿಪಡಿಸುವುದು ಹೇಗೆ",
        "Close Report": "ವರದಿ ಮುಚ್ಚಿ",
        "Passed Tests": "ಉತ್ತೀರ್ಣಗೊಂಡ ಪರೀಕ್ಷೆಗಳು",
        "Items Need Review": "ಪರಿಶೀಲನೆ ಅಗತ್ಯವಿರುವ ಅಂಶಗಳು",
        "Annotations": "ಟಿಪ್ಪಣಿಗಳು",
        "Text to Speech": "ಪಠ್ಯದಿಂದ ಧ್ವನಿ",
        "Text to Speech On": "ಪಠ್ಯದಿಂದ ಧ್ವನಿ ಆನ್",
        "Text to Speech Off": "ಪಠ್ಯದಿಂದ ಧ್ವನಿ ಆಫ್",
        "Simplify Layout": "ವಿನ್ಯಾಸ ಸರಳಗೊಳಿಸಿ",
        "Speech": "ಧ್ವನಿ",
        "Text": "ಪಠ್ಯ",
        "Color & Contrast": "ಬಣ್ಣ ಮತ್ತು ಕಾಂಟ್ರಾಸ್ಟ್",
        "Reading Aids": "ಓದುವ ಸಹಾಯಕಗಳು",
        "Interaction": "ಪರಸ್ಪರ ಕ್ರಿಯೆ",
        "Contrast": "ಕಾಂಟ್ರಾಸ್ಟ್",
        "Saturation": "ಸ್ಯಾಚುರೇಶನ್",
        "Light": "ತಿಳಿ",
        "Dark": "ಗಾಢ",
        "High": "ಅಧಿಕ",
        "Low": "ಕಡಿಮೆ",
        "Play": "ಪ್ಲೇ",
        "Pause": "ವಿರಾಮ",
        "Stop": "ನಿಲ್ಲಿಸಿ",
        "Loading voice...": "ಧ್ವನಿ ಲೋಡ್ ಆಗುತ್ತಿದೆ...",
        "Reading...": "ಓದಲಾಗುತ್ತಿದೆ...",
        "Profiles": "ಪ್ರೊಫೈಲ್‌ಗಳು",
        "Seizure Safe": "ಅಪಸ್ಮಾರ ಸುರಕ್ಷಿತ",
        "Vision Impaired": "ದೃಷ್ಟಿದೋಷವುಳ್ಳವರು",
        "ADHD Friendly": "ಎಡಿಎಚ್‌ಡಿ ಸ್ನೇಹಿ",
        "Dyslexia Friendly": "ಡಿಸ್ಲೆಕ್ಸಿಯಾ ಸ್ನೇಹಿ",
        "On": "ಆನ್",
        "Off": "ಆಫ್",
        "Mute Sounds": "ಶಬ್ದಗಳನ್ನು ಮ್ಯೂಟ್ ಮಾಡಿ",
        "Page Structure": "ಪುಟದ ರಚನೆ",
        "Text Magnifier": "ಪಠ್ಯ ವರ್ಧಕ",
        "Headings": "ಶೀರ್ಷಿಕೆಗಳು",
        "Landmarks": "ಲ್ಯಾಂಡ್‌ಮಾರ್ಕ್‌ಗಳು",
        "Links": "ಲಿಂಕ್‌ಗಳು",
        "No items found": "ಯಾವುದೇ ಅಂಶಗಳು ಕಂಡುಬಂದಿಲ್ಲ",
        "Settings reset": "ಸೆಟ್ಟಿಂಗ್‌ಗಳನ್ನು ಮರುಹೊಂದಿಸಲಾಗಿದೆ",
      },
      ko: {
        "Accessibility": "접근성",
        "Accessibility Options": "접근성 옵션",
        "Accessibility Menu": "접근성 메뉴",
        "Reset settings": "설정 초기화",
        "Reset All Settings": "모든 설정 초기화",
        "Close": "닫기",
        "Content Adjustments": "콘텐츠 조정",
        "Adjust Font Size": "글자 크기 조정",
        "Highlight Title": "제목 강조",
        "Highlight Links": "링크 강조",
        "Readable Font": "읽기 쉬운 글꼴",
        "Color Adjustments": "색상 조정",
        "Invert Colors": "색상 반전",
        "Light Contrast": "밝은 대비",
        "Dark Contrast": "어두운 대비",
        "High Contrast": "고대비",
        "High Saturation": "고채도",
        "Low Saturation": "저채도",
        "Monochrome": "흑백",
        "Tools": "도구",
        "Reading Guide": "읽기 가이드",
        "Stop Animations": "애니메이션 중지",
        "Big Cursor": "큰 커서",
        "Increase Font Size": "글자 크기 확대",
        "Decrease Font Size": "글자 크기 축소",
        "Letter Spacing": "자간",
        "Line Height": "줄 간격",
        "Font Weight": "글자 굵기",
        "Dyslexia Font": "난독증 글꼴",
        "Legible Font": "가독성 높은 글꼴",
        "Font Size": "글자 크기",
        "Language": "언어",
        "All Languages": "모든 언어",
        "Search language": "언어 검색",
        "Open Accessibility Menu": "접근성 메뉴 열기",
        "Open accessibility menu": "접근성 메뉴 열기",
        "Hide Images": "이미지 숨기기",
        "Skip to accessibility menu": "접근성 메뉴로 건너뛰기",
        "Accessibility Report": "접근성 보고서",
        "Run Accessibility Check": "접근성 검사 실행",
        "Loading...": "불러오는 중...",
        "Analyzing page...": "페이지 분석 중...",
        "Critical": "치명적",
        "Serious": "심각",
        "Moderate": "보통",
        "Minor": "경미",
        "Violations Found": "발견된 위반 사항",
        "No Issues Found": "발견된 문제 없음",
        "Element": "요소",
        "Issue": "문제",
        "How to Fix": "해결 방법",
        "Close Report": "보고서 닫기",
        "Passed Tests": "통과한 검사",
        "Items Need Review": "검토가 필요한 항목",
        "Annotations": "주석",
        "Text to Speech": "텍스트 음성 변환",
        "Text to Speech On": "텍스트 음성 변환 켜짐",
        "Text to Speech Off": "텍스트 음성 변환 꺼짐",
        "Simplify Layout": "레이아웃 단순화",
        "Speech": "음성",
        "Text": "텍스트",
        "Color & Contrast": "색상 및 대비",
        "Reading Aids": "읽기 보조",
        "Interaction": "상호작용",
        "Contrast": "대비",
        "Saturation": "채도",
        "Light": "밝음",
        "Dark": "어두움",
        "High": "높음",
        "Low": "낮음",
        "Play": "재생",
        "Pause": "일시정지",
        "Stop": "정지",
        "Loading voice...": "음성 불러오는 중...",
        "Reading...": "읽는 중...",
        "Profiles": "프로필",
        "Seizure Safe": "발작 방지",
        "Vision Impaired": "시각 장애 지원",
        "ADHD Friendly": "ADHD 친화적",
        "Dyslexia Friendly": "난독증 친화적",
        "On": "켜짐",
        "Off": "꺼짐",
        "Mute Sounds": "음소거",
        "Page Structure": "페이지 구조",
        "Text Magnifier": "텍스트 돋보기",
        "Headings": "제목",
        "Landmarks": "랜드마크",
        "Links": "링크",
        "No items found": "항목을 찾을 수 없습니다",
        "Settings reset": "설정이 초기화되었습니다",
      },
      ku: {
        "Accessibility": "Gihîştinbarî",
        "Accessibility Options": "Vebijêrkên Gihîştinbariyê",
        "Accessibility Menu": "Menûya Gihîştinbariyê",
        "Reset settings": "Mîhengan vegerîne",
        "Reset All Settings": "Hemû Mîhengan Vegerîne",
        "Close": "Bigire",
        "Content Adjustments": "Eyarên Naverokê",
        "Adjust Font Size": "Mezinahiya Fontê Eyar Bike",
        "Highlight Title": "Sernavan Diyar Bike",
        "Highlight Links": "Girêdanan Diyar Bike",
        "Readable Font": "Fonta Xwendinbar",
        "Color Adjustments": "Eyarên Rengan",
        "Invert Colors": "Rengan Berevajî Bike",
        "Light Contrast": "Kontrasta Ronî",
        "Dark Contrast": "Kontrasta Tarî",
        "High Contrast": "Kontrasta Bilind",
        "High Saturation": "Têrbûna Bilind",
        "Low Saturation": "Têrbûna Nizm",
        "Monochrome": "Yekreng",
        "Tools": "Amûr",
        "Reading Guide": "Rêbera Xwendinê",
        "Stop Animations": "Anîmasyonan Rawestîne",
        "Big Cursor": "Kursora Mezin",
        "Increase Font Size": "Mezinahiya Fontê Zêde Bike",
        "Decrease Font Size": "Mezinahiya Fontê Kêm Bike",
        "Letter Spacing": "Navbera Tîpan",
        "Line Height": "Bilindahiya Rêzê",
        "Font Weight": "Giraniya Fontê",
        "Dyslexia Font": "Fonta Dîsleksiyê",
        "Legible Font": "Fonta Zelal",
        "Font Size": "Mezinahiya Fontê",
        "Language": "Ziman",
        "All Languages": "Hemû Zimanan",
        "Search language": "Li zimanan bigere",
        "Open Accessibility Menu": "Menûya Gihîştinbariyê Veke",
        "Open accessibility menu": "Menûya gihîştinbariyê veke",
        "Hide Images": "Wêneyan Veşêre",
        "Skip to accessibility menu": "Derbasî menûya gihîştinbariyê bibe",
        "Accessibility Report": "Rapora Gihîştinbariyê",
        "Run Accessibility Check": "Kontrola Gihîştinbariyê Bimeşîne",
        "Loading...": "Tê barkirin...",
        "Analyzing page...": "Rûpel tê analîzkirin...",
        "Critical": "Krîtîk",
        "Serious": "Giran",
        "Moderate": "Navîn",
        "Minor": "Sivik",
        "Violations Found": "Binpêkirin Hatin Dîtin",
        "No Issues Found": "Tu Pirsgirêk Nehat Dîtin",
        "Element": "Hêman",
        "Issue": "Pirsgirêk",
        "How to Fix": "Çawa Tê Çareserkirin",
        "Close Report": "Raporê Bigire",
        "Passed Tests": "Testên Derbasbûyî",
        "Items Need Review": "Hêmanên Hewceyî Vekolînê",
        "Annotations": "Têbinî",
        "Text to Speech": "Xwendina bi Deng",
        "Text to Speech On": "Xwendina bi Deng Vekirî",
        "Text to Speech Off": "Xwendina bi Deng Girtî",
        "Simplify Layout": "Rûpelê Sade Bike",
        "Speech": "Axaftin",
        "Text": "Nivîs",
        "Color & Contrast": "Reng û Kontrast",
        "Reading Aids": "Alîkariyên Xwendinê",
        "Interaction": "Têkilî",
        "Contrast": "Kontrast",
        "Saturation": "Têrbûna Rengan",
        "Light": "Ronî",
        "Dark": "Tarî",
        "High": "Bilind",
        "Low": "Nizm",
        "Play": "Lê bide",
        "Pause": "Bisekinîne",
        "Stop": "Rawestîne",
        "Loading voice...": "Deng tê barkirin...",
        "Reading...": "Tê xwendin...",
        "Profiles": "Profîl",
        "Seizure Safe": "Ewlehiya Epîlepsiyê",
        "Vision Impaired": "Kêmbînî",
        "ADHD Friendly": "Guncan ji bo ADHD",
        "Dyslexia Friendly": "Guncan ji bo Dîsleksiyê",
        "On": "Vekirî",
        "Off": "Girtî",
        "Mute Sounds": "Dengan Bigire",
        "Page Structure": "Struktura Rûpelê",
        "Text Magnifier": "Mezinkera Nivîsê",
        "Headings": "Sernav",
        "Landmarks": "Nîşangeh",
        "Links": "Girêdan",
        "No items found": "Tu hêman nehat dîtin",
        "Settings reset": "Mîheng hatin vegerandin",
      },
      lb: {
        "Accessibility": "Accessibilitéit",
        "Accessibility Options": "Accessibilitéitsoptiounen",
        "Accessibility Menu": "Accessibilitéitsmenü",
        "Reset settings": "Astellungen zerécksetzen",
        "Reset All Settings": "All Astellungen zerécksetzen",
        "Close": "Zoumaachen",
        "Content Adjustments": "Inhaltsupassungen",
        "Adjust Font Size": "Schrëftgréisst upassen",
        "Highlight Title": "Titel ervirhiewen",
        "Highlight Links": "Linken ervirhiewen",
        "Readable Font": "Liesbar Schrëft",
        "Color Adjustments": "Faarfupassungen",
        "Invert Colors": "Faarwen invertéieren",
        "Light Contrast": "Helle Kontrast",
        "Dark Contrast": "Donkele Kontrast",
        "High Contrast": "Héije Kontrast",
        "High Saturation": "Héich Saturatioun",
        "Low Saturation": "Niddreg Saturatioun",
        "Monochrome": "Monochrom",
        "Tools": "Instrumenter",
        "Reading Guide": "Lieslineal",
        "Stop Animations": "Animatioune stoppen",
        "Big Cursor": "Grousse Cursor",
        "Increase Font Size": "Schrëft vergréisseren",
        "Decrease Font Size": "Schrëft verklengeren",
        "Letter Spacing": "Buschtawenofstand",
        "Line Height": "Zeilenhéicht",
        "Font Weight": "Schrëftstäerkt",
        "Dyslexia Font": "Dyslexie-Schrëft",
        "Legible Font": "Kloer Schrëft",
        "Font Size": "Schrëftgréisst",
        "Language": "Sprooch",
        "All Languages": "All Sproochen",
        "Search language": "Sprooch sichen",
        "Open Accessibility Menu": "Accessibilitéitsmenü opmaachen",
        "Open accessibility menu": "Accessibilitéitsmenü opmaachen",
        "Hide Images": "Biller verstoppen",
        "Skip to accessibility menu": "Zum Accessibilitéitsmenü sprangen",
        "Accessibility Report": "Accessibilitéitsrapport",
        "Run Accessibility Check": "Accessibilitéitsiwwerpréiwung starten",
        "Loading...": "Gëtt gelueden...",
        "Analyzing page...": "Säit gëtt analyséiert...",
        "Critical": "Kritesch",
        "Serious": "Schwéier",
        "Moderate": "Moderat",
        "Minor": "Geréng",
        "Violations Found": "Verstéiss fonnt",
        "No Issues Found": "Keng Problemer fonnt",
        "Element": "Element",
        "Issue": "Problem",
        "How to Fix": "Léisung",
        "Close Report": "Rapport zoumaachen",
        "Passed Tests": "Bestanen Tester",
        "Items Need Review": "Elementer ze iwwerpréiwen",
        "Annotations": "Annotatiounen",
        "Text to Speech": "Virliesfunktioun",
        "Text to Speech On": "Virliesfunktioun un",
        "Text to Speech Off": "Virliesfunktioun aus",
        "Simplify Layout": "Layout vereinfachen",
        "Speech": "Virliesen",
        "Text": "Text",
        "Color & Contrast": "Faarf & Kontrast",
        "Reading Aids": "Lieshëllefen",
        "Interaction": "Interaktioun",
        "Contrast": "Kontrast",
        "Saturation": "Saturatioun",
        "Light": "Hell",
        "Dark": "Donkel",
        "High": "Héich",
        "Low": "Niddreg",
        "Play": "Ofspillen",
        "Pause": "Paus",
        "Stop": "Stopp",
        "Loading voice...": "Stëmm gëtt gelueden...",
        "Reading...": "Gëtt virgelies...",
        "Profiles": "Profiller",
        "Seizure Safe": "Epilepsie-sécher",
        "Vision Impaired": "Siichtbehënnert",
        "ADHD Friendly": "ADHS-frëndlech",
        "Dyslexia Friendly": "Dyslexie-frëndlech",
        "On": "Un",
        "Off": "Aus",
        "Mute Sounds": "Toun ausmaachen",
        "Page Structure": "Säitestruktur",
        "Text Magnifier": "Textlupp",
        "Headings": "Iwwerschrëften",
        "Landmarks": "Regiounen",
        "Links": "Linken",
        "No items found": "Keng Elementer fonnt",
        "Settings reset": "Astellungen zeréckgesat",
      },
      ml: {
        "Accessibility": "പ്രവേശനക്ഷമത",
        "Accessibility Options": "പ്രവേശനക്ഷമതാ ഓപ്ഷനുകൾ",
        "Accessibility Menu": "പ്രവേശനക്ഷമതാ മെനു",
        "Reset settings": "ക്രമീകരണങ്ങൾ പുനഃസജ്ജമാക്കുക",
        "Reset All Settings": "എല്ലാ ക്രമീകരണങ്ങളും പുനഃസജ്ജമാക്കുക",
        "Close": "അടയ്ക്കുക",
        "Content Adjustments": "ഉള്ളടക്ക ക്രമീകരണങ്ങൾ",
        "Adjust Font Size": "ഫോണ്ട് വലുപ്പം ക്രമീകരിക്കുക",
        "Highlight Title": "തലക്കെട്ടുകൾ ഹൈലൈറ്റ് ചെയ്യുക",
        "Highlight Links": "ലിങ്കുകൾ ഹൈലൈറ്റ് ചെയ്യുക",
        "Readable Font": "വായനായോഗ്യ ഫോണ്ട്",
        "Color Adjustments": "നിറ ക്രമീകരണങ്ങൾ",
        "Invert Colors": "നിറങ്ങൾ വിപരീതമാക്കുക",
        "Light Contrast": "ഇളം കോൺട്രാസ്റ്റ്",
        "Dark Contrast": "ഇരുണ്ട കോൺട്രാസ്റ്റ്",
        "High Contrast": "ഉയർന്ന കോൺട്രാസ്റ്റ്",
        "High Saturation": "ഉയർന്ന സാച്ചുറേഷൻ",
        "Low Saturation": "കുറഞ്ഞ സാച്ചുറേഷൻ",
        "Monochrome": "മോണോക്രോം",
        "Tools": "ഉപകരണങ്ങൾ",
        "Reading Guide": "വായനാ വഴികാട്ടി",
        "Stop Animations": "ആനിമേഷനുകൾ നിർത്തുക",
        "Big Cursor": "വലിയ കർസർ",
        "Increase Font Size": "ഫോണ്ട് വലുപ്പം കൂട്ടുക",
        "Decrease Font Size": "ഫോണ്ട് വലുപ്പം കുറയ്ക്കുക",
        "Letter Spacing": "അക്ഷര അകലം",
        "Line Height": "വരി അകലം",
        "Font Weight": "ഫോണ്ട് കനം",
        "Dyslexia Font": "ഡിസ്‌ലെക്സിയ ഫോണ്ട്",
        "Legible Font": "വ്യക്തമായ ഫോണ്ട്",
        "Font Size": "ഫോണ്ട് വലുപ്പം",
        "Language": "ഭാഷ",
        "All Languages": "എല്ലാ ഭാഷകളും",
        "Search language": "ഭാഷ തിരയുക",
        "Open Accessibility Menu": "പ്രവേശനക്ഷമതാ മെനു തുറക്കുക",
        "Open accessibility menu": "പ്രവേശനക്ഷമതാ മെനു തുറക്കുക",
        "Hide Images": "ചിത്രങ്ങൾ മറയ്ക്കുക",
        "Skip to accessibility menu": "പ്രവേശനക്ഷമതാ മെനുവിലേക്ക് നേരിട്ട് പോകുക",
        "Accessibility Report": "പ്രവേശനക്ഷമതാ റിപ്പോർട്ട്",
        "Run Accessibility Check": "പ്രവേശനക്ഷമതാ പരിശോധന നടത്തുക",
        "Loading...": "ലോഡ് ചെയ്യുന്നു...",
        "Analyzing page...": "പേജ് വിശകലനം ചെയ്യുന്നു...",
        "Critical": "അതീവ ഗുരുതരം",
        "Serious": "ഗുരുതരം",
        "Moderate": "ഇടത്തരം",
        "Minor": "നിസ്സാരം",
        "Violations Found": "കണ്ടെത്തിയ ലംഘനങ്ങൾ",
        "No Issues Found": "പ്രശ്നങ്ങളൊന്നും കണ്ടെത്തിയില്ല",
        "Element": "ഘടകം",
        "Issue": "പ്രശ്നം",
        "How to Fix": "എങ്ങനെ പരിഹരിക്കാം",
        "Close Report": "റിപ്പോർട്ട് അടയ്ക്കുക",
        "Passed Tests": "വിജയിച്ച പരിശോധനകൾ",
        "Items Need Review": "അവലോകനം ആവശ്യമുള്ള ഇനങ്ങൾ",
        "Annotations": "അടയാളപ്പെടുത്തലുകൾ",
        "Text to Speech": "എഴുത്ത് സംസാരമാക്കൽ",
        "Text to Speech On": "എഴുത്ത് സംസാരമാക്കൽ ഓൺ",
        "Text to Speech Off": "എഴുത്ത് സംസാരമാക്കൽ ഓഫ്",
        "Simplify Layout": "ലേഔട്ട് ലളിതമാക്കുക",
        "Speech": "സംസാരം",
        "Text": "ടെക്സ്റ്റ്",
        "Color & Contrast": "നിറവും കോൺട്രാസ്റ്റും",
        "Reading Aids": "വായനാ സഹായങ്ങൾ",
        "Interaction": "ഇടപെടൽ",
        "Contrast": "കോൺട്രാസ്റ്റ്",
        "Saturation": "സാച്ചുറേഷൻ",
        "Light": "ഇളം",
        "Dark": "ഇരുണ്ട",
        "High": "ഉയർന്ന",
        "Low": "കുറഞ്ഞ",
        "Play": "പ്ലേ",
        "Pause": "പോസ്",
        "Stop": "സ്റ്റോപ്പ്",
        "Loading voice...": "ശബ്ദം ലോഡ് ചെയ്യുന്നു...",
        "Reading...": "വായിക്കുന്നു...",
        "Profiles": "പ്രൊഫൈലുകൾ",
        "Seizure Safe": "അപസ്മാര സുരക്ഷിതം",
        "Vision Impaired": "കാഴ്ച പരിമിതി",
        "ADHD Friendly": "ADHD സൗഹൃദം",
        "Dyslexia Friendly": "ഡിസ്‌ലെക്സിയ സൗഹൃദം",
        "On": "ഓൺ",
        "Off": "ഓഫ്",
        "Mute Sounds": "ശബ്ദം മ്യൂട്ട് ചെയ്യുക",
        "Page Structure": "പേജ് ഘടന",
        "Text Magnifier": "ടെക്സ്റ്റ് ഭൂതക്കണ്ണാടി",
        "Headings": "തലക്കെട്ടുകൾ",
        "Landmarks": "ലാൻഡ്മാർക്കുകൾ",
        "Links": "ലിങ്കുകൾ",
        "No items found": "ഇനങ്ങളൊന്നും കണ്ടെത്തിയില്ല",
        "Settings reset": "ക്രമീകരണങ്ങൾ പുനഃസജ്ജമാക്കി",
      },
      mn: {
        "Accessibility": "Хүртээмж",
        "Accessibility Options": "Хүртээмжийн сонголтууд",
        "Accessibility Menu": "Хүртээмжийн цэс",
        "Reset settings": "Тохиргоог сэргээх",
        "Reset All Settings": "Бүх тохиргоог сэргээх",
        "Close": "Хаах",
        "Content Adjustments": "Агуулгын тохируулга",
        "Adjust Font Size": "Үсгийн хэмжээг тохируулах",
        "Highlight Title": "Гарчгийг тодруулах",
        "Highlight Links": "Холбоосыг тодруулах",
        "Readable Font": "Уншигдахуйц фонт",
        "Color Adjustments": "Өнгөний тохируулга",
        "Invert Colors": "Өнгийг урвуулах",
        "Light Contrast": "Цайвар контраст",
        "Dark Contrast": "Бараан контраст",
        "High Contrast": "Өндөр контраст",
        "High Saturation": "Өндөр ханалт",
        "Low Saturation": "Бага ханалт",
        "Monochrome": "Хар цагаан",
        "Tools": "Хэрэгслүүд",
        "Reading Guide": "Унших шугам",
        "Stop Animations": "Анимацийг зогсоох",
        "Big Cursor": "Том курсор",
        "Increase Font Size": "Үсгийн хэмжээг томсгох",
        "Decrease Font Size": "Үсгийн хэмжээг багасгах",
        "Letter Spacing": "Үсэг хоорондын зай",
        "Line Height": "Мөр хоорондын зай",
        "Font Weight": "Үсгийн зузаан",
        "Dyslexia Font": "Дислекси фонт",
        "Legible Font": "Гаргацтай фонт",
        "Font Size": "Үсгийн хэмжээ",
        "Language": "Хэл",
        "All Languages": "Бүх хэл",
        "Search language": "Хэл хайх",
        "Open Accessibility Menu": "Хүртээмжийн цэсийг нээх",
        "Open accessibility menu": "Хүртээмжийн цэсийг нээх",
        "Hide Images": "Зургийг нуух",
        "Skip to accessibility menu": "Хүртээмжийн цэс рүү шилжих",
        "Accessibility Report": "Хүртээмжийн тайлан",
        "Run Accessibility Check": "Хүртээмжийн шалгалт хийх",
        "Loading...": "Ачаалж байна...",
        "Analyzing page...": "Хуудсыг шинжилж байна...",
        "Critical": "Онц ноцтой",
        "Serious": "Ноцтой",
        "Moderate": "Дунд зэрэг",
        "Minor": "Бага зэрэг",
        "Violations Found": "Илэрсэн зөрчлүүд",
        "No Issues Found": "Асуудал илрээгүй",
        "Element": "Элемент",
        "Issue": "Асуудал",
        "How to Fix": "Хэрхэн засах",
        "Close Report": "Тайланг хаах",
        "Passed Tests": "Тэнцсэн шалгалтууд",
        "Items Need Review": "Хянах шаардлагатай зүйлс",
        "Annotations": "Тэмдэглэгээ",
        "Text to Speech": "Дуут унших",
        "Text to Speech On": "Дуут унших асаалттай",
        "Text to Speech Off": "Дуут унших унтраалттай",
        "Simplify Layout": "Хуудсыг хялбарчлах",
        "Speech": "Яриа",
        "Text": "Текст",
        "Color & Contrast": "Өнгө ба контраст",
        "Reading Aids": "Унших тусламж",
        "Interaction": "Харилцан үйлдэл",
        "Contrast": "Контраст",
        "Saturation": "Ханалт",
        "Light": "Цайвар",
        "Dark": "Бараан",
        "High": "Өндөр",
        "Low": "Бага",
        "Play": "Тоглуулах",
        "Pause": "Түр зогсоох",
        "Stop": "Зогсоох",
        "Loading voice...": "Дуу хоолойг ачаалж байна...",
        "Reading...": "Уншиж байна...",
        "Profiles": "Профайлууд",
        "Seizure Safe": "Таталтаас сэргийлсэн",
        "Vision Impaired": "Харааны бэрхшээлтэй",
        "ADHD Friendly": "Анхаарлын дутагдалд ээлтэй",
        "Dyslexia Friendly": "Дислексид ээлтэй",
        "On": "Асаалттай",
        "Off": "Унтраалттай",
        "Mute Sounds": "Дууг хаах",
        "Page Structure": "Хуудасны бүтэц",
        "Text Magnifier": "Текст томруулагч",
        "Headings": "Гарчгууд",
        "Landmarks": "Бүсүүд",
        "Links": "Холбоосууд",
        "No items found": "Илэрц олдсонгүй",
        "Settings reset": "Тохиргоог сэргээлээ",
      },
      ms: {
        "Accessibility": "Kebolehcapaian",
        "Accessibility Options": "Pilihan Kebolehcapaian",
        "Accessibility Menu": "Menu Kebolehcapaian",
        "Reset settings": "Tetapkan semula tetapan",
        "Reset All Settings": "Tetapkan Semula Semua Tetapan",
        "Close": "Tutup",
        "Content Adjustments": "Pelarasan Kandungan",
        "Adjust Font Size": "Laraskan Saiz Fon",
        "Highlight Title": "Serlahkan Tajuk",
        "Highlight Links": "Serlahkan Pautan",
        "Readable Font": "Fon Mudah Dibaca",
        "Color Adjustments": "Pelarasan Warna",
        "Invert Colors": "Songsangkan Warna",
        "Light Contrast": "Kontras Terang",
        "Dark Contrast": "Kontras Gelap",
        "High Contrast": "Kontras Tinggi",
        "High Saturation": "Ketepuan Tinggi",
        "Low Saturation": "Ketepuan Rendah",
        "Monochrome": "Monokrom",
        "Tools": "Alatan",
        "Reading Guide": "Panduan Bacaan",
        "Stop Animations": "Hentikan Animasi",
        "Big Cursor": "Kursor Besar",
        "Increase Font Size": "Besarkan Saiz Fon",
        "Decrease Font Size": "Kecilkan Saiz Fon",
        "Letter Spacing": "Jarak Huruf",
        "Line Height": "Jarak Baris",
        "Font Weight": "Ketebalan Fon",
        "Dyslexia Font": "Fon Disleksia",
        "Legible Font": "Fon Jelas",
        "Font Size": "Saiz Fon",
        "Language": "Bahasa",
        "All Languages": "Semua Bahasa",
        "Search language": "Cari bahasa",
        "Open Accessibility Menu": "Buka Menu Kebolehcapaian",
        "Open accessibility menu": "Buka menu kebolehcapaian",
        "Hide Images": "Sembunyikan Imej",
        "Skip to accessibility menu": "Langkau ke menu kebolehcapaian",
        "Accessibility Report": "Laporan Kebolehcapaian",
        "Run Accessibility Check": "Jalankan Semakan Kebolehcapaian",
        "Loading...": "Memuatkan...",
        "Analyzing page...": "Menganalisis halaman...",
        "Critical": "Kritikal",
        "Serious": "Serius",
        "Moderate": "Sederhana",
        "Minor": "Kecil",
        "Violations Found": "Pelanggaran Ditemui",
        "No Issues Found": "Tiada Isu Ditemui",
        "Element": "Elemen",
        "Issue": "Isu",
        "How to Fix": "Cara Membaiki",
        "Close Report": "Tutup Laporan",
        "Passed Tests": "Ujian Lulus",
        "Items Need Review": "Item Perlu Semakan",
        "Annotations": "Anotasi",
        "Text to Speech": "Teks ke Pertuturan",
        "Text to Speech On": "Teks ke Pertuturan Dihidupkan",
        "Text to Speech Off": "Teks ke Pertuturan Dimatikan",
        "Simplify Layout": "Ringkaskan Susun Atur",
        "Speech": "Pertuturan",
        "Text": "Teks",
        "Color & Contrast": "Warna & Kontras",
        "Reading Aids": "Bantuan Bacaan",
        "Interaction": "Interaksi",
        "Contrast": "Kontras",
        "Saturation": "Ketepuan",
        "Light": "Terang",
        "Dark": "Gelap",
        "High": "Tinggi",
        "Low": "Rendah",
        "Play": "Main",
        "Pause": "Jeda",
        "Stop": "Berhenti",
        "Loading voice...": "Memuatkan suara...",
        "Reading...": "Membaca...",
        "Profiles": "Profil",
        "Seizure Safe": "Selamat Sawan",
        "Vision Impaired": "Masalah Penglihatan",
        "ADHD Friendly": "Mesra ADHD",
        "Dyslexia Friendly": "Mesra Disleksia",
        "On": "Hidup",
        "Off": "Mati",
        "Mute Sounds": "Redam Bunyi",
        "Page Structure": "Struktur Halaman",
        "Text Magnifier": "Pembesar Teks",
        "Headings": "Tajuk",
        "Landmarks": "Mercu Tanda",
        "Links": "Pautan",
        "No items found": "Tiada item ditemui",
        "Settings reset": "Tetapan ditetapkan semula",
      },
      my: {
        "Accessibility": "အများသုံးစွဲနိုင်မှု",
        "Accessibility Options": "အများသုံးစွဲနိုင်မှု ရွေးချယ်စရာများ",
        "Accessibility Menu": "အများသုံးစွဲနိုင်မှု မီနူး",
        "Reset settings": "ဆက်တင်များ ပြန်လည်သတ်မှတ်ရန်",
        "Reset All Settings": "ဆက်တင်အားလုံး ပြန်လည်သတ်မှတ်ရန်",
        "Close": "ပိတ်ရန်",
        "Content Adjustments": "အကြောင်းအရာ ချိန်ညှိမှုများ",
        "Adjust Font Size": "ဖောင့်အရွယ်အစား ချိန်ညှိရန်",
        "Highlight Title": "ခေါင်းစဉ် မီးမောင်းထိုးရန်",
        "Highlight Links": "လင့်ခ်များ မီးမောင်းထိုးရန်",
        "Readable Font": "ဖတ်ရလွယ်သော ဖောင့်",
        "Color Adjustments": "အရောင် ချိန်ညှိမှုများ",
        "Invert Colors": "အရောင် ပြောင်းပြန်လုပ်ရန်",
        "Light Contrast": "ကွန်ထရက်စ်အလင်း",
        "Dark Contrast": "ကွန်ထရက်စ်အမှောင်",
        "High Contrast": "ကွန်ထရက်စ်မြင့်",
        "High Saturation": "ရောင်စိုမှုမြင့်",
        "Low Saturation": "ရောင်စိုမှုနိမ့်",
        "Monochrome": "တစ်ရောင်တည်း",
        "Tools": "ကိရိယာများ",
        "Reading Guide": "စာဖတ်လမ်းညွှန်",
        "Stop Animations": "လှုပ်ရှားသက်ဝင်ပုံများ ရပ်ရန်",
        "Big Cursor": "ကာဆာကြီး",
        "Increase Font Size": "ဖောင့်အရွယ်အစား တိုးရန်",
        "Decrease Font Size": "ဖောင့်အရွယ်အစား လျှော့ရန်",
        "Letter Spacing": "စာလုံးကြား အကွာအဝေး",
        "Line Height": "စာကြောင်းအမြင့်",
        "Font Weight": "စာလုံးအထူ",
        "Dyslexia Font": "ဒစ်စလက်ဆီးယား ဖောင့်",
        "Legible Font": "ရှင်းလင်းပြတ်သားသော ဖောင့်",
        "Font Size": "ဖောင့်အရွယ်အစား",
        "Language": "ဘာသာစကား",
        "All Languages": "ဘာသာစကားအားလုံး",
        "Search language": "ဘာသာစကား ရှာဖွေရန်",
        "Open Accessibility Menu": "အများသုံးစွဲနိုင်မှု မီနူး ဖွင့်ရန်",
        "Open accessibility menu": "အများသုံးစွဲနိုင်မှု မီနူး ဖွင့်ရန်",
        "Hide Images": "ပုံများ ဖျောက်ရန်",
        "Skip to accessibility menu": "အများသုံးစွဲနိုင်မှု မီနူးသို့ ကျော်သွားရန်",
        "Accessibility Report": "အများသုံးစွဲနိုင်မှု အစီရင်ခံစာ",
        "Run Accessibility Check": "အများသုံးစွဲနိုင်မှု စစ်ဆေးရန်",
        "Loading...": "ရယူနေသည်...",
        "Analyzing page...": "စာမျက်နှာကို ခွဲခြမ်းစိတ်ဖြာနေသည်...",
        "Critical": "အလွန်ပြင်းထန်",
        "Serious": "ပြင်းထန်",
        "Moderate": "အလယ်အလတ်",
        "Minor": "သေးငယ်",
        "Violations Found": "တွေ့ရှိသည့် ချိုးဖောက်မှုများ",
        "No Issues Found": "ပြဿနာ မတွေ့ပါ",
        "Element": "အစိတ်အပိုင်း",
        "Issue": "ပြဿနာ",
        "How to Fix": "ပြင်ဆင်နည်း",
        "Close Report": "အစီရင်ခံစာ ပိတ်ရန်",
        "Passed Tests": "အောင်မြင်သည့် စစ်ဆေးမှုများ",
        "Items Need Review": "ပြန်လည်သုံးသပ်ရန် လိုအပ်သည့် အချက်များ",
        "Annotations": "မှတ်ချက်များ",
        "Text to Speech": "စာသားမှ အသံထွက်",
        "Text to Speech On": "စာသားမှ အသံထွက် ဖွင့်ထားသည်",
        "Text to Speech Off": "စာသားမှ အသံထွက် ပိတ်ထားသည်",
        "Simplify Layout": "အပြင်အဆင် ရိုးရှင်းစေရန်",
        "Speech": "အသံထွက်",
        "Text": "စာသား",
        "Color & Contrast": "အရောင်နှင့် ကွန်ထရက်စ်",
        "Reading Aids": "စာဖတ်ခြင်း အထောက်အကူများ",
        "Interaction": "အပြန်အလှန်လုပ်ဆောင်မှု",
        "Contrast": "ကွန်ထရက်စ်",
        "Saturation": "ရောင်စိုမှု",
        "Light": "အလင်း",
        "Dark": "အမှောင်",
        "High": "မြင့်",
        "Low": "နိမ့်",
        "Play": "ဖွင့်ရန်",
        "Pause": "ခဏရပ်ရန်",
        "Stop": "ရပ်ရန်",
        "Loading voice...": "အသံ ရယူနေသည်...",
        "Reading...": "ဖတ်နေသည်...",
        "Profiles": "ပရိုဖိုင်များ",
        "Seizure Safe": "အတက်ရောဂါ ဘေးကင်း",
        "Vision Impaired": "အမြင်အာရုံ ချို့ယွင်းသူ",
        "ADHD Friendly": "ADHD အတွက် သင့်လျော်",
        "Dyslexia Friendly": "ဒစ်စလက်ဆီးယားအတွက် သင့်လျော်",
        "On": "ဖွင့်",
        "Off": "ပိတ်",
        "Mute Sounds": "အသံ ပိတ်ရန်",
        "Page Structure": "စာမျက်နှာ ဖွဲ့စည်းပုံ",
        "Text Magnifier": "စာသား မှန်ဘီလူး",
        "Headings": "ခေါင်းစဉ်များ",
        "Landmarks": "မှတ်တိုင်များ",
        "Links": "လင့်ခ်များ",
        "No items found": "မည်သည့်အရာမှ မတွေ့ပါ",
        "Settings reset": "ဆက်တင်များ ပြန်လည်သတ်မှတ်ပြီးပါပြီ",
      },
      no: {
        "Accessibility": "Tilgjengelighet",
        "Accessibility Options": "Tilgjengelighetsvalg",
        "Accessibility Menu": "Tilgjengelighetsmeny",
        "Reset settings": "Tilbakestill innstillinger",
        "Reset All Settings": "Tilbakestill alle innstillinger",
        "Close": "Lukk",
        "Content Adjustments": "Innholdsjusteringer",
        "Adjust Font Size": "Juster skriftstørrelse",
        "Highlight Title": "Uthev titler",
        "Highlight Links": "Uthev lenker",
        "Readable Font": "Lesbar skrift",
        "Color Adjustments": "Fargejusteringer",
        "Invert Colors": "Inverter farger",
        "Light Contrast": "Lys kontrast",
        "Dark Contrast": "Mørk kontrast",
        "High Contrast": "Høy kontrast",
        "High Saturation": "Høy metning",
        "Low Saturation": "Lav metning",
        "Monochrome": "Monokrom",
        "Tools": "Verktøy",
        "Reading Guide": "Leselinjal",
        "Stop Animations": "Stopp animasjoner",
        "Big Cursor": "Stor peker",
        "Increase Font Size": "Øk skriftstørrelse",
        "Decrease Font Size": "Reduser skriftstørrelse",
        "Letter Spacing": "Bokstavavstand",
        "Line Height": "Linjeavstand",
        "Font Weight": "Skrifttykkelse",
        "Dyslexia Font": "Dysleksiskrift",
        "Legible Font": "Tydelig skrift",
        "Font Size": "Skriftstørrelse",
        "Language": "Språk",
        "All Languages": "Alle språk",
        "Search language": "Søk etter språk",
        "Open Accessibility Menu": "Åpne tilgjengelighetsmenyen",
        "Open accessibility menu": "Åpne tilgjengelighetsmenyen",
        "Hide Images": "Skjul bilder",
        "Skip to accessibility menu": "Hopp til tilgjengelighetsmenyen",
        "Accessibility Report": "Tilgjengelighetsrapport",
        "Run Accessibility Check": "Kjør tilgjengelighetssjekk",
        "Loading...": "Laster inn...",
        "Analyzing page...": "Analyserer siden...",
        "Critical": "Kritisk",
        "Serious": "Alvorlig",
        "Moderate": "Moderat",
        "Minor": "Mindre",
        "Violations Found": "Brudd funnet",
        "No Issues Found": "Ingen problemer funnet",
        "Element": "Element",
        "Issue": "Problem",
        "How to Fix": "Slik retter du det",
        "Close Report": "Lukk rapport",
        "Passed Tests": "Beståtte tester",
        "Items Need Review": "Elementer som må gjennomgås",
        "Annotations": "Merknader",
        "Text to Speech": "Opplesing",
        "Text to Speech On": "Opplesing på",
        "Text to Speech Off": "Opplesing av",
        "Simplify Layout": "Forenkle oppsett",
        "Speech": "Tale",
        "Text": "Tekst",
        "Color & Contrast": "Farge og kontrast",
        "Reading Aids": "Lesehjelp",
        "Interaction": "Interaksjon",
        "Contrast": "Kontrast",
        "Saturation": "Metning",
        "Light": "Lys",
        "Dark": "Mørk",
        "High": "Høy",
        "Low": "Lav",
        "Play": "Spill av",
        "Pause": "Pause",
        "Stop": "Stopp",
        "Loading voice...": "Laster inn stemme...",
        "Reading...": "Leser...",
        "Profiles": "Profiler",
        "Seizure Safe": "Epilepsisikker",
        "Vision Impaired": "Synshemmet",
        "ADHD Friendly": "ADHD-vennlig",
        "Dyslexia Friendly": "Dysleksivennlig",
        "On": "På",
        "Off": "Av",
        "Mute Sounds": "Demp lyder",
        "Page Structure": "Sidestruktur",
        "Text Magnifier": "Tekstforstørrer",
        "Headings": "Overskrifter",
        "Landmarks": "Landemerker",
        "Links": "Lenker",
        "No items found": "Ingen elementer funnet",
        "Settings reset": "Innstillinger tilbakestilt",
      },
      pa: {
        "Accessibility": "ਪਹੁੰਚਯੋਗਤਾ",
        "Accessibility Options": "ਪਹੁੰਚਯੋਗਤਾ ਵਿਕਲਪ",
        "Accessibility Menu": "ਪਹੁੰਚਯੋਗਤਾ ਮੀਨੂ",
        "Reset settings": "ਸੈਟਿੰਗਾਂ ਰੀਸੈੱਟ ਕਰੋ",
        "Reset All Settings": "ਸਾਰੀਆਂ ਸੈਟਿੰਗਾਂ ਰੀਸੈੱਟ ਕਰੋ",
        "Close": "ਬੰਦ ਕਰੋ",
        "Content Adjustments": "ਸਮੱਗਰੀ ਵਿਵਸਥਾਵਾਂ",
        "Adjust Font Size": "ਫੌਂਟ ਦਾ ਆਕਾਰ ਵਿਵਸਥਿਤ ਕਰੋ",
        "Highlight Title": "ਸਿਰਲੇਖ ਹਾਈਲਾਈਟ ਕਰੋ",
        "Highlight Links": "ਲਿੰਕ ਹਾਈਲਾਈਟ ਕਰੋ",
        "Readable Font": "ਪੜ੍ਹਨਯੋਗ ਫੌਂਟ",
        "Color Adjustments": "ਰੰਗ ਵਿਵਸਥਾਵਾਂ",
        "Invert Colors": "ਰੰਗ ਉਲਟਾਓ",
        "Light Contrast": "ਹਲਕਾ ਕੰਟਰਾਸਟ",
        "Dark Contrast": "ਗੂੜ੍ਹਾ ਕੰਟਰਾਸਟ",
        "High Contrast": "ਉੱਚ ਕੰਟਰਾਸਟ",
        "High Saturation": "ਉੱਚ ਸੈਚੁਰੇਸ਼ਨ",
        "Low Saturation": "ਘੱਟ ਸੈਚੁਰੇਸ਼ਨ",
        "Monochrome": "ਮੋਨੋਕ੍ਰੋਮ",
        "Tools": "ਟੂਲ",
        "Reading Guide": "ਪੜ੍ਹਨ ਗਾਈਡ",
        "Stop Animations": "ਐਨੀਮੇਸ਼ਨ ਰੋਕੋ",
        "Big Cursor": "ਵੱਡਾ ਕਰਸਰ",
        "Increase Font Size": "ਫੌਂਟ ਦਾ ਆਕਾਰ ਵਧਾਓ",
        "Decrease Font Size": "ਫੌਂਟ ਦਾ ਆਕਾਰ ਘਟਾਓ",
        "Letter Spacing": "ਅੱਖਰਾਂ ਦੀ ਵਿੱਥ",
        "Line Height": "ਲਾਈਨ ਦੀ ਉਚਾਈ",
        "Font Weight": "ਫੌਂਟ ਦੀ ਮੋਟਾਈ",
        "Dyslexia Font": "ਡਿਸਲੈਕਸੀਆ ਫੌਂਟ",
        "Legible Font": "ਸਪੱਸ਼ਟ ਫੌਂਟ",
        "Font Size": "ਫੌਂਟ ਦਾ ਆਕਾਰ",
        "Language": "ਭਾਸ਼ਾ",
        "All Languages": "ਸਾਰੀਆਂ ਭਾਸ਼ਾਵਾਂ",
        "Search language": "ਭਾਸ਼ਾ ਖੋਜੋ",
        "Open Accessibility Menu": "ਪਹੁੰਚਯੋਗਤਾ ਮੀਨੂ ਖੋਲ੍ਹੋ",
        "Open accessibility menu": "ਪਹੁੰਚਯੋਗਤਾ ਮੀਨੂ ਖੋਲ੍ਹੋ",
        "Hide Images": "ਤਸਵੀਰਾਂ ਲੁਕਾਓ",
        "Skip to accessibility menu": "ਪਹੁੰਚਯੋਗਤਾ ਮੀਨੂ 'ਤੇ ਜਾਓ",
        "Accessibility Report": "ਪਹੁੰਚਯੋਗਤਾ ਰਿਪੋਰਟ",
        "Run Accessibility Check": "ਪਹੁੰਚਯੋਗਤਾ ਜਾਂਚ ਚਲਾਓ",
        "Loading...": "ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...",
        "Analyzing page...": "ਪੰਨੇ ਦਾ ਵਿਸ਼ਲੇਸ਼ਣ ਹੋ ਰਿਹਾ ਹੈ...",
        "Critical": "ਅਤਿ ਗੰਭੀਰ",
        "Serious": "ਗੰਭੀਰ",
        "Moderate": "ਦਰਮਿਆਨਾ",
        "Minor": "ਮਾਮੂਲੀ",
        "Violations Found": "ਉਲੰਘਣਾਵਾਂ ਮਿਲੀਆਂ",
        "No Issues Found": "ਕੋਈ ਸਮੱਸਿਆ ਨਹੀਂ ਮਿਲੀ",
        "Element": "ਐਲੀਮੈਂਟ",
        "Issue": "ਸਮੱਸਿਆ",
        "How to Fix": "ਠੀਕ ਕਰਨ ਦਾ ਤਰੀਕਾ",
        "Close Report": "ਰਿਪੋਰਟ ਬੰਦ ਕਰੋ",
        "Passed Tests": "ਪਾਸ ਹੋਏ ਟੈਸਟ",
        "Items Need Review": "ਸਮੀਖਿਆ ਦੀ ਲੋੜ ਵਾਲੀਆਂ ਆਈਟਮਾਂ",
        "Annotations": "ਐਨੋਟੇਸ਼ਨ",
        "Text to Speech": "ਲਿਖਤ ਤੋਂ ਬੋਲੀ",
        "Text to Speech On": "ਲਿਖਤ ਤੋਂ ਬੋਲੀ ਚਾਲੂ",
        "Text to Speech Off": "ਲਿਖਤ ਤੋਂ ਬੋਲੀ ਬੰਦ",
        "Simplify Layout": "ਲੇਆਉਟ ਸਰਲ ਕਰੋ",
        "Speech": "ਬੋਲੀ",
        "Text": "ਲਿਖਤ",
        "Color & Contrast": "ਰੰਗ ਅਤੇ ਕੰਟਰਾਸਟ",
        "Reading Aids": "ਪੜ੍ਹਨ ਸਹਾਇਤਾ",
        "Interaction": "ਇੰਟਰੈਕਸ਼ਨ",
        "Contrast": "ਕੰਟਰਾਸਟ",
        "Saturation": "ਸੈਚੁਰੇਸ਼ਨ",
        "Light": "ਹਲਕਾ",
        "Dark": "ਗੂੜ੍ਹਾ",
        "High": "ਉੱਚ",
        "Low": "ਘੱਟ",
        "Play": "ਚਲਾਓ",
        "Pause": "ਵਿਰਾਮ",
        "Stop": "ਰੋਕੋ",
        "Loading voice...": "ਅਵਾਜ਼ ਲੋਡ ਹੋ ਰਹੀ ਹੈ...",
        "Reading...": "ਪੜ੍ਹਿਆ ਜਾ ਰਿਹਾ ਹੈ...",
        "Profiles": "ਪ੍ਰੋਫਾਈਲ",
        "Seizure Safe": "ਦੌਰੇ ਤੋਂ ਸੁਰੱਖਿਅਤ",
        "Vision Impaired": "ਕਮਜ਼ੋਰ ਨਜ਼ਰ",
        "ADHD Friendly": "ADHD ਅਨੁਕੂਲ",
        "Dyslexia Friendly": "ਡਿਸਲੈਕਸੀਆ ਅਨੁਕੂਲ",
        "On": "ਚਾਲੂ",
        "Off": "ਬੰਦ",
        "Mute Sounds": "ਅਵਾਜ਼ਾਂ ਮਿਊਟ ਕਰੋ",
        "Page Structure": "ਪੰਨੇ ਦੀ ਬਣਤਰ",
        "Text Magnifier": "ਲਿਖਤ ਵੱਡਦਰਸ਼ੀ",
        "Headings": "ਸਿਰਲੇਖ",
        "Landmarks": "ਲੈਂਡਮਾਰਕ",
        "Links": "ਲਿੰਕ",
        "No items found": "ਕੋਈ ਆਈਟਮ ਨਹੀਂ ਮਿਲੀ",
        "Settings reset": "ਸੈਟਿੰਗਾਂ ਰੀਸੈੱਟ ਹੋ ਗਈਆਂ",
      },
      si: {
        "Accessibility": "ප්‍රවේශ්‍යතාව",
        "Accessibility Options": "ප්‍රවේශ්‍යතා විකල්ප",
        "Accessibility Menu": "ප්‍රවේශ්‍යතා මෙනුව",
        "Reset settings": "සැකසුම් යළි සකසන්න",
        "Reset All Settings": "සියලු සැකසුම් යළි සකසන්න",
        "Close": "වසන්න",
        "Content Adjustments": "අන්තර්ගත ගැලපීම්",
        "Adjust Font Size": "අකුරු ප්‍රමාණය සකසන්න",
        "Highlight Title": "මාතෘකා ඉස්මතු කරන්න",
        "Highlight Links": "සබැඳි ඉස්මතු කරන්න",
        "Readable Font": "කියවීමට පහසු අකුරු",
        "Color Adjustments": "වර්ණ ගැලපීම්",
        "Invert Colors": "වර්ණ ප්‍රතිලෝම කරන්න",
        "Light Contrast": "ලා ප්‍රභේදනය",
        "Dark Contrast": "අඳුරු ප්‍රභේදනය",
        "High Contrast": "ඉහළ ප්‍රභේදනය",
        "High Saturation": "ඉහළ සන්තෘප්තිය",
        "Low Saturation": "අඩු සන්තෘප්තිය",
        "Monochrome": "ඒකවර්ණ",
        "Tools": "මෙවලම්",
        "Reading Guide": "කියවීමේ මාර්ගෝපදේශය",
        "Stop Animations": "සජීවීකරණ නවත්වන්න",
        "Big Cursor": "විශාල කර්සරය",
        "Increase Font Size": "අකුරු ප්‍රමාණය වැඩි කරන්න",
        "Decrease Font Size": "අකුරු ප්‍රමාණය අඩු කරන්න",
        "Letter Spacing": "අකුරු පරතරය",
        "Line Height": "පේළි උස",
        "Font Weight": "අකුරු ඝනකම",
        "Dyslexia Font": "ඩිස්ලෙක්සියා අකුරු",
        "Legible Font": "පැහැදිලි අකුරු",
        "Font Size": "අකුරු ප්‍රමාණය",
        "Language": "භාෂාව",
        "All Languages": "සියලු භාෂා",
        "Search language": "භාෂාව සොයන්න",
        "Open Accessibility Menu": "ප්‍රවේශ්‍යතා මෙනුව විවෘත කරන්න",
        "Open accessibility menu": "ප්‍රවේශ්‍යතා මෙනුව විවෘත කරන්න",
        "Hide Images": "රූප සඟවන්න",
        "Skip to accessibility menu": "ප්‍රවේශ්‍යතා මෙනුව වෙත යන්න",
        "Accessibility Report": "ප්‍රවේශ්‍යතා වාර්තාව",
        "Run Accessibility Check": "ප්‍රවේශ්‍යතා පරීක්ෂාව ක්‍රියාත්මක කරන්න",
        "Loading...": "පූරණය වෙමින්...",
        "Analyzing page...": "පිටුව විශ්ලේෂණය කරමින්...",
        "Critical": "ඉතා බරපතළ",
        "Serious": "බරපතළ",
        "Moderate": "මධ්‍යම",
        "Minor": "සුළු",
        "Violations Found": "හමු වූ උල්ලංඝන",
        "No Issues Found": "ගැටලු හමු නොවීය",
        "Element": "මූලාංගය",
        "Issue": "ගැටලුව",
        "How to Fix": "නිවැරදි කරන ආකාරය",
        "Close Report": "වාර්තාව වසන්න",
        "Passed Tests": "සමත් වූ පරීක්ෂණ",
        "Items Need Review": "සමාලෝචනය අවශ්‍ය අයිතම",
        "Annotations": "විවරණ",
        "Text to Speech": "පෙළින් කථනය",
        "Text to Speech On": "පෙළින් කථනය සක්‍රීයයි",
        "Text to Speech Off": "පෙළින් කථනය අක්‍රීයයි",
        "Simplify Layout": "පිරිසැලසුම සරල කරන්න",
        "Speech": "කථනය",
        "Text": "පෙළ",
        "Color & Contrast": "වර්ණ සහ ප්‍රභේදනය",
        "Reading Aids": "කියවීමේ ආධාරක",
        "Interaction": "අන්තර්ක්‍රියා",
        "Contrast": "ප්‍රභේදනය",
        "Saturation": "සන්තෘප්තිය",
        "Light": "ලා",
        "Dark": "අඳුරු",
        "High": "ඉහළ",
        "Low": "අඩු",
        "Play": "වාදනය කරන්න",
        "Pause": "විරාම කරන්න",
        "Stop": "නවත්වන්න",
        "Loading voice...": "හඬ පූරණය වෙමින්...",
        "Reading...": "කියවමින්...",
        "Profiles": "පැතිකඩ",
        "Seizure Safe": "අපස්මාර ආරක්ෂිත",
        "Vision Impaired": "දෘෂ්ටි ආබාධිත",
        "ADHD Friendly": "ADHD හිතකාමී",
        "Dyslexia Friendly": "ඩිස්ලෙක්සියා හිතකාමී",
        "On": "සක්‍රීයයි",
        "Off": "අක්‍රීයයි",
        "Mute Sounds": "ශබ්ද නිහඬ කරන්න",
        "Page Structure": "පිටු ව්‍යුහය",
        "Text Magnifier": "පෙළ විශාලකය",
        "Headings": "ශීර්ෂ",
        "Landmarks": "සලකුණු",
        "Links": "සබැඳි",
        "No items found": "අයිතම හමු නොවීය",
        "Settings reset": "සැකසුම් යළි සකසන ලදී",
      },
      sk: {
        "Accessibility": "Prístupnosť",
        "Accessibility Options": "Možnosti prístupnosti",
        "Accessibility Menu": "Ponuka prístupnosti",
        "Reset settings": "Obnoviť nastavenia",
        "Reset All Settings": "Obnoviť všetky nastavenia",
        "Close": "Zavrieť",
        "Content Adjustments": "Úpravy obsahu",
        "Adjust Font Size": "Upraviť veľkosť písma",
        "Highlight Title": "Zvýrazniť nadpisy",
        "Highlight Links": "Zvýrazniť odkazy",
        "Readable Font": "Čitateľné písmo",
        "Color Adjustments": "Úpravy farieb",
        "Invert Colors": "Invertovať farby",
        "Light Contrast": "Svetlý kontrast",
        "Dark Contrast": "Tmavý kontrast",
        "High Contrast": "Vysoký kontrast",
        "High Saturation": "Vysoká sýtosť",
        "Low Saturation": "Nízka sýtosť",
        "Monochrome": "Čiernobiele",
        "Tools": "Nástroje",
        "Reading Guide": "Pravítko na čítanie",
        "Stop Animations": "Zastaviť animácie",
        "Big Cursor": "Veľký kurzor",
        "Increase Font Size": "Zväčšiť veľkosť písma",
        "Decrease Font Size": "Zmenšiť veľkosť písma",
        "Letter Spacing": "Rozostup písmen",
        "Line Height": "Riadkovanie",
        "Font Weight": "Hrúbka písma",
        "Dyslexia Font": "Písmo pre dyslektikov",
        "Legible Font": "Zreteľné písmo",
        "Font Size": "Veľkosť písma",
        "Language": "Jazyk",
        "All Languages": "Všetky jazyky",
        "Search language": "Hľadať jazyk",
        "Open Accessibility Menu": "Otvoriť ponuku prístupnosti",
        "Open accessibility menu": "Otvoriť ponuku prístupnosti",
        "Hide Images": "Skryť obrázky",
        "Skip to accessibility menu": "Preskočiť na ponuku prístupnosti",
        "Accessibility Report": "Správa o prístupnosti",
        "Run Accessibility Check": "Spustiť kontrolu prístupnosti",
        "Loading...": "Načítava sa...",
        "Analyzing page...": "Analyzuje sa stránka...",
        "Critical": "Kritické",
        "Serious": "Závažné",
        "Moderate": "Stredne závažné",
        "Minor": "Menej závažné",
        "Violations Found": "Zistené porušenia",
        "No Issues Found": "Nenašli sa žiadne problémy",
        "Element": "Prvok",
        "Issue": "Problém",
        "How to Fix": "Ako opraviť",
        "Close Report": "Zavrieť správu",
        "Passed Tests": "Úspešné testy",
        "Items Need Review": "Položky na kontrolu",
        "Annotations": "Anotácie",
        "Text to Speech": "Prevod textu na reč",
        "Text to Speech On": "Prevod textu na reč zapnutý",
        "Text to Speech Off": "Prevod textu na reč vypnutý",
        "Simplify Layout": "Zjednodušiť rozloženie",
        "Speech": "Reč",
        "Text": "Text",
        "Color & Contrast": "Farby a kontrast",
        "Reading Aids": "Pomôcky na čítanie",
        "Interaction": "Interakcia",
        "Contrast": "Kontrast",
        "Saturation": "Sýtosť",
        "Light": "Svetlý",
        "Dark": "Tmavý",
        "High": "Vysoká",
        "Low": "Nízka",
        "Play": "Prehrať",
        "Pause": "Pozastaviť",
        "Stop": "Zastaviť",
        "Loading voice...": "Načítava sa hlas...",
        "Reading...": "Číta sa...",
        "Profiles": "Profily",
        "Seizure Safe": "Bezpečný pri epilepsii",
        "Vision Impaired": "Pre slabozrakých",
        "ADHD Friendly": "Vhodný pri ADHD",
        "Dyslexia Friendly": "Vhodný pri dyslexii",
        "On": "Zapnuté",
        "Off": "Vypnuté",
        "Mute Sounds": "Stlmiť zvuky",
        "Page Structure": "Štruktúra stránky",
        "Text Magnifier": "Textová lupa",
        "Headings": "Nadpisy",
        "Landmarks": "Orientačné body",
        "Links": "Odkazy",
        "No items found": "Nenašli sa žiadne položky",
        "Settings reset": "Nastavenia boli obnovené",
      },
      sr: {
        "Accessibility": "Приступачност",
        "Accessibility Options": "Опције приступачности",
        "Accessibility Menu": "Мени приступачности",
        "Reset settings": "Ресетуј подешавања",
        "Reset All Settings": "Ресетуј сва подешавања",
        "Close": "Затвори",
        "Content Adjustments": "Прилагођавање садржаја",
        "Adjust Font Size": "Прилагоди величину фонта",
        "Highlight Title": "Истакни наслове",
        "Highlight Links": "Истакни везе",
        "Readable Font": "Читљив фонт",
        "Color Adjustments": "Прилагођавање боја",
        "Invert Colors": "Инвертуј боје",
        "Light Contrast": "Светли контраст",
        "Dark Contrast": "Тамни контраст",
        "High Contrast": "Високи контраст",
        "High Saturation": "Висока засићеност",
        "Low Saturation": "Ниска засићеност",
        "Monochrome": "Црно-бело",
        "Tools": "Алатке",
        "Reading Guide": "Водич за читање",
        "Stop Animations": "Заустави анимације",
        "Big Cursor": "Велики курсор",
        "Increase Font Size": "Повећај величину фонта",
        "Decrease Font Size": "Смањи величину фонта",
        "Letter Spacing": "Размак између слова",
        "Line Height": "Проред",
        "Font Weight": "Дебљина фонта",
        "Dyslexia Font": "Фонт за дислексију",
        "Legible Font": "Читак фонт",
        "Font Size": "Величина фонта",
        "Language": "Језик",
        "All Languages": "Сви језици",
        "Search language": "Претражи језике",
        "Open Accessibility Menu": "Отвори мени приступачности",
        "Open accessibility menu": "Отвори мени приступачности",
        "Hide Images": "Сакриј слике",
        "Skip to accessibility menu": "Пређи на мени приступачности",
        "Accessibility Report": "Извештај о приступачности",
        "Run Accessibility Check": "Покрени проверу приступачности",
        "Loading...": "Учитавање...",
        "Analyzing page...": "Анализирање странице...",
        "Critical": "Критично",
        "Serious": "Озбиљно",
        "Moderate": "Умерено",
        "Minor": "Незнатно",
        "Violations Found": "Пронађени проблеми",
        "No Issues Found": "Нема пронађених проблема",
        "Element": "Елемент",
        "Issue": "Проблем",
        "How to Fix": "Како исправити",
        "Close Report": "Затвори извештај",
        "Passed Tests": "Успешни тестови",
        "Items Need Review": "Ставке за преглед",
        "Annotations": "Анотације",
        "Text to Speech": "Текст у говор",
        "Text to Speech On": "Текст у говор укључен",
        "Text to Speech Off": "Текст у говор искључен",
        "Simplify Layout": "Поједностави распоред",
        "Speech": "Говор",
        "Text": "Текст",
        "Color & Contrast": "Боје и контраст",
        "Reading Aids": "Помагала за читање",
        "Interaction": "Интеракција",
        "Contrast": "Контраст",
        "Saturation": "Засићеност",
        "Light": "Светло",
        "Dark": "Тамно",
        "High": "Високо",
        "Low": "Ниско",
        "Play": "Пусти",
        "Pause": "Паузирај",
        "Stop": "Заустави",
        "Loading voice...": "Учитавање гласа...",
        "Reading...": "Читање...",
        "Profiles": "Профили",
        "Seizure Safe": "Безбедно за епилепсију",
        "Vision Impaired": "Оштећен вид",
        "ADHD Friendly": "Прилагођено за АДХД",
        "Dyslexia Friendly": "Прилагођено за дислексију",
        "On": "Укључено",
        "Off": "Искључено",
        "Mute Sounds": "Искључи звук",
        "Page Structure": "Структура странице",
        "Text Magnifier": "Лупа за текст",
        "Headings": "Наслови",
        "Landmarks": "Оријентири",
        "Links": "Везе",
        "No items found": "Нема пронађених ставки",
        "Settings reset": "Подешавања су ресетована",
      },
      sw: {
        "Accessibility": "Ufikivu",
        "Accessibility Options": "Chaguo za Ufikivu",
        "Accessibility Menu": "Menyu ya Ufikivu",
        "Reset settings": "Weka upya mipangilio",
        "Reset All Settings": "Weka Upya Mipangilio Yote",
        "Close": "Funga",
        "Content Adjustments": "Marekebisho ya Maudhui",
        "Adjust Font Size": "Rekebisha Ukubwa wa Fonti",
        "Highlight Title": "Angazia Vichwa",
        "Highlight Links": "Angazia Viungo",
        "Readable Font": "Fonti Inayosomeka",
        "Color Adjustments": "Marekebisho ya Rangi",
        "Invert Colors": "Geuza Rangi Kinyume",
        "Light Contrast": "Utofautishaji Angavu",
        "Dark Contrast": "Utofautishaji wa Giza",
        "High Contrast": "Utofautishaji wa Juu",
        "High Saturation": "Ukolezi wa Juu",
        "Low Saturation": "Ukolezi wa Chini",
        "Monochrome": "Rangi Moja",
        "Tools": "Zana",
        "Reading Guide": "Mwongozo wa Kusoma",
        "Stop Animations": "Simamisha Uhuishaji",
        "Big Cursor": "Kishale Kikubwa",
        "Increase Font Size": "Ongeza Ukubwa wa Fonti",
        "Decrease Font Size": "Punguza Ukubwa wa Fonti",
        "Letter Spacing": "Nafasi ya Herufi",
        "Line Height": "Nafasi ya Mistari",
        "Font Weight": "Unene wa Fonti",
        "Dyslexia Font": "Fonti ya Disleksia",
        "Legible Font": "Fonti Rahisi Kusoma",
        "Font Size": "Ukubwa wa Fonti",
        "Language": "Lugha",
        "All Languages": "Lugha Zote",
        "Search language": "Tafuta lugha",
        "Open Accessibility Menu": "Fungua Menyu ya Ufikivu",
        "Open accessibility menu": "Fungua menyu ya ufikivu",
        "Hide Images": "Ficha Picha",
        "Skip to accessibility menu": "Ruka hadi menyu ya ufikivu",
        "Accessibility Report": "Ripoti ya Ufikivu",
        "Run Accessibility Check": "Fanya Ukaguzi wa Ufikivu",
        "Loading...": "Inapakia...",
        "Analyzing page...": "Inachanganua ukurasa...",
        "Critical": "Hatari",
        "Serious": "Kali",
        "Moderate": "Wastani",
        "Minor": "Ndogo",
        "Violations Found": "Ukiukaji Uliopatikana",
        "No Issues Found": "Hakuna Matatizo Yaliyopatikana",
        "Element": "Kipengele",
        "Issue": "Tatizo",
        "How to Fix": "Jinsi ya Kurekebisha",
        "Close Report": "Funga Ripoti",
        "Passed Tests": "Majaribio Yaliyofaulu",
        "Items Need Review": "Vipengele Vinavyohitaji Ukaguzi",
        "Annotations": "Vidokezo",
        "Text to Speech": "Kusoma kwa Sauti",
        "Text to Speech On": "Kusoma kwa Sauti Kumewashwa",
        "Text to Speech Off": "Kusoma kwa Sauti Kumezimwa",
        "Simplify Layout": "Rahisisha Mpangilio",
        "Speech": "Sauti",
        "Text": "Maandishi",
        "Color & Contrast": "Rangi na Utofautishaji",
        "Reading Aids": "Visaidizi vya Kusoma",
        "Interaction": "Mwingiliano",
        "Contrast": "Utofautishaji",
        "Saturation": "Ukolezi wa Rangi",
        "Light": "Angavu",
        "Dark": "Giza",
        "High": "Juu",
        "Low": "Chini",
        "Play": "Cheza",
        "Pause": "Sitisha",
        "Stop": "Simamisha",
        "Loading voice...": "Inapakia sauti...",
        "Reading...": "Inasoma...",
        "Profiles": "Wasifu",
        "Seizure Safe": "Salama kwa Kifafa",
        "Vision Impaired": "Wenye Uoni Hafifu",
        "ADHD Friendly": "Rafiki kwa ADHD",
        "Dyslexia Friendly": "Rafiki kwa Disleksia",
        "On": "Imewashwa",
        "Off": "Imezimwa",
        "Mute Sounds": "Zima Sauti",
        "Page Structure": "Muundo wa Ukurasa",
        "Text Magnifier": "Kikuza Maandishi",
        "Headings": "Vichwa",
        "Landmarks": "Alama Muhimu",
        "Links": "Viungo",
        "No items found": "Hakuna vipengele vilivyopatikana",
        "Settings reset": "Mipangilio imewekwa upya",
      },
      ta: {
        "Accessibility": "அணுகல்தன்மை",
        "Accessibility Options": "அணுகல்தன்மை விருப்பங்கள்",
        "Accessibility Menu": "அணுகல்தன்மை மெனு",
        "Reset settings": "அமைப்புகளை மீட்டமை",
        "Reset All Settings": "எல்லா அமைப்புகளையும் மீட்டமை",
        "Close": "மூடு",
        "Content Adjustments": "உள்ளடக்கச் சீரமைப்புகள்",
        "Adjust Font Size": "எழுத்துரு அளவைச் சரிசெய்",
        "Highlight Title": "தலைப்பை முன்னிலைப்படுத்து",
        "Highlight Links": "இணைப்புகளை முன்னிலைப்படுத்து",
        "Readable Font": "படிக்க எளிதான எழுத்துரு",
        "Color Adjustments": "வண்ணச் சீரமைப்புகள்",
        "Invert Colors": "வண்ணங்களை நேர்மாறாக்கு",
        "Light Contrast": "வெளிர் மாறுபாடு",
        "Dark Contrast": "இருண்ட மாறுபாடு",
        "High Contrast": "அதிக மாறுபாடு",
        "High Saturation": "அதிக நிறச்செறிவு",
        "Low Saturation": "குறைந்த நிறச்செறிவு",
        "Monochrome": "ஒற்றை வண்ணம்",
        "Tools": "கருவிகள்",
        "Reading Guide": "வாசிப்பு வழிகாட்டி",
        "Stop Animations": "அனிமேஷன்களை நிறுத்து",
        "Big Cursor": "பெரிய கர்சர்",
        "Increase Font Size": "எழுத்துரு அளவை அதிகரி",
        "Decrease Font Size": "எழுத்துரு அளவைக் குறை",
        "Letter Spacing": "எழுத்து இடைவெளி",
        "Line Height": "வரி உயரம்",
        "Font Weight": "எழுத்துருத் தடிமன்",
        "Dyslexia Font": "டிஸ்லெக்ஸியா எழுத்துரு",
        "Legible Font": "தெளிவான எழுத்துரு",
        "Font Size": "எழுத்துரு அளவு",
        "Language": "மொழி",
        "All Languages": "அனைத்து மொழிகளும்",
        "Search language": "மொழியைத் தேடு",
        "Open Accessibility Menu": "அணுகல்தன்மை மெனுவைத் திற",
        "Open accessibility menu": "அணுகல்தன்மை மெனுவைத் திற",
        "Hide Images": "படங்களை மறை",
        "Skip to accessibility menu": "அணுகல்தன்மை மெனுவிற்குத் தாவு",
        "Accessibility Report": "அணுகல்தன்மை அறிக்கை",
        "Run Accessibility Check": "அணுகல்தன்மை சோதனையை இயக்கு",
        "Loading...": "ஏற்றுகிறது...",
        "Analyzing page...": "பக்கம் பகுப்பாய்வு செய்யப்படுகிறது...",
        "Critical": "மிகத் தீவிரம்",
        "Serious": "தீவிரம்",
        "Moderate": "மிதமானது",
        "Minor": "சிறியது",
        "Violations Found": "கண்டறியப்பட்ட மீறல்கள்",
        "No Issues Found": "சிக்கல்கள் எதுவும் கண்டறியப்படவில்லை",
        "Element": "உறுப்பு",
        "Issue": "சிக்கல்",
        "How to Fix": "சரிசெய்வது எப்படி",
        "Close Report": "அறிக்கையை மூடு",
        "Passed Tests": "தேர்ச்சியடைந்த சோதனைகள்",
        "Items Need Review": "மதிப்பாய்வு தேவைப்படும் உருப்படிகள்",
        "Annotations": "விளக்கக்குறிப்புகள்",
        "Text to Speech": "உரையிலிருந்து பேச்சு",
        "Text to Speech On": "உரையிலிருந்து பேச்சு இயக்கப்பட்டது",
        "Text to Speech Off": "உரையிலிருந்து பேச்சு முடக்கப்பட்டது",
        "Simplify Layout": "தளவமைப்பை எளிமையாக்கு",
        "Speech": "பேச்சு",
        "Text": "உரை",
        "Color & Contrast": "வண்ணம் மற்றும் மாறுபாடு",
        "Reading Aids": "வாசிப்பு உதவிகள்",
        "Interaction": "ஊடாட்டம்",
        "Contrast": "மாறுபாடு",
        "Saturation": "நிறச்செறிவு",
        "Light": "வெளிர்",
        "Dark": "இருண்ட",
        "High": "அதிகம்",
        "Low": "குறைவு",
        "Play": "இயக்கு",
        "Pause": "இடைநிறுத்து",
        "Stop": "நிறுத்து",
        "Loading voice...": "குரல் ஏற்றப்படுகிறது...",
        "Reading...": "வாசிக்கிறது...",
        "Profiles": "சுயவிவரங்கள்",
        "Seizure Safe": "வலிப்புப் பாதுகாப்பு",
        "Vision Impaired": "பார்வைக் குறைபாடு",
        "ADHD Friendly": "ADHD-க்கு ஏற்றது",
        "Dyslexia Friendly": "டிஸ்லெக்ஸியாவுக்கு ஏற்றது",
        "On": "இயக்கம்",
        "Off": "முடக்கம்",
        "Mute Sounds": "ஒலியை முடக்கு",
        "Page Structure": "பக்க அமைப்பு",
        "Text Magnifier": "உரைப் பெரிதாக்கி",
        "Headings": "தலைப்புகள்",
        "Landmarks": "அடையாளங்கள்",
        "Links": "இணைப்புகள்",
        "No items found": "உருப்படிகள் எதுவும் இல்லை",
        "Settings reset": "அமைப்புகள் மீட்டமைக்கப்பட்டன",
      },
      te: {
        "Accessibility": "యాక్సెసిబిలిటీ",
        "Accessibility Options": "యాక్సెసిబిలిటీ ఎంపికలు",
        "Accessibility Menu": "యాక్సెసిబిలిటీ మెనూ",
        "Reset settings": "సెట్టింగ్‌లను రీసెట్ చేయండి",
        "Reset All Settings": "అన్ని సెట్టింగ్‌లను రీసెట్ చేయండి",
        "Close": "మూసివేయండి",
        "Content Adjustments": "కంటెంట్ సర్దుబాట్లు",
        "Adjust Font Size": "ఫాంట్ పరిమాణాన్ని సర్దుబాటు చేయండి",
        "Highlight Title": "శీర్షికలను హైలైట్ చేయండి",
        "Highlight Links": "లింక్‌లను హైలైట్ చేయండి",
        "Readable Font": "చదవగలిగే ఫాంట్",
        "Color Adjustments": "రంగు సర్దుబాట్లు",
        "Invert Colors": "రంగులను విలోమం చేయండి",
        "Light Contrast": "లేత కాంట్రాస్ట్",
        "Dark Contrast": "ముదురు కాంట్రాస్ట్",
        "High Contrast": "అధిక కాంట్రాస్ట్",
        "High Saturation": "అధిక సంతృప్తత",
        "Low Saturation": "తక్కువ సంతృప్తత",
        "Monochrome": "ఏకవర్ణం",
        "Tools": "సాధనాలు",
        "Reading Guide": "పఠన మార్గదర్శి",
        "Stop Animations": "యానిమేషన్‌లను ఆపండి",
        "Big Cursor": "పెద్ద కర్సర్",
        "Increase Font Size": "ఫాంట్ పరిమాణాన్ని పెంచండి",
        "Decrease Font Size": "ఫాంట్ పరిమాణాన్ని తగ్గించండి",
        "Letter Spacing": "అక్షరాల అంతరం",
        "Line Height": "పంక్తి ఎత్తు",
        "Font Weight": "ఫాంట్ మందం",
        "Dyslexia Font": "డిస్లెక్సియా ఫాంట్",
        "Legible Font": "స్పష్టమైన ఫాంట్",
        "Font Size": "ఫాంట్ పరిమాణం",
        "Language": "భాష",
        "All Languages": "అన్ని భాషలు",
        "Search language": "భాషను వెతకండి",
        "Open Accessibility Menu": "యాక్సెసిబిలిటీ మెనూను తెరవండి",
        "Open accessibility menu": "యాక్సెసిబిలిటీ మెనూను తెరవండి",
        "Hide Images": "చిత్రాలను దాచండి",
        "Skip to accessibility menu": "యాక్సెసిబిలిటీ మెనూకు నేరుగా వెళ్ళండి",
        "Accessibility Report": "యాక్సెసిబిలిటీ నివేదిక",
        "Run Accessibility Check": "యాక్సెసిబిలిటీ తనిఖీ చేయండి",
        "Loading...": "లోడ్ అవుతోంది...",
        "Analyzing page...": "పేజీని విశ్లేషిస్తోంది...",
        "Critical": "అత్యంత తీవ్రం",
        "Serious": "తీవ్రం",
        "Moderate": "మధ్యస్థం",
        "Minor": "స్వల్పం",
        "Violations Found": "కనుగొనబడిన ఉల్లంఘనలు",
        "No Issues Found": "సమస్యలు ఏవీ కనుగొనబడలేదు",
        "Element": "ఎలిమెంట్",
        "Issue": "సమస్య",
        "How to Fix": "ఎలా సరిచేయాలి",
        "Close Report": "నివేదికను మూసివేయండి",
        "Passed Tests": "ఉత్తీర్ణమైన పరీక్షలు",
        "Items Need Review": "సమీక్ష అవసరమైన అంశాలు",
        "Annotations": "వ్యాఖ్యలు",
        "Text to Speech": "వచనం నుండి ప్రసంగం",
        "Text to Speech On": "వచనం నుండి ప్రసంగం ఆన్",
        "Text to Speech Off": "వచనం నుండి ప్రసంగం ఆఫ్",
        "Simplify Layout": "లేఅవుట్‌ను సరళీకరించండి",
        "Speech": "ప్రసంగం",
        "Text": "వచనం",
        "Color & Contrast": "రంగు & కాంట్రాస్ట్",
        "Reading Aids": "పఠన సహాయాలు",
        "Interaction": "పరస్పర చర్య",
        "Contrast": "కాంట్రాస్ట్",
        "Saturation": "సంతృప్తత",
        "Light": "లేత",
        "Dark": "ముదురు",
        "High": "అధికం",
        "Low": "తక్కువ",
        "Play": "ప్లే",
        "Pause": "పాజ్",
        "Stop": "స్టాప్",
        "Loading voice...": "వాయిస్ లోడ్ అవుతోంది...",
        "Reading...": "చదువుతోంది...",
        "Profiles": "ప్రొఫైల్‌లు",
        "Seizure Safe": "మూర్ఛ సురక్షితం",
        "Vision Impaired": "దృష్టి లోపం",
        "ADHD Friendly": "ADHD అనుకూలం",
        "Dyslexia Friendly": "డిస్లెక్సియా అనుకూలం",
        "On": "ఆన్",
        "Off": "ఆఫ్",
        "Mute Sounds": "శబ్దాలను మ్యూట్ చేయండి",
        "Page Structure": "పేజీ నిర్మాణం",
        "Text Magnifier": "వచన మాగ్నిఫైయర్",
        "Headings": "శీర్షికలు",
        "Landmarks": "ల్యాండ్‌మార్క్‌లు",
        "Links": "లింక్‌లు",
        "No items found": "అంశాలు ఏవీ కనుగొనబడలేదు",
        "Settings reset": "సెట్టింగ్‌లు రీసెట్ చేయబడ్డాయి",
      },
      th: {
        "Accessibility": "การช่วยการเข้าถึง",
        "Accessibility Options": "ตัวเลือกการช่วยการเข้าถึง",
        "Accessibility Menu": "เมนูการช่วยการเข้าถึง",
        "Reset settings": "รีเซ็ตการตั้งค่า",
        "Reset All Settings": "รีเซ็ตการตั้งค่าทั้งหมด",
        "Close": "ปิด",
        "Content Adjustments": "การปรับเนื้อหา",
        "Adjust Font Size": "ปรับขนาดตัวอักษร",
        "Highlight Title": "เน้นหัวข้อ",
        "Highlight Links": "เน้นลิงก์",
        "Readable Font": "ฟอนต์อ่านง่าย",
        "Color Adjustments": "การปรับสี",
        "Invert Colors": "กลับสี",
        "Light Contrast": "ความคมชัดสว่าง",
        "Dark Contrast": "ความคมชัดมืด",
        "High Contrast": "ความคมชัดสูง",
        "High Saturation": "ความอิ่มตัวของสีสูง",
        "Low Saturation": "ความอิ่มตัวของสีต่ำ",
        "Monochrome": "โทนสีเดียว",
        "Tools": "เครื่องมือ",
        "Reading Guide": "เส้นนำสายตา",
        "Stop Animations": "หยุดภาพเคลื่อนไหว",
        "Big Cursor": "เคอร์เซอร์ขนาดใหญ่",
        "Increase Font Size": "เพิ่มขนาดตัวอักษร",
        "Decrease Font Size": "ลดขนาดตัวอักษร",
        "Letter Spacing": "ระยะห่างตัวอักษร",
        "Line Height": "ระยะห่างบรรทัด",
        "Font Weight": "ความหนาตัวอักษร",
        "Dyslexia Font": "ฟอนต์สำหรับผู้มีภาวะดิสเล็กเซีย",
        "Legible Font": "ฟอนต์ชัดเจน",
        "Font Size": "ขนาดตัวอักษร",
        "Language": "ภาษา",
        "All Languages": "ภาษาทั้งหมด",
        "Search language": "ค้นหาภาษา",
        "Open Accessibility Menu": "เปิดเมนูการช่วยการเข้าถึง",
        "Open accessibility menu": "เปิดเมนูการช่วยการเข้าถึง",
        "Hide Images": "ซ่อนรูปภาพ",
        "Skip to accessibility menu": "ข้ามไปยังเมนูการช่วยการเข้าถึง",
        "Accessibility Report": "รายงานการช่วยการเข้าถึง",
        "Run Accessibility Check": "ตรวจสอบการช่วยการเข้าถึง",
        "Loading...": "กำลังโหลด...",
        "Analyzing page...": "กำลังวิเคราะห์หน้าเว็บ...",
        "Critical": "วิกฤต",
        "Serious": "ร้ายแรง",
        "Moderate": "ปานกลาง",
        "Minor": "เล็กน้อย",
        "Violations Found": "พบปัญหา",
        "No Issues Found": "ไม่พบปัญหา",
        "Element": "องค์ประกอบ",
        "Issue": "ปัญหา",
        "How to Fix": "วิธีแก้ไข",
        "Close Report": "ปิดรายงาน",
        "Passed Tests": "การทดสอบที่ผ่าน",
        "Items Need Review": "รายการที่ต้องตรวจสอบ",
        "Annotations": "คำอธิบายประกอบ",
        "Text to Speech": "อ่านออกเสียง",
        "Text to Speech On": "เปิดการอ่านออกเสียง",
        "Text to Speech Off": "ปิดการอ่านออกเสียง",
        "Simplify Layout": "ปรับหน้าให้เรียบง่าย",
        "Speech": "เสียงพูด",
        "Text": "ข้อความ",
        "Color & Contrast": "สีและความคมชัด",
        "Reading Aids": "ตัวช่วยการอ่าน",
        "Interaction": "การโต้ตอบ",
        "Contrast": "ความคมชัด",
        "Saturation": "ความอิ่มตัวของสี",
        "Light": "สว่าง",
        "Dark": "มืด",
        "High": "สูง",
        "Low": "ต่ำ",
        "Play": "เล่น",
        "Pause": "หยุดชั่วคราว",
        "Stop": "หยุด",
        "Loading voice...": "กำลังโหลดเสียง...",
        "Reading...": "กำลังอ่าน...",
        "Profiles": "โปรไฟล์",
        "Seizure Safe": "ปลอดภัยจากอาการชัก",
        "Vision Impaired": "ผู้บกพร่องทางการมองเห็น",
        "ADHD Friendly": "เหมาะกับผู้มีสมาธิสั้น",
        "Dyslexia Friendly": "เหมาะกับผู้มีภาวะดิสเล็กเซีย",
        "On": "เปิด",
        "Off": "ปิด",
        "Mute Sounds": "ปิดเสียง",
        "Page Structure": "โครงสร้างหน้าเว็บ",
        "Text Magnifier": "แว่นขยายข้อความ",
        "Headings": "หัวข้อ",
        "Landmarks": "จุดสังเกต",
        "Links": "ลิงก์",
        "No items found": "ไม่พบรายการ",
        "Settings reset": "รีเซ็ตการตั้งค่าแล้ว",
      },
      tr: {
        "Accessibility": "Erişilebilirlik",
        "Accessibility Options": "Erişilebilirlik Seçenekleri",
        "Accessibility Menu": "Erişilebilirlik Menüsü",
        "Reset settings": "Ayarları sıfırla",
        "Reset All Settings": "Tüm Ayarları Sıfırla",
        "Close": "Kapat",
        "Content Adjustments": "İçerik Ayarları",
        "Adjust Font Size": "Yazı Boyutunu Ayarla",
        "Highlight Title": "Başlıkları Vurgula",
        "Highlight Links": "Bağlantıları Vurgula",
        "Readable Font": "Okunabilir Yazı Tipi",
        "Color Adjustments": "Renk Ayarları",
        "Invert Colors": "Renkleri Ters Çevir",
        "Light Contrast": "Açık Kontrast",
        "Dark Contrast": "Koyu Kontrast",
        "High Contrast": "Yüksek Kontrast",
        "High Saturation": "Yüksek Doygunluk",
        "Low Saturation": "Düşük Doygunluk",
        "Monochrome": "Tek Renk",
        "Tools": "Araçlar",
        "Reading Guide": "Okuma Kılavuzu",
        "Stop Animations": "Animasyonları Durdur",
        "Big Cursor": "Büyük İmleç",
        "Increase Font Size": "Yazı Boyutunu Büyüt",
        "Decrease Font Size": "Yazı Boyutunu Küçült",
        "Letter Spacing": "Harf Aralığı",
        "Line Height": "Satır Yüksekliği",
        "Font Weight": "Yazı Kalınlığı",
        "Dyslexia Font": "Disleksi Yazı Tipi",
        "Legible Font": "Okunaklı Yazı Tipi",
        "Font Size": "Yazı Boyutu",
        "Language": "Dil",
        "All Languages": "Tüm Diller",
        "Search language": "Dil ara",
        "Open Accessibility Menu": "Erişilebilirlik Menüsünü Aç",
        "Open accessibility menu": "Erişilebilirlik menüsünü aç",
        "Hide Images": "Görselleri Gizle",
        "Skip to accessibility menu": "Erişilebilirlik menüsüne atla",
        "Accessibility Report": "Erişilebilirlik Raporu",
        "Run Accessibility Check": "Erişilebilirlik Denetimi Yap",
        "Loading...": "Yükleniyor...",
        "Analyzing page...": "Sayfa analiz ediliyor...",
        "Critical": "Kritik",
        "Serious": "Ciddi",
        "Moderate": "Orta",
        "Minor": "Düşük",
        "Violations Found": "Bulunan İhlaller",
        "No Issues Found": "Sorun Bulunamadı",
        "Element": "Öğe",
        "Issue": "Sorun",
        "How to Fix": "Nasıl Düzeltilir",
        "Close Report": "Raporu Kapat",
        "Passed Tests": "Başarılı Testler",
        "Items Need Review": "İncelenmesi Gereken Öğeler",
        "Annotations": "Ek Açıklamalar",
        "Text to Speech": "Metin Okuma",
        "Text to Speech On": "Metin Okuma Açık",
        "Text to Speech Off": "Metin Okuma Kapalı",
        "Simplify Layout": "Düzeni Sadeleştir",
        "Speech": "Konuşma",
        "Text": "Metin",
        "Color & Contrast": "Renk ve Kontrast",
        "Reading Aids": "Okuma Yardımcıları",
        "Interaction": "Etkileşim",
        "Contrast": "Kontrast",
        "Saturation": "Doygunluk",
        "Light": "Açık",
        "Dark": "Koyu",
        "High": "Yüksek",
        "Low": "Düşük",
        "Play": "Oynat",
        "Pause": "Duraklat",
        "Stop": "Durdur",
        "Loading voice...": "Ses yükleniyor...",
        "Reading...": "Okunuyor...",
        "Profiles": "Profiller",
        "Seizure Safe": "Epilepsi Dostu",
        "Vision Impaired": "Görme Engelli",
        "ADHD Friendly": "DEHB Dostu",
        "Dyslexia Friendly": "Disleksi Dostu",
        "On": "Açık",
        "Off": "Kapalı",
        "Mute Sounds": "Sesleri Kapat",
        "Page Structure": "Sayfa Yapısı",
        "Text Magnifier": "Metin Büyüteci",
        "Headings": "Başlıklar",
        "Landmarks": "Sınırlar",
        "Links": "Bağlantılar",
        "No items found": "Öğe bulunamadı",
        "Settings reset": "Ayarlar sıfırlandı",
      },
      ur: {
        "Accessibility": "رسائی",
        "Accessibility Options": "رسائی کے اختیارات",
        "Accessibility Menu": "رسائی مینو",
        "Reset settings": "ترتیبات بحال کریں",
        "Reset All Settings": "تمام ترتیبات بحال کریں",
        "Close": "بند کریں",
        "Content Adjustments": "مواد کی تبدیلیاں",
        "Adjust Font Size": "فونٹ سائز تبدیل کریں",
        "Highlight Title": "عنوان نمایاں کریں",
        "Highlight Links": "روابط نمایاں کریں",
        "Readable Font": "پڑھنے میں آسان فونٹ",
        "Color Adjustments": "رنگوں کی تبدیلیاں",
        "Invert Colors": "رنگ الٹ دیں",
        "Light Contrast": "روشن کنٹراسٹ",
        "Dark Contrast": "گہرا کنٹراسٹ",
        "High Contrast": "زیادہ کنٹراسٹ",
        "High Saturation": "زیادہ سیچوریشن",
        "Low Saturation": "کم سیچوریشن",
        "Monochrome": "یک رنگی",
        "Tools": "اوزار",
        "Reading Guide": "پڑھنے کا رہنما",
        "Stop Animations": "اینیمیشن روکیں",
        "Big Cursor": "بڑا کرسر",
        "Increase Font Size": "فونٹ سائز بڑھائیں",
        "Decrease Font Size": "فونٹ سائز کم کریں",
        "Letter Spacing": "حروف کا فاصلہ",
        "Line Height": "سطر کی اونچائی",
        "Font Weight": "فونٹ کی موٹائی",
        "Dyslexia Font": "ڈسلیکسیا فونٹ",
        "Legible Font": "واضح فونٹ",
        "Font Size": "فونٹ سائز",
        "Language": "زبان",
        "All Languages": "تمام زبانیں",
        "Search language": "زبان تلاش کریں",
        "Open Accessibility Menu": "رسائی مینو کھولیں",
        "Open accessibility menu": "رسائی مینو کھولیں",
        "Hide Images": "تصاویر چھپائیں",
        "Skip to accessibility menu": "رسائی مینو پر جائیں",
        "Accessibility Report": "رسائی رپورٹ",
        "Run Accessibility Check": "رسائی کی جانچ کریں",
        "Loading...": "لوڈ ہو رہا ہے...",
        "Analyzing page...": "صفحے کا تجزیہ ہو رہا ہے...",
        "Critical": "انتہائی سنگین",
        "Serious": "سنگین",
        "Moderate": "درمیانہ",
        "Minor": "معمولی",
        "Violations Found": "خلاف ورزیاں پائی گئیں",
        "No Issues Found": "کوئی مسئلہ نہیں ملا",
        "Element": "عنصر",
        "Issue": "مسئلہ",
        "How to Fix": "درست کرنے کا طریقہ",
        "Close Report": "رپورٹ بند کریں",
        "Passed Tests": "کامیاب ٹیسٹ",
        "Items Need Review": "جائزہ طلب اشیاء",
        "Annotations": "تشریحات",
        "Text to Speech": "متن سے تقریر",
        "Text to Speech On": "متن سے تقریر آن",
        "Text to Speech Off": "متن سے تقریر آف",
        "Simplify Layout": "خاکہ سادہ بنائیں",
        "Speech": "تقریر",
        "Text": "متن",
        "Color & Contrast": "رنگ اور کنٹراسٹ",
        "Reading Aids": "پڑھنے کی سہولیات",
        "Interaction": "تعامل",
        "Contrast": "کنٹراسٹ",
        "Saturation": "سیچوریشن",
        "Light": "روشن",
        "Dark": "گہرا",
        "High": "زیادہ",
        "Low": "کم",
        "Play": "چلائیں",
        "Pause": "توقف کریں",
        "Stop": "روکیں",
        "Loading voice...": "آواز لوڈ ہو رہی ہے...",
        "Reading...": "پڑھا جا رہا ہے...",
        "Profiles": "پروفائلز",
        "Seizure Safe": "دوروں سے محفوظ",
        "Vision Impaired": "کمزور بینائی",
        "ADHD Friendly": "ADHD دوستانہ",
        "Dyslexia Friendly": "ڈسلیکسیا دوستانہ",
        "On": "آن",
        "Off": "آف",
        "Mute Sounds": "آوازیں خاموش کریں",
        "Page Structure": "صفحے کی ساخت",
        "Text Magnifier": "متن میگنیفائر",
        "Headings": "سرخیاں",
        "Landmarks": "نشانات",
        "Links": "روابط",
        "No items found": "کوئی چیز نہیں ملی",
        "Settings reset": "ترتیبات بحال ہو گئیں",
      },
      vi: {
        "Accessibility": "Trợ năng",
        "Accessibility Options": "Tùy chọn trợ năng",
        "Accessibility Menu": "Menu trợ năng",
        "Reset settings": "Đặt lại cài đặt",
        "Reset All Settings": "Đặt lại tất cả các cài đặt",
        "Close": "Đóng",
        "Content Adjustments": "Điều chỉnh nội dung",
        "Adjust Font Size": "Điều chỉnh cỡ chữ",
        "Highlight Title": "Làm nổi bật tiêu đề",
        "Highlight Links": "Làm nổi bật liên kết",
        "Readable Font": "Phông chữ dễ đọc",
        "Color Adjustments": "Điều chỉnh màu sắc",
        "Invert Colors": "Đảo ngược màu",
        "Light Contrast": "Tương phản sáng",
        "Dark Contrast": "Tương phản tối",
        "High Contrast": "Tương phản cao",
        "High Saturation": "Độ bão hòa cao",
        "Low Saturation": "Độ bão hòa thấp",
        "Monochrome": "Đơn sắc",
        "Tools": "Công cụ",
        "Reading Guide": "Thước đọc",
        "Stop Animations": "Dừng hoạt ảnh",
        "Big Cursor": "Con trỏ lớn",
        "Increase Font Size": "Tăng cỡ chữ",
        "Decrease Font Size": "Giảm cỡ chữ",
        "Letter Spacing": "Khoảng cách ký tự",
        "Line Height": "Khoảng cách dòng",
        "Font Weight": "Độ đậm chữ",
        "Dyslexia Font": "Phông chữ cho chứng khó đọc",
        "Legible Font": "Phông chữ rõ ràng",
        "Font Size": "Cỡ chữ",
        "Language": "Ngôn ngữ",
        "All Languages": "Tất cả các ngôn ngữ",
        "Search language": "Tìm ngôn ngữ",
        "Open Accessibility Menu": "Mở menu trợ năng",
        "Open accessibility menu": "Mở menu trợ năng",
        "Hide Images": "Ẩn hình ảnh",
        "Skip to accessibility menu": "Chuyển đến menu trợ năng",
        "Accessibility Report": "Báo cáo trợ năng",
        "Run Accessibility Check": "Chạy kiểm tra trợ năng",
        "Loading...": "Đang tải...",
        "Analyzing page...": "Đang phân tích trang...",
        "Critical": "Nghiêm trọng",
        "Serious": "Nặng",
        "Moderate": "Trung bình",
        "Minor": "Nhẹ",
        "Violations Found": "Đã tìm thấy vi phạm",
        "No Issues Found": "Không tìm thấy vấn đề nào",
        "Element": "Phần tử",
        "Issue": "Vấn đề",
        "How to Fix": "Cách khắc phục",
        "Close Report": "Đóng báo cáo",
        "Passed Tests": "Kiểm tra đã đạt",
        "Items Need Review": "Mục cần xem xét",
        "Annotations": "Chú thích",
        "Text to Speech": "Đọc thành tiếng",
        "Text to Speech On": "Đã bật đọc thành tiếng",
        "Text to Speech Off": "Đã tắt đọc thành tiếng",
        "Simplify Layout": "Đơn giản hóa bố cục",
        "Speech": "Giọng nói",
        "Text": "Văn bản",
        "Color & Contrast": "Màu sắc & tương phản",
        "Reading Aids": "Hỗ trợ đọc",
        "Interaction": "Tương tác",
        "Contrast": "Độ tương phản",
        "Saturation": "Độ bão hòa",
        "Light": "Sáng",
        "Dark": "Tối",
        "High": "Cao",
        "Low": "Thấp",
        "Play": "Phát",
        "Pause": "Tạm dừng",
        "Stop": "Dừng",
        "Loading voice...": "Đang tải giọng nói...",
        "Reading...": "Đang đọc...",
        "Profiles": "Hồ sơ",
        "Seizure Safe": "An toàn cho người động kinh",
        "Vision Impaired": "Hỗ trợ khiếm thị",
        "ADHD Friendly": "Thân thiện với ADHD",
        "Dyslexia Friendly": "Thân thiện với chứng khó đọc",
        "On": "Bật",
        "Off": "Tắt",
        "Mute Sounds": "Tắt âm thanh",
        "Page Structure": "Cấu trúc trang",
        "Text Magnifier": "Kính lúp văn bản",
        "Headings": "Đề mục",
        "Landmarks": "Điểm mốc",
        "Links": "Liên kết",
        "No items found": "Không tìm thấy mục nào",
        "Settings reset": "Đã đặt lại cài đặt",
      },
      zh: {
        "Accessibility": "无障碍",
        "Accessibility Options": "无障碍选项",
        "Accessibility Menu": "无障碍菜单",
        "Reset settings": "重置设置",
        "Reset All Settings": "重置所有设置",
        "Close": "关闭",
        "Content Adjustments": "内容调整",
        "Adjust Font Size": "调整字号",
        "Highlight Title": "高亮标题",
        "Highlight Links": "高亮链接",
        "Readable Font": "易读字体",
        "Color Adjustments": "颜色调整",
        "Invert Colors": "反转颜色",
        "Light Contrast": "浅色对比度",
        "Dark Contrast": "深色对比度",
        "High Contrast": "高对比度",
        "High Saturation": "高饱和度",
        "Low Saturation": "低饱和度",
        "Monochrome": "单色",
        "Tools": "工具",
        "Reading Guide": "阅读辅助线",
        "Stop Animations": "停止动画",
        "Big Cursor": "大光标",
        "Increase Font Size": "增大字号",
        "Decrease Font Size": "减小字号",
        "Letter Spacing": "字间距",
        "Line Height": "行高",
        "Font Weight": "字体粗细",
        "Dyslexia Font": "阅读障碍字体",
        "Legible Font": "清晰字体",
        "Font Size": "字号",
        "Language": "语言",
        "All Languages": "所有语言",
        "Search language": "搜索语言",
        "Open Accessibility Menu": "打开无障碍菜单",
        "Open accessibility menu": "打开无障碍菜单",
        "Hide Images": "隐藏图片",
        "Skip to accessibility menu": "跳转到无障碍菜单",
        "Accessibility Report": "无障碍报告",
        "Run Accessibility Check": "运行无障碍检查",
        "Loading...": "加载中…",
        "Analyzing page...": "正在分析页面…",
        "Critical": "严重",
        "Serious": "较严重",
        "Moderate": "中等",
        "Minor": "轻微",
        "Violations Found": "发现的违规项",
        "No Issues Found": "未发现问题",
        "Element": "元素",
        "Issue": "问题",
        "How to Fix": "修复方法",
        "Close Report": "关闭报告",
        "Passed Tests": "通过的测试",
        "Items Need Review": "待审查项目",
        "Annotations": "标注",
        "Text to Speech": "文本转语音",
        "Text to Speech On": "文本转语音已开启",
        "Text to Speech Off": "文本转语音已关闭",
        "Simplify Layout": "简化布局",
        "Speech": "语音",
        "Text": "文本",
        "Color & Contrast": "颜色与对比度",
        "Reading Aids": "阅读辅助",
        "Interaction": "交互",
        "Contrast": "对比度",
        "Saturation": "饱和度",
        "Light": "浅色",
        "Dark": "深色",
        "High": "高",
        "Low": "低",
        "Play": "播放",
        "Pause": "暂停",
        "Stop": "停止",
        "Loading voice...": "正在加载语音…",
        "Reading...": "朗读中…",
        "Profiles": "无障碍模式",
        "Seizure Safe": "癫痫安全",
        "Vision Impaired": "视力障碍",
        "ADHD Friendly": "ADHD 友好",
        "Dyslexia Friendly": "阅读障碍友好",
        "On": "开",
        "Off": "关",
        "Mute Sounds": "静音",
        "Page Structure": "页面结构",
        "Text Magnifier": "文本放大镜",
        "Headings": "标题",
        "Landmarks": "地标",
        "Links": "链接",
        "No items found": "未找到任何项目",
        "Settings reset": "设置已重置",
      },
      "zh-TW": {
        "Accessibility": "無障礙",
        "Accessibility Options": "無障礙選項",
        "Accessibility Menu": "無障礙選單",
        "Reset settings": "重設設定",
        "Reset All Settings": "重設所有設定",
        "Close": "關閉",
        "Content Adjustments": "內容調整",
        "Adjust Font Size": "調整文字大小",
        "Highlight Title": "突顯標題",
        "Highlight Links": "突顯連結",
        "Readable Font": "易讀字型",
        "Color Adjustments": "色彩調整",
        "Invert Colors": "反轉色彩",
        "Light Contrast": "淺色對比",
        "Dark Contrast": "深色對比",
        "High Contrast": "高對比",
        "High Saturation": "高飽和度",
        "Low Saturation": "低飽和度",
        "Monochrome": "單色",
        "Tools": "工具",
        "Reading Guide": "閱讀導引線",
        "Stop Animations": "停止動畫",
        "Big Cursor": "大型游標",
        "Increase Font Size": "放大文字",
        "Decrease Font Size": "縮小文字",
        "Letter Spacing": "字元間距",
        "Line Height": "行高",
        "Font Weight": "字型粗細",
        "Dyslexia Font": "讀寫障礙字型",
        "Legible Font": "清晰字型",
        "Font Size": "文字大小",
        "Language": "語言",
        "All Languages": "所有語言",
        "Search language": "搜尋語言",
        "Open Accessibility Menu": "開啟無障礙選單",
        "Open accessibility menu": "開啟無障礙選單",
        "Hide Images": "隱藏圖片",
        "Skip to accessibility menu": "跳至無障礙選單",
        "Accessibility Report": "無障礙報告",
        "Run Accessibility Check": "執行無障礙檢查",
        "Loading...": "載入中…",
        "Analyzing page...": "正在分析頁面…",
        "Critical": "危急",
        "Serious": "嚴重",
        "Moderate": "中度",
        "Minor": "輕微",
        "Violations Found": "發現違規項目",
        "No Issues Found": "未發現問題",
        "Element": "元素",
        "Issue": "問題",
        "How to Fix": "修正方式",
        "Close Report": "關閉報告",
        "Passed Tests": "通過的測試",
        "Items Need Review": "待檢視項目",
        "Annotations": "標註",
        "Text to Speech": "文字轉語音",
        "Text to Speech On": "文字轉語音已開啟",
        "Text to Speech Off": "文字轉語音已關閉",
        "Simplify Layout": "簡化版面",
        "Speech": "語音",
        "Text": "文字",
        "Color & Contrast": "色彩與對比",
        "Reading Aids": "閱讀輔助",
        "Interaction": "互動",
        "Contrast": "對比",
        "Saturation": "飽和度",
        "Light": "淺色",
        "Dark": "深色",
        "High": "高",
        "Low": "低",
        "Play": "播放",
        "Pause": "暫停",
        "Stop": "停止",
        "Loading voice...": "正在載入語音…",
        "Reading...": "朗讀中…",
        "Profiles": "設定檔",
        "Seizure Safe": "癲癇安全",
        "Vision Impaired": "視覺障礙",
        "ADHD Friendly": "過動症友善",
        "Dyslexia Friendly": "讀寫障礙友善",
        "On": "開啟",
        "Off": "關閉",
        "Mute Sounds": "靜音",
        "Page Structure": "頁面結構",
        "Text Magnifier": "文字放大鏡",
        "Headings": "標題",
        "Landmarks": "地標",
        "Links": "連結",
        "No items found": "找不到項目",
        "Settings reset": "設定已重設",
      }
    };

// Keep a deliberate English fallback for alignment labels in dictionaries
// that have not been localized yet, while shipping the Spanish labels
// requested in issue #21. This is scoped to these four labels so the existing
// completeness test still exposes unrelated translation gaps.
const TEXT_ALIGNMENT_TRANSLATIONS = {
      en: {
        "Text Alignment": "Text Alignment",
        "Start": "Start",
        "Center": "Center",
        "End": "End",
      },
      es: {
        "Text Alignment": "Alineación del texto",
        "Start": "Inicio",
        "Center": "Centro",
        "End": "Final",
      }
    };

Object.entries(TRANSLATIONS).forEach(([code, dictionary]) => {
      Object.assign(dictionary, TEXT_ALIGNMENT_TRANSLATIONS[code] || TEXT_ALIGNMENT_TRANSLATIONS.en);
    });

export const SUPPORTED_LANGUAGES = [
      { code: "en", label: "English (English)" },
      { code: "pt", label: "Português (Portuguese)" },
      { code: "it", label: "Italiano (Italian)" },
      { code: "fr", label: "Français (French)" },
      { code: "de", label: "Deutsch (German)" },
      { code: "es", label: "Español (Spanish)" },
      { code: "ru", label: "Русский (Russian)" },
      { code: "pl", label: "Polski (Polish)" },
      { code: "ro", label: "Română (Romanian)" },
      { code: "nl", label: "Nederlands (Dutch)" },
      { code: "uk", label: "Українська (Ukrainian)" },
      { code: "ar", label: "العربية (Arabic)" },
      { code: "he", label: "עברית (Hebrew)" },
      { code: "sv", label: "Svenska (Swedish)" },
      { code: "da", label: "Dansk (Danish)" },
      { code: "ca", label: "Català (Catalan)" },
      { code: "sl", label: "Slovenščina (Slovenian)" },
      { code: "lv", label: "Latviešu (Latvian)" },
      { code: "el", label: "Ελληνικά (Greek)" },
      { code: "ka", label: "ქართული (Georgian)" },
      { code: "am", label: "አማርኛ (Amharic)" },
      { code: "bg", label: "Български (Bulgarian)" },
      { code: "bn", label: "বাংলা (Bengali)" },
      { code: "cs", label: "Čeština (Czech)" },
      { code: "fa", label: "فارسی (Persian)" },
      { code: "fi", label: "Suomi (Finnish)" },
      { code: "fil", label: "Filipino (Filipino)" },
      { code: "hi", label: "हिन्दी (Hindi)" },
      { code: "hr", label: "Hrvatski (Croatian)" },
      { code: "hu", label: "Magyar (Hungarian)" },
      { code: "id", label: "Bahasa Indonesia (Indonesian)" },
      { code: "ja", label: "日本語 (Japanese)" },
      { code: "kn", label: "ಕನ್ನಡ (Kannada)" },
      { code: "ko", label: "한국어 (Korean)" },
      { code: "ku", label: "Kurdî (Kurmancî) (Kurdish)" },
      { code: "lb", label: "Lëtzebuergesch (Luxembourgish)" },
      { code: "ml", label: "മലയാളം (Malayalam)" },
      { code: "mn", label: "Монгол (Mongolian)" },
      { code: "ms", label: "Bahasa Melayu (Malay)" },
      { code: "my", label: "မြန်မာ (Burmese)" },
      { code: "no", label: "Norsk bokmål (Norwegian)" },
      { code: "pa", label: "ਪੰਜਾਬੀ (Punjabi)" },
      { code: "si", label: "සිංහල (Sinhala)" },
      { code: "sk", label: "Slovenčina (Slovak)" },
      { code: "sr", label: "Српски (Serbian)" },
      { code: "sw", label: "Kiswahili (Swahili)" },
      { code: "ta", label: "தமிழ் (Tamil)" },
      { code: "te", label: "తెలుగు (Telugu)" },
      { code: "th", label: "ไทย (Thai)" },
      { code: "tr", label: "Türkçe (Turkish)" },
      { code: "ur", label: "اردو (Urdu)" },
      { code: "vi", label: "Tiếng Việt (Vietnamese)" },
      { code: "zh", label: "简体中文 (Chinese (Simplified))" },
      { code: "zh-TW", label: "繁體中文 (Chinese (Traditional))" }
    ];
